import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  isNaNymqb93xtq8w8 as isNaN_0,
  to2cs3ny02qtbcb as to,
  Enum3alwj03lh1n41 as Enum,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  lazy2hsh8ze7j6ikd as lazy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  toList383f556t1dixk as toList,
  Duration5ynfiptaqcrg as Duration,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  numberToDouble210hrknaofnhf as numberToDouble,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspendednggonvg9333x as returnIfSuspended,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  Comparator2b3maoeh98xtg as Comparator,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  contains1tccixv8iwdcq as contains,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Duration__times_impl_sfuzvp1gzave8ckyu1a as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  createFailure8paxfkfa5dc7 as createFailure,
  HashMap1a0ld5kgwhmhv as HashMap,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  replace3le3ie7l9k8aq as replace,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_WARN_getInstance2cg04z8rod8ga as Level_WARN_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Companion_getInstancet6d3dkp9rzuf as Companion_getInstance_1,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
  Signal3nnez3346azzf as Signal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope1245ljoj2flcu as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance2expa55gr45sc as Key_instance,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout2wixyx2dhn9kz as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  completeWith2hvdlbg1q1mlx as completeWith,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readBitmapdk80pcjw6p8f as readBitmap,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_2,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance1905h5dvjxi3r as EmptyShape_instance,
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  readFont34z4s2654u5hd as readFont,
  HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j as VerticalAlign__getOffsetY_impl_iso0y6,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_3,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  BitmapFont35unsvaxq1brd as BitmapFont,
  Font2bg7nte760csr as Font,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke,
  LineInfo27uw564y6w2d2 as LineInfo,
  _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk as _HorizontalAlign___get_ratio__impl__x9wlea,
  _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance2w9pdpq8h2ue0 as Companion_getInstance_4,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqtysv8goadjy9q as _RGBA___get_rgb__impl__tijaqt,
  Companion_getInstance3488ghvvugrnp as Companion_getInstance_5,
  _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5 as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3gshkh79a96f7 as Companion_instance_0,
  Companion_instance293l0r179rei7 as Companion_instance_1,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_6,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  get_fast37cu8s8qwnuyi as get_fast,
  FastDuration__times_impl_h6amcp3u6kv4tju4mnx as FastDuration__times_impl_h6amcp,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  FastDuration__div_impl_rlslck3eqcfgtjve915 as FastDuration__div_impl_rlslck,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_slowaqovrrnrezzv as get_slow,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds_0,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2moqkr2wlhp55 as FastDuration__div_impl_rlslck_0,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
  toDuration15w5sljvx2ut2 as toDuration_0,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injectorznx5rgygah7n as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance1dp345vz250gb as Companion_getInstance_7,
  DefaultViewport_getInstance3ta8638tkh0q1 as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2edcjnp9auwx5 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1jsrcs9uzp4z9 as KorgeReload_getInstance,
  configureLoggerFromProperties2zy8apzr93pqp as configureLoggerFromProperties,
  CoroutineKey_getInstance2jikmq30sknr8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance104tc4m897tyy as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstance27oonvh9zpi1o as Type_START_getInstance,
  Status_ADD_getInstance22apyg5ct4px7 as Status_ADD_getInstance,
  Type_END_getInstance3ekhp9k4xqwsb as Type_END_getInstance,
  Status_REMOVE_getInstance19drpw6lfvon8 as Status_REMOVE_getInstance,
  Type_MOVE_getInstanceavavmobr5nzz as Type_MOVE_getInstance,
  Status_KEEP_getInstance3tj4183qdgyi5 as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2pxjdxrpl68c5 as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance1oyczma3u1sfi as Type_DRAG_getInstance,
  Type_UP_getInstance1azeslmnft6l5 as Type_UP_getInstance,
  Type_DOWN_getInstance1zas01g4tazis as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstancekjblelnta22u as Companion_getInstance_8,
  Companion_getInstance1wltq3fgn1avz as Companion_getInstance_9,
  Companion_getInstance2ckr5i14ndxro as Companion_getInstance_10,
  Companion_getInstance18y91gyxi2z7 as Companion_getInstance_11,
  Companion_instance3i2v9jzzqvdkl as Companion_instance_2,
  Companion_instance2ovjg7lp6gfg7 as Companion_instance_3,
  Companion_instancef7estul0zruo as Companion_instance_4,
  Companion_instance99w5lpdgjzr4 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance6ryfwvwg9trm as Companion_getInstance_12,
  Companion_getInstanceok0yphc67vv6 as Companion_getInstance_13,
  Companion_instancekcgdgz2aik3h as Companion_instance_6,
  Companion_instance12t49ingjwxzt as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance7uo85wjiqj61 as Companion_instance_8,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Type_TYPE_getInstance3kl3gtiytkq1p as Type_TYPE_getInstance,
  Type_DOWN_getInstance3w3upujzs6x5 as Type_DOWN_getInstance_0,
  Type_UP_getInstance2onpl7vaj0n6f as Type_UP_getInstance_0,
  Cursor_DEFAULT_getInstancemdqrzfwu4c9e as Cursor_DEFAULT_getInstance,
  Companion_getInstance1ifu77pbb1si2 as Companion_getInstance_14,
  drawText2ld6eqw3mc9xd as drawText,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  SDFShaders_getInstance2aqc6fv2u457r as SDFShaders_getInstance,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  Companion_instanceyamrbth4pjfq as Companion_instance_9,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance23l94gq35u9ye as Companion_getInstance_15,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance2c14wyrj73xek as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_16,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  readColor21xoh99px3uyk as readColor,
  debugBmpFont2i7i2ml66o1iy as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance20smmrbslhgku as Key_F12_getInstance,
  Key_F7_getInstance1fxfgbmldwoq6 as Key_F7_getInstance,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  Texture2obedkmljq67n as Texture_0,
  Companion_getInstanceae40js4gnuwg as Companion_getInstance_17,
  Companion_getInstance2cx7brx0y6bm1 as Companion_getInstance_18,
  Companion_getInstance3dym1csqm206y as Companion_getInstance_19,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus,
  _AGColorMask___init__impl__j38ai819ejt5rq8iy6o as _AGColorMask___init__impl__j38ai8,
  Companion_getInstancei2plsq4vst79 as Companion_getInstance_20,
  AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4 as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3 as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance203qp9xyfv543 as Companion_getInstance_21,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42 as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance14dcva8uz4sb6 as Companion_getInstance_22,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0 as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai828hvpfxybxjk7 as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstance29a9zmyrrw3c9 as Companion_getInstance_23,
  AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891w3d9dwll45l9u7 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2 as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082fge542b8j3bn5 as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufx32vlakxm4newn as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5urey2md6modztx as AGCullFace__hashCode_impl_t4e5ur,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  DefaultShaders_getInstance2nkm3g7twu3qg as DefaultShaders_getInstance,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance321ftm11bbyai as VarType_Float2_getInstance,
  If1av5krmfyt44s as If,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance1fp6gxp2vmo7y as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstancewn61okav7bh4 as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  VertexShader26kcg39ndf3s1 as VertexShader,
  Program1hnygp9hph4ry as Program,
  Companion_instance31en7fj48z7ti as Companion_instance_10,
  Companion_getInstance31h96uhdj5cc as Companion_getInstance_24,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance23o88a0u6ly94 as Companion_getInstance_25,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_26,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_27,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_28,
  Rectangle3q03woyn9k8x1 as Rectangle,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_29,
  Scale2cm697xlulcp5 as Scale,
  Circle1sk1qi5ph1m23 as Circle,
  Companion_getInstance2yu48324co92b as Companion_getInstance_30,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_31,
  RoundRectangle271svjyf7w51p as RoundRectangle,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_32,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_33,
  BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl as BoundsBuilder__plus_impl_cz7f7x_0,
  _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa as _BoundsBuilder___get_xmax__impl__gsz0km,
  _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r as _BoundsBuilder___get_ymax__impl__oia4uz,
  _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5 as _BoundsBuilder___get_ymin__impl__5n2e8j,
  MarginInt3jiec8xsxkfd as MarginInt,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_34,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_35,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampdicp8njiht45 as clamp,
  clamp1qclpmpfxm7xb as clamp_0,
  toRatio1hooqit5gulhr as toRatio,
  toLongRound7crzegvo2qbo as toLongRound,
  toIntCeil3h286vm49zgwd as toIntCeil,
  clamp31lhm66c28ic8 as clamp_1,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange,
  convertRange1a6ancvyn151r as convertRange_0,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_immutablepxpdoj6e54ll as get_immutable,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  toShape2D2vgft60vvvqgq as toShape2D,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  MMatrix1y71lv7vv6y8t as MMatrix,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  HitTestDirection_ANY_getInstance1hlnrhgqmsigf as HitTestDirection_ANY_getInstance,
  get_mutable10c8ws0x48eez as get_mutable,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838 as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance2mlqkio15xcm4 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_36,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  cancel1n0qjc93h2v6w as cancel_0,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1 as _Frequency___get_hertz__impl__9m7k6x,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance20wy3vp7551rj as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ibbocika451b as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance2nobhthyyb9yj as Companion_instance_13,
  Dyn__set_impl_2ozvx82bmztjcahblz8 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  getExtra307y0o9pd6mp3 as getExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  Pool1zbsw0zhvh8ca as Pool,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.y9t_1 = Companion_getInstance_0().iz('Korge');
    this.z9t_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  a9u(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  ge(p1, $completion) {
    return this.a9u(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.m9s_1 = this$0;
    this.n9s_1 = $entry;
  }
  a1r($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_37();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_37().z9t_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_7().f8l_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().r8i_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_38().v3v() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().z44_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().y44_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.o9s_1 = args;
    this.p9s_1 = imageFormats;
    this.q9s_1 = gameWindow;
    this.r9s_1 = mainSceneClass;
    this.s9s_1 = timeProvider;
    this.t9s_1 = injector;
    this.u9s_1 = configInjector;
    this.v9s_1 = debug;
    this.w9s_1 = trace;
    this.x9s_1 = context;
    this.y9s_1 = fullscreen;
    this.z9s_1 = blocking;
    this.a9t_1 = gameId;
    this.b9t_1 = settingsFolder;
    this.c9t_1 = batchMaxQuads;
    this.d9t_1 = windowSize;
    this.e9t_1 = virtualSize;
    this.f9t_1 = displayMode;
    this.g9t_1 = title;
    this.h9t_1 = backgroundColor;
    this.i9t_1 = quality;
    this.j9t_1 = icon;
    this.k9t_1 = multithreaded;
    this.l9t_1 = forceRenderEveryFrame;
    this.m9t_1 = windowCreationConfig;
    this.n9t_1 = main;
    this.o9t_1 = debugAg;
    this.p9t_1 = debugFontExtraScale;
    this.q9t_1 = debugFontColor;
    this.r9t_1 = stageBuilder;
    this.s9t_1 = targetFps;
    this.t9t_1 = preferSyncIo;
    this.u9t_1 = debugCoroutines;
    this.v9t_1 = unit;
  }
  v9w(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this, entry), $completion);
  }
  w9w(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  w9t(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.o9s_1 : args;
    imageFormats = imageFormats === VOID ? this.p9s_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.q9s_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.r9s_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.s9s_1 : timeProvider;
    injector = injector === VOID ? this.t9s_1 : injector;
    configInjector = configInjector === VOID ? this.u9s_1 : configInjector;
    debug = debug === VOID ? this.v9s_1 : debug;
    trace = trace === VOID ? this.w9s_1 : trace;
    context = context === VOID ? this.x9s_1 : context;
    fullscreen = fullscreen === VOID ? this.y9s_1 : fullscreen;
    blocking = blocking === VOID ? this.z9s_1 : blocking;
    gameId = gameId === VOID ? this.a9t_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.b9t_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.c9t_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.d9t_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.e9t_1 : virtualSize;
    displayMode = displayMode === VOID ? this.f9t_1 : displayMode;
    title = title === VOID ? this.g9t_1 : title;
    backgroundColor = backgroundColor === VOID ? this.h9t_1 : backgroundColor;
    quality = quality === VOID ? this.i9t_1 : quality;
    icon = icon === VOID ? this.j9t_1 : icon;
    multithreaded = multithreaded === VOID ? this.k9t_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.l9t_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.m9t_1 : windowCreationConfig;
    main = main === VOID ? this.n9t_1 : main;
    debugAg = debugAg === VOID ? this.o9t_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.p9t_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.q9t_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.r9t_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.s9t_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.t9t_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.u9t_1 : debugCoroutines;
    unit = unit === VOID ? this.v9t_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.w9w(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.w9w;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.o9s_1);
    var tmp_0 = this.p9s_1.toString();
    var tmp_1 = toString_0(this.q9s_1);
    var tmp_2 = toString_0(this.r9s_1);
    var tmp_3 = toString(this.s9s_1);
    var tmp_4 = this.t9s_1.toString();
    var tmp_5 = toString(this.u9s_1);
    var tmp_6 = toString_0(this.x9s_1);
    var tmp_7 = this.d9t_1.toString();
    var tmp_8 = this.e9t_1.toString();
    var tmp_9 = this.f9t_1.toString();
    var tmp_10 = this.h9t_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.v9s_1 + ', trace=' + this.w9s_1 + ', context=' + tmp_6 + ', fullscreen=' + this.y9s_1 + ', blocking=' + this.z9s_1 + ', gameId=' + this.a9t_1 + ', settingsFolder=' + this.b9t_1 + ', batchMaxQuads=' + this.c9t_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.g9t_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.i9t_1) + ', icon=' + this.j9t_1 + ', multithreaded=' + this.k9t_1 + ', forceRenderEveryFrame=' + this.l9t_1 + ', windowCreationConfig=' + this.m9t_1.toString() + ', main=' + toString(this.n9t_1) + ', debugAg=' + this.o9t_1 + ', debugFontExtraScale=' + this.p9t_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.q9t_1) + ', stageBuilder=' + toString(this.r9t_1) + ', targetFps=' + this.s9t_1 + ', preferSyncIo=' + this.t9t_1 + ', debugCoroutines=' + this.u9t_1 + ', unit=' + this.v9t_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.o9s_1);
    result = imul(result, 31) + hashCode(this.p9s_1) | 0;
    result = imul(result, 31) + (this.q9s_1 == null ? 0 : hashCode(this.q9s_1)) | 0;
    result = imul(result, 31) + (this.r9s_1 == null ? 0 : this.r9s_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.s9s_1) | 0;
    result = imul(result, 31) + hashCode(this.t9s_1) | 0;
    result = imul(result, 31) + hashCode(this.u9s_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v9s_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w9s_1) | 0;
    result = imul(result, 31) + (this.x9s_1 == null ? 0 : hashCode(this.x9s_1)) | 0;
    result = imul(result, 31) + (this.y9s_1 == null ? 0 : getBooleanHashCode(this.y9s_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z9s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a9t_1) | 0;
    result = imul(result, 31) + (this.b9t_1 == null ? 0 : getStringHashCode(this.b9t_1)) | 0;
    result = imul(result, 31) + this.c9t_1 | 0;
    result = imul(result, 31) + this.d9t_1.hashCode() | 0;
    result = imul(result, 31) + this.e9t_1.hashCode() | 0;
    result = imul(result, 31) + this.f9t_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.g9t_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.h9t_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.h9t_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.i9t_1.hashCode() | 0;
    result = imul(result, 31) + (this.j9t_1 == null ? 0 : getStringHashCode(this.j9t_1)) | 0;
    result = imul(result, 31) + (this.k9t_1 == null ? 0 : getBooleanHashCode(this.k9t_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l9t_1) | 0;
    result = imul(result, 31) + this.m9t_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.n9t_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o9t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p9t_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.q9t_1) | 0;
    result = imul(result, 31) + hashCode(this.r9t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s9t_1) | 0;
    result = imul(result, 31) + (this.t9t_1 == null ? 0 : getBooleanHashCode(this.t9t_1)) | 0;
    result = imul(result, 31) + (this.u9t_1 == null ? 0 : getBooleanHashCode(this.u9t_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.o9s_1, tmp0_other_with_cast.o9s_1))
      return false;
    if (!equals(this.p9s_1, tmp0_other_with_cast.p9s_1))
      return false;
    if (!equals(this.q9s_1, tmp0_other_with_cast.q9s_1))
      return false;
    if (!equals(this.r9s_1, tmp0_other_with_cast.r9s_1))
      return false;
    if (!equals(this.s9s_1, tmp0_other_with_cast.s9s_1))
      return false;
    if (!equals(this.t9s_1, tmp0_other_with_cast.t9s_1))
      return false;
    if (!equals(this.u9s_1, tmp0_other_with_cast.u9s_1))
      return false;
    if (!(this.v9s_1 === tmp0_other_with_cast.v9s_1))
      return false;
    if (!(this.w9s_1 === tmp0_other_with_cast.w9s_1))
      return false;
    if (!equals(this.x9s_1, tmp0_other_with_cast.x9s_1))
      return false;
    if (!(this.y9s_1 == tmp0_other_with_cast.y9s_1))
      return false;
    if (!(this.z9s_1 === tmp0_other_with_cast.z9s_1))
      return false;
    if (!(this.a9t_1 === tmp0_other_with_cast.a9t_1))
      return false;
    if (!(this.b9t_1 == tmp0_other_with_cast.b9t_1))
      return false;
    if (!(this.c9t_1 === tmp0_other_with_cast.c9t_1))
      return false;
    if (!this.d9t_1.equals(tmp0_other_with_cast.d9t_1))
      return false;
    if (!this.e9t_1.equals(tmp0_other_with_cast.e9t_1))
      return false;
    if (!this.f9t_1.equals(tmp0_other_with_cast.f9t_1))
      return false;
    if (!(this.g9t_1 === tmp0_other_with_cast.g9t_1))
      return false;
    var tmp = this.h9t_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.h9t_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.i9t_1.equals(tmp0_other_with_cast.i9t_1))
      return false;
    if (!(this.j9t_1 == tmp0_other_with_cast.j9t_1))
      return false;
    if (!(this.k9t_1 == tmp0_other_with_cast.k9t_1))
      return false;
    if (!(this.l9t_1 === tmp0_other_with_cast.l9t_1))
      return false;
    if (!this.m9t_1.equals(tmp0_other_with_cast.m9t_1))
      return false;
    if (!equals(this.n9t_1, tmp0_other_with_cast.n9t_1))
      return false;
    if (!(this.o9t_1 === tmp0_other_with_cast.o9t_1))
      return false;
    if (!equals(this.p9t_1, tmp0_other_with_cast.p9t_1))
      return false;
    if (!(this.q9t_1 === tmp0_other_with_cast.q9t_1))
      return false;
    if (!equals(this.r9t_1, tmp0_other_with_cast.r9t_1))
      return false;
    if (!equals(this.s9t_1, tmp0_other_with_cast.s9t_1))
      return false;
    if (!(this.t9t_1 == tmp0_other_with_cast.t9t_1))
      return false;
    if (!(this.u9t_1 == tmp0_other_with_cast.u9t_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.r9w_1 = new KorgeDisplayMode(Companion_getInstance_25().q2n_1, Companion_getInstance_26().u2c(), true);
    this.s9w_1 = new KorgeDisplayMode(Companion_getInstance_25().q2n_1, Companion_getInstance_26().u2c(), false);
    this.t9w_1 = new KorgeDisplayMode(Companion_getInstance_25().q2n_1, Companion_getInstance_26().i2c_1, false);
    this.u9w_1 = new KorgeDisplayMode(Companion_getInstance_25().s2n_1, Companion_getInstance_26().i2c_1, false);
  }
  v3v() {
    return this.r9w_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_38();
    this.x9w_1 = scaleMode;
    this.y9w_1 = scaleAnchor;
    this.z9w_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.x9w_1.toString() + ', scaleAnchor=' + this.y9w_1.toString() + ', clipBorders=' + this.z9w_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x9w_1);
    result = imul(result, 31) + this.y9w_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z9w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.x9w_1, tmp0_other_with_cast.x9w_1))
      return false;
    if (!this.y9w_1.equals(tmp0_other_with_cast.y9w_1))
      return false;
    if (!(this.z9w_1 === tmp0_other_with_cast.z9w_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.o9z_1 = $config;
    this.p9z_1 = $views;
    this.q9z_1 = $entry;
    this.r9z_1 = $gameWindow;
  }
  a1r($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.ua4_1 = $config;
    this.va4_1 = $views;
    this.wa4_1 = $entry;
    this.xa4_1 = $gameWindow;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.ya4_1 = $realGameWindow;
    this.za4_1 = $windowSize;
    this.aa5_1 = $config;
    this.ba5_1 = $iconPath;
    this.ca5_1 = $imageFormats;
    this.da5_1 = $entry;
  }
  la5($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$loop), $completion);
  }
  ge(p1, $completion) {
    return this.la5(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.ma5_1 = $views;
  }
  fe($completion) {
    this.ma5_1.t6();
  }
}
class KorgeRunner {
  x9t(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, config), $completion);
  }
  ha5(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.h9x_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.a6i(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.g9x_1;
    injector.a6i(getKClass(AG), instance);
    injector.a6i(getKClass(Resources), views.oa5());
    var tmp = getKClass(ResourcesRoot);
    injector.d6i(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.i9x_1;
    injector.a6i(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.k9x_1;
    injector.a6i(getKClass(Stats), instance_1);
    injector.a6i(getKClass(CoroutineContext), views.f9x_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.e6i(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.a6i(getKClass(TimeProvider), views.j9x_1);
    configInjector(injector);
    var input = views.i9x_1;
    var ag = views.g9x_1;
    var downPos = {_v: Companion_getInstance_28().j2d_1};
    var upPos = {_v: Companion_getInstance_28().j2d_1};
    var downTime = {_v: new DateTime(Companion_getInstance_6().e1y_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_6().e1y_1)};
    var upTime = Companion_getInstance_6().e1y_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.pa5(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_8().o6n_1.slice();
    eventDispatcher.x6l(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_9().a6n_1.slice();
    eventDispatcher.x6l(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_10().p6o_1.slice();
    eventDispatcher.x6l(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_11().w6o_1.slice();
    eventDispatcher.x6l(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.l6l(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.l6l(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.l6l(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.l6l(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_12().r6p_1.slice();
    eventDispatcher.x6l(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_13().w6r_1.slice();
    eventDispatcher.x6l(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.l6l(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.l6l(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.w6l(new ReshapeEvent(0, 0, views.qa5(), views.ra5()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.l6l(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.f9y_1 = clearEachFrame;
    views.g9y_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.l9x_1.s8w(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  a9u(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  ge(p1, $completion) {
    return this.a9u(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  a9u(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  ge(p1, $completion) {
    return this.a9u(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$down$slambda {
  constructor($callback) {
    this.sa5_1 = $callback;
  }
  fa6(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, it), $completion);
  }
  ge(p1, $completion) {
    return this.fa6(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.za5_1 = this$0;
    this.aa6_1 = $event;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.ba6_1 = this$0;
    this.ca6_1 = $event;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.da6_1 = this$0;
    this.ea6_1 = $event;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.ta5_1 = view;
    this.va5_1 = new AsyncSignal();
    this.wa5_1 = new AsyncSignal();
    this.xa5_1 = new AsyncSignal();
    this.ya5_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.ta5_1.l6l(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.ta5_1.l6l(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.ta5_1.l6l(tmp_1, KeysEvents$lambda_1(this));
  }
  ga6() {
    var tmp = this.ua5_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  ha6(callback) {
    return this.va5_1.c23(KeysEvents$down$slambda_0(callback));
  }
  t6() {
    this.ya5_1.t6();
  }
}
class MouseDragInfo {
  constructor(view, dx, dy, start, end, startTime, time, sx, sy, cx, cy) {
    dx = dx === VOID ? 0.0 : dx;
    dy = dy === VOID ? 0.0 : dy;
    start = start === VOID ? false : start;
    end = end === VOID ? false : end;
    startTime = startTime === VOID ? Companion_getInstance_6().e1y_1 : startTime;
    time = time === VOID ? Companion_getInstance_6().e1y_1 : time;
    sx = sx === VOID ? 0.0 : sx;
    sy = sy === VOID ? 0.0 : sy;
    cx = cx === VOID ? 0.0 : cx;
    cy = cy === VOID ? 0.0 : cy;
    this.ia6_1 = view;
    this.ja6_1 = dx;
    this.ka6_1 = dy;
    this.la6_1 = start;
    this.ma6_1 = end;
    this.na6_1 = startTime;
    this.oa6_1 = time;
    this.pa6_1 = sx;
    this.qa6_1 = sy;
    this.ra6_1 = cx;
    this.sa6_1 = cy;
    this.ua6_1 = NaN;
    this.va6_1 = NaN;
    this.wa6_1 = 0.0;
    this.xa6_1 = 0.0;
  }
  toString() {
    return 'MouseDragInfo(start=' + this.la6_1 + ', end=' + this.ma6_1 + ', sx=' + this.pa6_1 + ', sy=' + this.qa6_1 + ', cx=' + this.ra6_1 + ', cy=' + this.sa6_1 + ')';
  }
  j2y() {
    this.ua6_1 = NaN;
    this.va6_1 = NaN;
    this.wa6_1 = 0.0;
    this.xa6_1 = 0.0;
    this.ja6_1 = 0.0;
    this.ka6_1 = 0.0;
    this.pa6_1 = 0.0;
    this.qa6_1 = 0.0;
    this.ra6_1 = 0.0;
    this.sa6_1 = 0.0;
  }
  ya6(dx, dy, start, end, time, sx, sy, cx, cy) {
    this.ja6_1 = dx;
    this.ka6_1 = dy;
    this.pa6_1 = sx;
    this.qa6_1 = sy;
    this.ra6_1 = cx;
    this.sa6_1 = cy;
    if (!isNaN_0(this.ua6_1) && !isNaN_0(this.va6_1)) {
      this.wa6_1 = this.ua6_1 - dx;
      this.xa6_1 = this.va6_1 - dy;
    }
    this.ua6_1 = dx;
    this.va6_1 = dy;
    this.la6_1 = start;
    this.ma6_1 = end;
    if (start)
      this.na6_1 = time;
    this.oa6_1 = time;
    return this;
  }
}
class OnMouseDragCloseable {
  constructor(onDownCloseable, onUpAnywhereCloseable, onMoveAnywhereCloseable) {
    this.za6_1 = onDownCloseable;
    this.aa7_1 = onUpAnywhereCloseable;
    this.ba7_1 = onMoveAnywhereCloseable;
  }
  t6() {
    this.za6_1.t6();
    this.aa7_1.t6();
    this.ba7_1.t6();
  }
  toString() {
    return 'OnMouseDragCloseable(onDownCloseable=' + toString(this.za6_1) + ', onUpAnywhereCloseable=' + toString(this.aa7_1) + ', onMoveAnywhereCloseable=' + toString(this.ba7_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.za6_1);
    result = imul(result, 31) + hashCode(this.aa7_1) | 0;
    result = imul(result, 31) + hashCode(this.ba7_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OnMouseDragCloseable))
      return false;
    var tmp0_other_with_cast = other instanceof OnMouseDragCloseable ? other : THROW_CCE();
    if (!equals(this.za6_1, tmp0_other_with_cast.za6_1))
      return false;
    if (!equals(this.aa7_1, tmp0_other_with_cast.aa7_1))
      return false;
    if (!equals(this.ba7_1, tmp0_other_with_cast.ba7_1))
      return false;
    return true;
  }
}
class MouseDragState extends Enum {
  p6q() {
    return this.equals(MouseDragState_START_getInstance());
  }
  q6q() {
    return this.equals(MouseDragState_END_getInstance());
  }
}
class onMouseDragInternal$slambda {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.ha7_1 = $dragging;
    this.ia7_1 = $info;
    this.ja7_1 = $mousePos;
    this.ka7_1 = $sx;
    this.la7_1 = $sy;
    this.ma7_1 = $cx;
    this.na7_1 = $cy;
    this.oa7_1 = $callback;
    this.pa7_1 = $timeProvider;
    this.qa7_1 = $view;
  }
  ra7(it, $completion) {
    onMouseDragInternal$handle(this.ha7_1, this.ia7_1, this.ja7_1, this.ka7_1, this.la7_1, this.ma7_1, this.na7_1, this.oa7_1, this.pa7_1, this.qa7_1, it, MouseDragState_START_getInstance());
  }
  ge(p1, $completion) {
    return this.ra7(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda {
  constructor($handler, $it) {
    this.sa7_1 = $handler;
    this.ta7_1 = $it;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class onMouseDragInternal$slambda_0 {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.ka9_1 = $dragging;
    this.la9_1 = $info;
    this.ma9_1 = $mousePos;
    this.na9_1 = $sx;
    this.oa9_1 = $sy;
    this.pa9_1 = $cx;
    this.qa9_1 = $cy;
    this.ra9_1 = $callback;
    this.sa9_1 = $timeProvider;
    this.ta9_1 = $view;
  }
  ra7(it, $completion) {
    onMouseDragInternal$handle(this.ka9_1, this.la9_1, this.ma9_1, this.na9_1, this.oa9_1, this.pa9_1, this.qa9_1, this.ra9_1, this.sa9_1, this.ta9_1, it, MouseDragState_END_getInstance());
  }
  ge(p1, $completion) {
    return this.ra7(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda_0 {
  constructor($handler, $it) {
    this.ua9_1 = $handler;
    this.va9_1 = $it;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
  }
}
class onMouseDragInternal$slambda_1 {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.wa9_1 = $dragging;
    this.xa9_1 = $info;
    this.ya9_1 = $mousePos;
    this.za9_1 = $sx;
    this.aaa_1 = $sy;
    this.baa_1 = $cx;
    this.caa_1 = $cy;
    this.daa_1 = $callback;
    this.eaa_1 = $timeProvider;
    this.faa_1 = $view;
  }
  ra7(it, $completion) {
    onMouseDragInternal$handle(this.wa9_1, this.xa9_1, this.ya9_1, this.za9_1, this.aaa_1, this.baa_1, this.caa_1, this.daa_1, this.eaa_1, this.faa_1, it, MouseDragState_DRAG_getInstance());
  }
  ge(p1, $completion) {
    return this.ra7(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda_1 {
  constructor($handler, $it) {
    this.gaa_1 = $handler;
    this.haa_1 = $it;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class Companion_1 {
  oaa(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.c3d_1) {
      this_0.c3d_1 = true;
      // Inline function 'korlibs.korge.input.Companion.installDebugExtensionOnce.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = views.x9y_1;
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      this_1.h(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.raa_1 = $outer;
    this.paa_1 = new Mixin();
    this.qaa_1 = view;
    addUpdaterWithViews(this.qaa_1, MouseEvents$MouseEventsUpdate$lambda(this.raa_1));
  }
  r10(value) {
    this.paa_1.r10(value);
  }
  s10() {
    return this.paa_1.s10();
  }
}
class MouseEvents {
  constructor(view) {
    this.ua7_1 = new Mixin();
    this.va7_1 = view;
    this.va7_1.uaa(true);
    this.xa7_1 = new Signal();
    this.ya7_1 = new Signal();
    this.za7_1 = new Signal();
    this.aa8_1 = new Signal();
    this.ba8_1 = new Signal();
    this.ca8_1 = new Signal();
    this.da8_1 = new Signal();
    this.ea8_1 = new Signal();
    this.fa8_1 = new Signal();
    this.ga8_1 = new Signal();
    this.ha8_1 = new Signal();
    this.ia8_1 = new Signal();
    this.ja8_1 = new Signal();
    this.ka8_1 = new Signal();
    this.la8_1 = new Signal();
    this.ma8_1 = new Signal();
    this.na8_1 = new Signal();
    this.oa8_1 = new Signal();
    this.pa8_1 = new Signal();
    this.qa8_1 = null;
    this.ra8_1 = false;
    this.sa8_1 = false;
    this.ta8_1 = false;
    this.ua8_1 = PerformanceCounter_getInstance().k6j();
    this.va8_1 = PerformanceCounter_getInstance().k6j();
    this.wa8_1 = Vector2D.b2g();
    this.xa8_1 = Vector2D.b2g();
    this.ya8_1 = Vector2D.b2g();
    this.za8_1 = Vector2D.b2g();
    this.aa9_1 = Vector2D.b2g();
    this.ba9_1 = 0;
    this.ca9_1 = false;
    this.da9_1 = null;
    this.ea9_1 = new MouseEvent();
    this.fa9_1 = false;
    this.ga9_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_8().o6n_1.slice();
    tmp.ha9_1 = this.va7_1.x6l(tmp_0, MouseEvents$closeable$lambda(this));
    this.ia9_1 = new MouseEventsUpdate(this, this.va7_1);
  }
  fa7() {
    var tmp = this.wa7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  ja9() {
    return this.fa7().f9x_1;
  }
  vaa() {
    return this.va7_1.waa(this.aa9_1);
  }
  taa() {
    var tmp0_safe_receiver = this.qa8_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.va7_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  xaa() {
    return !(this.fa7().i9x_1.r8h_1 === 0);
  }
  toString() {
    return this.ea9_1.toString();
  }
  naa(views, dt) {
    if (!this.va7_1.saa())
      return Unit_instance;
    this.wa7_1 = views;
    Companion_instance_16.oaa(views);
    this.qa8_1 = mouseHitTest(Companion_instance_16, views);
    var over = this.taa();
    var inside = views.i9x_1.t8h_1;
    if (over) {
      set_mouseHitResultUsed(views.i9x_1, this.va7_1);
    }
    var overChanged = !(this.ra8_1 === over);
    var insideChanged = !(this.sa8_1 === inside);
    var pressingChanged = !(this.xaa() === this.ta8_1);
    this.aa9_1 = views.i9x_1.h8i();
    if (!overChanged && over && !this.aa9_1.equals(this.za8_1)) {
      this.ja8_1.r22(this);
    }
    if (!overChanged && !over && !this.aa9_1.equals(this.za8_1)) {
      this.la8_1.r22(this);
    }
    if (!this.aa9_1.equals(this.za8_1)) {
      this.ka8_1.r22(this);
    }
    if (overChanged && over) {
      this.za7_1.r22(this);
    }
    if (overChanged && !over) {
      this.aa8_1.r22(this);
    }
    if (pressingChanged && this.xaa()) {
      this.ya8_1 = this.aa9_1;
      if (over) {
        this.ba8_1.r22(this);
      }
      if (!over) {
        this.ca8_1.r22(this);
      }
    }
    if (overChanged && this.xaa()) {
      this.da8_1.r22(this);
    }
    if (pressingChanged && !this.xaa()) {
      var tmp = this.ga9_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.ba9_1 > 0;
    if (insideChanged && !inside) {
      this.la8_1.r22(this);
      this.aa8_1.r22(this);
      this.ga8_1.r22(this);
      this.ha8_1.r22(this);
      this.ma8_1.r22(this);
    }
    this.ra8_1 = over;
    this.sa8_1 = inside;
    this.ta8_1 = this.xaa();
    this.za8_1 = this.aa9_1;
    this.ba9_1 = 0;
  }
  t6() {
    this.ha9_1.t6();
  }
  r10(value) {
    this.ua7_1.r10(value);
  }
  s10() {
    return this.ua7_1.s10();
  }
}
class SceneCancellationException extends CancellationException {
  static eab(scene) {
    var $this = this.xd('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.dab_1);
    $this.cab_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.fab_1 = new Mixin();
    this.kab_1 = Container.cae();
    this.lab_1 = new CancellableGroup();
    var tmp = this;
    tmp.mab_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.nab_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.oab_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  qab() {
    var tmp = this.gab_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  dae(_set____db54di) {
    this.hab_1 = _set____db54di;
  }
  fa7() {
    var tmp = this.hab_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  rab() {
    var tmp = this.iab_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  eae() {
    return this.fa7().l9x_1;
  }
  s17() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.mab_1;
    coroutineContext$factory();
    return this_0.u1();
  }
  fae() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.nab_1;
    sceneView$factory();
    return this_0.u1();
  }
  sab(size) {
    return SContainer.rag(size);
  }
  l6i(injector) {
    this.gab_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.j6i(getKClass(Views));
    this.dae(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.iab_1 = injector.j6i(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.jab_1 = injector.j6i(getKClass(ResourcesRoot));
  }
  sag(_this__u8e3s4, $completion) {
  }
  tag(_this__u8e3s4, $completion) {
  }
  uag($completion) {
  }
  vag($completion) {
  }
  wag($completion) {
  }
  xag() {
    cancel_0(this.lab_1);
    this.qab().m6i();
  }
  pab($completion) {
  }
  yag($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219.bind(VOID, this), $completion);
  }
  r10(value) {
    this.fab_1.r10(value);
  }
  s10() {
    return this.fab_1.s10();
  }
}
class EmptyScene extends Scene {
  tag(_this__u8e3s4, $completion) {
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.pak_1 = clazz;
    this.qak_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.pak_1) + ', injects=' + toString(this.qak_1) + ')';
  }
  hashCode() {
    var result = this.pak_1.hashCode();
    result = imul(result, 31) + hashCode(this.qak_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.pak_1.equals(tmp0_other_with_cast.pak_1))
      return false;
    if (!equals(this.qak_1, tmp0_other_with_cast.qak_1))
      return false;
    return true;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_17 = this;
    this.tah_1 = Companion_getInstance_0().iz('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.uah_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.jah_1 = this$0;
    this.kah_1 = $event;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.wah_1 = $newScene;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.xah_1 = $newScene;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.yah_1 = $oldScene;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.zah_1 = $oldScene;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.aai_1 = $oldScene;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.bai_1 = $newScene;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
  }
}
class BaseView extends BaseEventListener {
  static gb7() {
    return this.j6l();
  }
  kaq() {
  }
}
class View extends BaseView {
  static jbi(isContainer) {
    var $this = this.gb7();
    $this.w9z_1 = isContainer;
    var tmp = $this;
    tmp.x9z_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.y9z_1 = true;
    $this.z9z_1 = null;
    $this.aa0_1 = null;
    $this.ba0_1 = null;
    $this.ca0_1 = 0;
    $this.da0_1 = null;
    $this.ea0_1 = 1.0;
    $this.fa0_1 = null;
    $this.ga0_1 = null;
    $this.ha0_1 = null;
    $this.ia0_1 = Companion_getInstance_14().i8d_1;
    $this.ja0_1 = 0.0;
    $this.ka0_1 = 0.0;
    $this.la0_1 = 1.0;
    $this.ma0_1 = 1.0;
    $this.na0_1 = Companion_getInstance_32().y2c_1;
    $this.oa0_1 = Companion_getInstance_32().y2c_1;
    $this.pa0_1 = Companion_getInstance_32().y2c_1;
    $this.qa0_1 = 0.0;
    $this.ra0_1 = scale$factory($this);
    $this.sa0_1 = false;
    $this.ta0_1 = true;
    $this.ua0_1 = true;
    $this.va0_1 = true;
    $this.wa0_1 = true;
    $this.xa0_1 = Companion_getInstance_31().s2g_1;
    $this.ya0_1 = Companion_getInstance_31().s2g_1;
    $this.za0_1 = -1;
    $this.aa1_1 = Companion_getInstance_31().s2g_1;
    $this.ba1_1 = -1;
    $this.ca1_1 = new ColorTransformMul();
    $this.da1_1 = new ColorTransformMul();
    $this.ea1_1 = -1;
    $this.fa1_1 = Companion_getInstance_14().i8d_1;
    $this.ga1_1 = -1;
    $this.ha1_1 = true;
    $this.ia1_1 = 0;
    $this.ja1_1 = 0;
    $this.ka1_1 = false;
    $this.la1_1 = false;
    $this.ma1_1 = null;
    $this.na1_1 = false;
    $this.oa1_1 = null;
    $this.pa1_1 = 0;
    $this.qa1_1 = true;
    $this.ra1_1 = null;
    return $this;
  }
  far() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x9z_1;
    bviewAll$factory();
    return this_0.u1();
  }
  static ebo() {
    return this.jbi(false);
  }
  gar() {
    return 0.0;
  }
  har() {
    return 0.0;
  }
  naq() {
    return null;
  }
  fb7(_set____db54di) {
    this.aa0_1 = _set____db54di;
  }
  iar() {
    return this.aa0_1;
  }
  jar() {
    return this.ba0_1;
  }
  fbd(value) {
    this.z9z_1 = value;
  }
  kar(value) {
    this.ca0_1 = value;
  }
  h6s() {
    return this.ca0_1;
  }
  lar(value) {
    if (this.fa0_1 === value)
      return Unit_instance;
    this.fa0_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.naq();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).lar(value);
      }
      tmp = Unit_instance;
    }
    this.mar();
  }
  mar() {
  }
  nar(value) {
    if (this.ga0_1 === value)
      return Unit_instance;
    this.ga0_1 = value;
    var parent = this.laq();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.naq();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).nar(parent);
      }
      tmp = Unit_instance;
    }
  }
  laq() {
    return this.ga0_1;
  }
  oar() {
    var tmp0_safe_receiver = this.da0_1;
    this.nar(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.laq());
  }
  par(value) {
    if (this.da0_1 === value)
      return Unit_instance;
    this.da0_1 = value;
    var tmp0_safe_receiver = this.da0_1;
    this.lar(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fa0_1);
    this.oar();
    this.xas();
    this.k6l(value);
  }
  l2b() {
    return this.da0_1;
  }
  qar() {
    return !(this.l2b() == null) ? ensureNotNull(this.l2b()).qar() * this.ea0_1 : this.ea0_1;
  }
  rar(x, y) {
    this.nas();
    if (!(this.ja0_1 === x) || !(this.ka0_1 === y)) {
      this.ja0_1 = x;
      this.ka0_1 = y;
      this.vas();
    }
  }
  d4y(value) {
    return this.rar(value.h2d_1, value.i2d_1);
  }
  sar(v) {
    this.rar(v, this.p6p());
  }
  o6p() {
    this.nas();
    return this.ja0_1;
  }
  tar(v) {
    this.rar(this.o6p(), v);
  }
  p6p() {
    this.nas();
    return this.ka0_1;
  }
  uar() {
    return this.qa0_1;
  }
  var(v) {
    this.bas(Scale.b2l(v, v));
  }
  war() {
    return this.cas().d2j();
  }
  xar(v) {
    this.nas();
    if (!(this.la0_1 === v)) {
      this.la0_1 = v;
      this.vas();
    }
  }
  yar() {
    this.nas();
    return this.la0_1;
  }
  zar(v) {
    this.nas();
    if (!(this.ma0_1 === v)) {
      this.ma0_1 = v;
      this.vas();
    }
  }
  aas() {
    this.nas();
    return this.ma0_1;
  }
  bas(value) {
    this.xar(value.z2k_1);
    this.zar(value.a2l_1);
  }
  cas() {
    return Scale.b2l(this.yar(), this.aas());
  }
  das() {
    this.nas();
    return this.na0_1;
  }
  eas() {
    this.nas();
    return this.oa0_1;
  }
  fas(v) {
    this.nas();
    if (!equals(this.pa0_1, v)) {
      this.pa0_1 = v;
      this.vas();
    }
  }
  gas() {
    this.nas();
    return this.pa0_1;
  }
  has() {
    var tmp0_safe_receiver = this.l2b();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dat(Vector2D.q2f(this.o6p(), this.p6p()));
    return tmp1_elvis_lhs == null ? Vector2D.q2f(this.o6p(), this.p6p()) : tmp1_elvis_lhs;
  }
  e1() {
    return this.pan();
  }
  pan() {
    return this.jaa().e1();
  }
  ias() {
    return this.pan().m2e_1;
  }
  jas() {
    return this.pan().n2e_1;
  }
  mbi() {
    return this.ias() * this.yar();
  }
  x2p() {
    return this.ias();
  }
  y2p() {
    return this.jas();
  }
  m4k(v) {
    if (!(v === this.ca1_1.o4k())) {
      this.ca1_1.m4k(v);
      this.paq();
    }
  }
  o4k() {
    return this.ca1_1.o4k();
  }
  kas(v) {
    this.las(v);
  }
  las(v) {
    if (!(this.ca1_1.l4k() === v)) {
      this.ca1_1.k4k(v);
      this.paq();
    }
  }
  mas() {
    return this.ca1_1.l4k();
  }
  nas() {
    if (this.va0_1)
      return Unit_instance;
    this.va0_1 = true;
    var t = this.xa0_1.f2i();
    this.ja0_1 = t.r2i_1;
    this.ka0_1 = t.s2i_1;
    this.la0_1 = t.t2i_1;
    this.ma0_1 = t.u2i_1;
    this.na0_1 = t.v2i_1;
    this.oa0_1 = t.w2i_1;
    this.pa0_1 = t.x2i_1;
  }
  d2b() {
    var tmp0_safe_receiver = this.l2b();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2b();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  ea7() {
    return this.fa0_1;
  }
  uaa(_set____db54di) {
    this.sa0_1 = _set____db54di;
  }
  saa() {
    return this.sa0_1;
  }
  oas() {
    return this.ta0_1;
  }
  z8w(value) {
    if (!(this.ua0_1 === value)) {
      this.ua0_1 = value;
      this.oaq();
    }
  }
  pas() {
    return this.ua0_1;
  }
  qas() {
    if (!this.wa0_1) {
      this.wa0_1 = true;
      this.ka1_1 = true;
      this.xa0_1 = Companion_getInstance_31().e2h(this.o6p(), this.p6p(), this.gas(), this.yar(), this.aas(), this.das(), this.eas(), 0.0, 0.0);
    }
    return this.xa0_1;
  }
  laa() {
    if (!(this.za0_1 === this.ia1_1)) {
      this.za0_1 = this.ia1_1;
      this.ka1_1 = true;
      this.ya0_1 = !(this.l2b() == null) ? this.qas().g2h(ensureNotNull(this.l2b()).laa()) : this.qas();
    }
    return this.ya0_1;
  }
  ras() {
    if (!(this.ba1_1 === this.ia1_1)) {
      this.ba1_1 = this.ia1_1;
      this.ka1_1 = true;
      this.aa1_1 = this.laa().e2i();
    }
    return this.aa1_1;
  }
  sas() {
    updateRenderColorTransformIfRequired(this);
    return this.da1_1;
  }
  tas() {
    updateRenderBlendModeIfRequired(this);
    return this.fa1_1;
  }
  uas() {
    updateRenderColorTransformIfRequired(this);
    return this.da1_1.o4k();
  }
  nbi(views) {
    return this.waa(views.i9x_1.h8i());
  }
  vas() {
    this.wa0_1 = false;
    this.oaq();
  }
  oaq() {
    this.ia1_1 = this.ia1_1 + 1 | 0;
    this.ka1_1 = false;
    this.ha1_1 = true;
    this.kaq();
  }
  was() {
    if (!(this.ma1_1 == null)) {
      this.ma1_1 = null;
      var tmp0_safe_receiver = this.l2b();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.was();
      }
    }
  }
  xas() {
    this.san();
  }
  yas() {
    this.san();
  }
  san() {
  }
  kaq() {
    var tmp0_safe_receiver = this.ga0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.maq(this);
    }
    this.was();
  }
  paq() {
    this.ja1_1 = this.ja1_1 + 1 | 0;
    this.la1_1 = false;
    this.ha1_1 = true;
    this.kaq();
  }
  qan(ctx) {
    if (!this.pas())
      return Unit_instance;
    var tmp0_safe_receiver = this.oa1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.h11_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].ic7(this, ctx);
      }
    }
    try {
      this.zas(ctx);
    }finally {
      var tmp1_safe_receiver = this.oa1_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.h11_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.e1() - n_0 | 0) - 1 | 0].jc7(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  zas(ctx) {
    var oldPhase = this.pa1_1;
    try {
      this.pa1_1 = 0;
      this.aat(ctx);
    }finally {
      this.pa1_1 = oldPhase;
    }
  }
  aat(ctx) {
    var stages = this.oa1_1;
    if (!(stages == null) && this.pa1_1 < stages.e1()) {
      var _unary__edvuaz = this.pa1_1;
      this.pa1_1 = _unary__edvuaz + 1 | 0;
      stages.d1(_unary__edvuaz).kc7(this, ctx);
    } else {
      var tmp = this.pa1_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.e1();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.uan(ctx);
        this.pa1_1 = this.pa1_1 + 1 | 0;
      }
    }
  }
  yaq(ctx) {
    if (this.na1_1 || this === get_debugAnnotateView(ctx)) {
      this.bat(ctx);
    }
  }
  bat(ctx) {
    var local = this.jaa();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.b8o_1;
    if (!(this_1.e8f_1 === this_0)) {
      this_1.e8f_1 = this_0;
      this_1.o8g();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.n8o_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_14().r8d_1;
          var doUpdate = !(this_0.m8o_1 === blending);
          var old = this_0.m8o_1;
          try {
            if (doUpdate) {
              this_0.b8o_1.o8g();
              this_0.m8o_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().a45_1;
            var m = this_0.n8o_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.e8o_1;
            this_0.e8o_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.g3v(this.oat());
              this_0.t8o(this_3, m);
            }finally {
              this_0.e8o_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.b8o_1.o8g();
            }
            this_0.m8o_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().a45_1;
        var m_0 = this_0.n8o_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.e8o_1;
        this_0.e8o_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.t3l(this.dat(Vector2D.q2f(local.y2d(), local.a2e())));
          this_4.v3l(this.dat(Vector2D.q2f(local.z2d(), local.a2e())));
          this_4.v3l(this.dat(Vector2D.q2f(local.z2d(), local.b2e())));
          this_4.v3l(this.dat(Vector2D.q2f(local.y2d(), local.b2e())));
          this_4.t6();
          this_0.t8o(this_4, m_0);
        }finally {
          this_0.e8o_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().o4a_1;
        var m_1 = this_0.n8o_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.e8o_1;
        this_0.e8o_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).u8n();
          this_5.b3g(this.dat(local.q2e()), anchorSize);
          this_5.b3g(this.dat(local.a2m()), anchorSize);
          this_5.b3g(this.dat(local.s2e()), anchorSize);
          this_5.b3g(this.dat(local.b2m()), anchorSize);
          this_5.b3g(this.dat(interpolate(Companion_getInstance_35().i10_1, local.q2e(), local.a2m())), anchorSize);
          this_5.b3g(this.dat(interpolate(Companion_getInstance_35().i10_1, local.a2m(), local.s2e())), anchorSize);
          this_5.b3g(this.dat(interpolate(Companion_getInstance_35().i10_1, local.s2e(), local.b2m())), anchorSize);
          this_5.b3g(this.dat(interpolate(Companion_getInstance_35().i10_1, local.b2m(), local.q2e())), anchorSize);
          this_0.t8o(this_5, m_1);
        }finally {
          this_0.e8o_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().c45_1;
        var m_2 = this_0.n8o_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.e8o_1;
        this_0.e8o_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.has();
          this_6.e3v(Vector2D.q2f(center.h2d_1, center.i2d_1 - 5), Vector2D.q2f(center.h2d_1, center.i2d_1 + 5));
          this_6.e3v(Vector2D.q2f(center.h2d_1 - 5, center.i2d_1), Vector2D.q2f(center.h2d_1 + 5, center.i2d_1));
          this_0.t8o(this_6, m_2);
        }finally {
          this_0.e8o_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.o6p() === 0.0) || !(this.p6p() === 0.0))
      out = out + (':pos=(' + this.cat(this.o6p()) + ',' + this.cat(this.p6p()) + ')');
    if (!(this.yar() === 1.0) || !(this.aas() === 1.0))
      out = out + (':scale=(' + this.cat(this.yar()) + ',' + this.cat(this.aas()) + ')');
    if (!equals(this.das(), Companion_getInstance_32().y2c_1) || !equals(this.eas(), Companion_getInstance_32().y2c_1))
      out = out + (':skew=(' + this.cat(_Angle___get_degrees__impl__qg56vw(this.das())) + ',' + this.cat(_Angle___get_degrees__impl__qg56vw(this.eas())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.gas()), Companion_getInstance_32().y2c_1))
      out = out + (':rotation=(' + this.cat(_Angle___get_degrees__impl__qg56vw(this.gas())) + '\xBA)');
    if (!(this.ha0_1 == null))
      out = out + (':name=(' + this.ha0_1 + ')');
    if (!this.ia0_1.equals(Companion_getInstance_14().i8d_1))
      out = out + (':blendMode=(' + this.ia0_1.toString() + ')');
    if (!this.pas())
      out = out + (':visible=' + this.pas());
    if (!(this.mas() === 1.0))
      out = out + (':alpha=' + niceStr(this.mas(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.o4k()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().y44_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.o4k()));
    return out;
  }
  cat(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  waa(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.ras();
      if (this_0.w2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.q2f(this_0.k2h(p.h2d_1, p.i2d_1), this_0.n2h(p.h2d_1, p.i2d_1));
    }
    return tmp$ret$0;
  }
  dat(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.laa();
      if (this_0.w2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.q2f(this_0.k2h(p.h2d_1, p.i2d_1), this_0.n2h(p.h2d_1, p.i2d_1));
    }
    return tmp$ret$0;
  }
  iaa(p) {
    if (!this.qa1_1)
      return null;
    if (!this.pas())
      return null;
    if (this.oas()) {
      var tmp0_safe_receiver = this.naq();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.View.mouseHitTest.<anonymous>' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.d1((tmp0_safe_receiver.e1() - n | 0) - 1 | 0).iaa(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.saa())
      return null;
    var tmp1_safe_receiver = this.gat(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var area = this.eat();
      if (!area.w2d() && !area.y2l(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  eat() {
    var out = Companion_getInstance_29().e2e_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l2b();
    }
    while (!(view == null)) {
      // Inline function 'korlibs.korge.view.View.getClippingAreaInternal.<anonymous>' call
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.w5u();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.qat();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.i2m(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.l2b();
    }
    return count === 0 ? Companion_getInstance_29().g2e() : out;
  }
  fat(p, direction) {
    if (!this.qa1_1)
      return null;
    var ll = this.waa(p);
    var bounds = this.jaa();
    if (!bounds.y2l(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.b2i(this.gar(), this.har());
    var l = Vector2D.q2f(ll.h2d_1 + that.h2d_1, ll.i2d_1 + that.i2d_1);
    if (this.ra1_1 === false)
      return this;
    var hitShape = this.iar();
    var hitShapes = this.jar();
    if (this.ra1_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.e1()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.d1(_unary__edvuaz).y3v(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.y3v(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  gat(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.fat(p, direction) : $super.fat.call(this, p, direction);
  }
  hat() {
    var tmp0_safe_receiver = this.l2b();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.ear(this);
  }
  iat(target, inclusive) {
    var tmp;
    if (target === this.l2b()) {
      tmp = this.qas();
    } else if (target === this) {
      tmp = Companion_getInstance_31().s2g_1;
    } else {
      var commonAncestor = Companion_instance_23.hc7(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.l2b() == null && inclusive) {
          return this.laa();
        }
        tmp_0 = this.laa().g2h(target.ras());
      } else {
        tmp_0 = Companion_getInstance_31().s2g_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.g2h(target.qas());
    }
    return out;
  }
  jat() {
    var tmp0_elvis_lhs = this.kat();
    return tmp0_elvis_lhs == null ? this.qat() : tmp0_elvis_lhs;
  }
  kat() {
    var stage = this.d2b();
    if (!(stage instanceof Stage))
      return null;
    return this.lat(stage);
  }
  lat(bp) {
    return this.qat().q2m(bp.q8n());
  }
  mat(ctx) {
    return ctx.b8p() ? this.lat(ctx) : this.qat();
  }
  nat(ctx) {
    return this.mat(ctx);
  }
  oat() {
    return this.qat();
  }
  pat(includeFilters) {
    return this.tat(this.d2b(), VOID, true, includeFilters);
  }
  qat(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.pat(includeFilters) : $super.pat.call(this, includeFilters);
  }
  rat(concat, doAnchoring, includeFilters) {
    var out = this.uat(doAnchoring, includeFilters);
    if (concat.x2d() && !concat.h2h()) {
      var tmp = Companion_getInstance_30();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.q2e();
        if (concat.w2d()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.q2f(concat.k2h(p.h2d_1, p.i2d_1), concat.n2h(p.h2d_1, p.i2d_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.a2m();
        if (concat.w2d()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.q2f(concat.k2h(p_0.h2d_1, p_0.i2d_1), concat.n2h(p_0.h2d_1, p_0.i2d_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.s2e();
        if (concat.w2d()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.q2f(concat.k2h(p_1.h2d_1, p_1.i2d_1), concat.n2h(p_1.h2d_1, p_1.i2d_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.b2m();
        if (concat.w2d()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.q2f(concat.k2h(p_2.h2d_1, p_2.i2d_1), concat.n2h(p_2.h2d_1, p_2.i2d_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.i2e(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  sat(target, doAnchoring, inclusive, includeFilters) {
    return this.rat(this.iat(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  tat(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.sat(target, doAnchoring, inclusive, includeFilters) : $super.sat.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  uat(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.ma1_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.ran();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.ma1_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.w2h(Vector2D.b2i(this.gar(), this.har()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  jaa(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.uat(doAnchoring, includeFilters) : $super.uat.call(this, doAnchoring, includeFilters);
  }
  ran() {
    return Companion_getInstance_29().g2e();
  }
  s6l(type, event, result) {
    var tmp0_safe_receiver = this.l2b();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.z6l(type, event, result);
  }
}
class Container extends View {
  static cae(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.jbi(true);
    $this.tad_1 = cull;
    $this.uad_1 = FastArrayList.j11();
    $this.vad_1 = new ContainerCollection($this, $this.uad_1);
    $this.wad_1 = null;
    $this.xad_1 = new MMatrix();
    $this.yad_1 = false;
    $this.zad_1 = false;
    $this.aae_1 = FastArrayList.j11();
    return $this;
  }
  naq() {
    return this.uad_1;
  }
  oaq() {
    super.oaq();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.vad_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.ka1_1) {
        child.oaq();
      }
    }
  }
  paq() {
    super.paq();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.vad_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.la1_1) {
        child.paq();
      }
    }
  }
  qaq() {
    return this.uad_1.e1();
  }
  raq(view) {
  }
  san() {
    super.san();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.naq();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).yas();
      }
      tmp = Unit_instance;
    }
  }
  saq(index) {
    return this.uad_1.d1(index);
  }
  taq(index) {
    return this.uaq(index, 1) === 1;
  }
  uaq(index, count) {
    if (count <= 0 || index < 0)
      return 0;
    var from = index;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = index + count | 0;
    var b = this.qaq();
    var to = Math.min(a, b);
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var removedIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var view = this.saq(removedIndex);
        view.par(null);
        view.kar(-1);
      }
       while (inductionVariable < to);
    this.uad_1.m11(from, to);
    var inductionVariable_0 = index;
    var last = this.qaq();
    if (inductionVariable_0 < last)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.uad_1.d1(i).kar(i);
      }
       while (inductionVariable_0 < last);
    this.aar();
    this.bar();
    this.was();
    return to - from | 0;
  }
  vaq() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.vad_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      child.par(null);
      child.kar(-1);
    }
    this.uad_1.m3();
    this.aar();
  }
  waq(view) {
    return this.dar(view, this.qaq());
  }
  bae(view) {
    this.dar(view, this.qaq());
  }
  d1(index) {
    return this.saq(index);
  }
  uan(ctx) {
    if (!this.pas())
      return Unit_instance;
    this.xaq(ctx);
  }
  xaq(ctx) {
    if (!this.tad_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.yad_1) {
        this.yad_1 = true;
        this.aae_1.m3();
        this.aae_1.f1(this.vad_1);
        if (this.zaq())
          this.zad_1 = false;
      }
      if (!this.zad_1) {
        this.zad_1 = true;
        sortWith(this.aae_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.aae_1.h11_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].qan(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.qat();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_29().g2e() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.yad_1) {
      this.yad_1 = true;
      this.aae_1.m3();
      this.aae_1.f1(this.vad_1);
      if (this.zaq())
        this.zad_1 = false;
    }
    if (!this.zad_1) {
      this.zad_1 = true;
      sortWith(this.aae_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.aae_1.h11_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.w2d() || bounds.f2m(child.pat(true))) {
        child.qan(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  yaq(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.yad_1) {
      this.yad_1 = true;
      this.aae_1.m3();
      this.aae_1.f1(this.vad_1);
      if (this.zaq())
        this.zad_1 = false;
    }
    if (!this.zad_1) {
      this.zad_1 = true;
      sortWith(this.aae_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.aae_1.h11_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].yaq(ctx);
    }
    super.yaq(ctx);
  }
  ran() {
    var bb = Companion_getInstance_30().h2e();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.vad_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.tat(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  zaq() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.uad_1.h11_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].uar() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  aar() {
    this.yad_1 = false;
    this.bar();
  }
  bar() {
    var tmp0_safe_receiver = this.ea7();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fa7();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.maq(this);
    }
  }
  car(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  dar(view, index) {
    this.car(view);
    var tmp0_safe_receiver = view.l2b();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.aar();
    }
    view.hat();
    var aindex = clamp_1(index, 0, this.qaq());
    var children = this.uad_1;
    children.q3(aindex, view);
    var inductionVariable = aindex;
    var last = this.qaq();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.d1(n).kar(n);
      }
       while (inductionVariable < last);
    view.par(this);
    view.oaq();
    this.raq(view);
    this.aar();
    this.bar();
    this.was();
  }
  ear(view) {
    if (!((view == null ? null : view.l2b()) === this))
      return false;
    return this.taq(view.h6s());
  }
  p6l(type, event, result) {
    if (this.wad_1 == null)
      this.wad_1 = FastArrayList.i11(this.vad_1.e1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.uad_1;
    var temp = ensureNotNull(this.wad_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.h11_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].y6l(type, event, result);
      }
    }finally {
      temp.m3();
    }
  }
}
class CachedContainer extends Container {
  static hb7(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.cae();
    $this.daq_1 = cache;
    $this.eaq_1 = renderQuality;
    $this.faq_1 = null;
    $this.gaq_1 = true;
    $this.haq_1 = -1.0;
    $this.iaq_1 = Companion_getInstance_29().v2g();
    $this.jaq_1 = Scale.k2n(1);
    return $this;
  }
  kaq() {
    super.kaq();
    this.gaq_1 = true;
  }
  uan(ctx) {
    if (!this.pas())
      return Unit_instance;
    if (!this.daq_1) {
      return super.uan(ctx);
    }
    if (this.faq_1 == null) {
      this.faq_1 = new CacheTexture(this, ctx);
      this.gaq_1 = true;
    }
    var cache = ensureNotNull(this.faq_1);
    ctx.f8p(cache);
    var renderScale = ctx.v8o().t3_1 === 0 ? 1.0 : ctx.n8p();
    var tmp1_elvis_lhs = this.eaq_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.v8o() : tmp1_elvis_lhs);
    if (this.gaq_1 || !(this.haq_1 === renderScale)) {
      this.haq_1 = renderScale;
      this.iaq_1 = this.jaa(VOID, false);
      this.jaq_1 = doExpensiveScaling ? this.jat().e1().m2n(this.iaq_1.e1()) : Scale.k2n(1);
      this.gaq_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.iaq_1.t2d_1 * renderScale * this.jaq_1.z2k_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.iaq_1.u2d_1 * renderScale * this.jaq_1.a2l_1), 1);
      cache.nb7(texWidth, texHeight);
      ctx.o8g();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.jb7_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.k8p(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.a8f_1;
        var this_1 = this_0.j8f_1;
        if (!(this_1.e8f_1 === this_0)) {
          this_1.e8f_1 = this_0;
          this_1.o8g();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.e75(0, 0, frameBuffer.d6u_1, frameBuffer.e6u_1);
          var temp = this_0.h8g_1;
          this_0.q8m();
          this_0.h8g_1 = scissor;
          try {
            if (true) {
              ctx.d8p(Colors_getInstance().d45_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.ras().y2h(-this.iaq_1.r2d_1, -this.iaq_1.s2d_1).s2h(renderScale * this.jaq_1.z2k_1, renderScale * this.jaq_1.a2l_1);
            ctx.o8g();
            var temp4 = ctx.p8e_1;
            var temp2d = ctx.q8e_1;
            ctx.q8e_1 = matrix;
            ctx.p8e_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.q71(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.f73();
              this_2.x7p(_unary__edvuaz + 1 | 0);
              this_2.y7p(this_2.f73() + 1 | 0);
              var blockSize = this_2.j71_1;
              var index0 = imul(this_2.f73() - 1 | 0, blockSize);
              var index1 = imul(this_2.f73(), blockSize);
              var texBlockSize = this_2.g71_1.f79().e1();
              var texIndex0 = imul(this_2.f73() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.f73(), texBlockSize);
              if (this_2.f73() > 0) {
                arraycopy(this_2.l71_1, index0, this_2.l71_1, index1, blockSize);
              } else {
                arrayfill(this_2.l71_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.g71_1;
              this_2.m71_1.h7q($this$push.e79(), ctx.p8e_1);
              if (true && this_2.f73() >= 1) {
                var equals = arrayequal(this_2.l71_1, index0, this_2.l71_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.f73();
                  this_2.x7p(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.uan(ctx);
            }finally {
              ctx.o8g();
              ctx.p8e_1 = temp4;
              ctx.q8e_1 = temp2d;
              ctx.q71(ProjViewUB_getInstance()).z7p();
            }
            break $l$block_0;
          }finally {
            this_0.q8m();
            this_0.h8g_1 = temp;
          }
        }
      }finally {
        ctx.l8p();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.a8f_1;
    var this_4 = this_3.j8f_1;
    if (!(this_4.e8f_1 === this_3)) {
      this_4.e8f_1 = this_3;
      this_4.o8g();
    }
    this_3.q8g(cache.lb7_1, VOID, VOID, VOID, VOID, this.laa().c2i(this.iaq_1.r2d_1, this.iaq_1.s2d_1).u2h(1.0 / (renderScale * this.jaq_1.z2k_1), 1.0 / (renderScale * this.jaq_1.a2l_1)), VOID, this.uas(), this.ia0_1);
  }
  laq() {
    return this;
  }
  maq(view) {
    this.gaq_1 = true;
    var tmp0_safe_receiver = this.l2b();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ga0_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.maq(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static qay(size, cache, clip) {
    size = size === VOID ? Size2D.o2e(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.hb7(cache);
    $this.nay_1 = clip;
    $this.oay_1 = size;
    $this.pay_1 = Ref(false);
    return $this;
  }
  pan() {
    return this.oay_1;
  }
  ran() {
    return new Rectangle(0.0, 0.0, this.x2p(), this.y2p());
  }
  uan(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.nay_1;
      var renderingInternalRef = this.pay_1;
      if (renderingInternalRef.u1()) {
        super.uan(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.laa();
        var hasRotation = !(m.y2g_1 === 0.0) || !(m.z2g_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.u1();
          try {
            renderingInternalRef.z2y(true);
            renderFiltered(this, ctx, Companion_getInstance_50());
          }finally {
            renderingInternalRef.z2y(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.a8f_1;
        if (!(ctx.e8f_1 === batcher)) {
          ctx.e8f_1 = batcher;
          ctx.o8g();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.c8f_1;
        var bounds = this.nat(ctx).q2m(ctx.q8e_1).r2m();
        var rect = c2d.r8p_1.a8m().m75();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.f2m(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_15().h75(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.r8p_1;
            var scissor_0 = c2d.z8p(scissor);
            var temp = this_0.h8g_1;
            this_0.q8m();
            this_0.h8g_1 = scissor_0;
            try {
              super.uan(ctx);
              break $l$block_1;
            }finally {
              this_0.q8m();
              this_0.h8g_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.uan(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.uan(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static lan(size, cache) {
    Companion_getInstance_41();
    size = size === VOID ? Companion_getInstance_41().xav_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.qay(size, cache, false);
    $this.jan_1 = size;
    $this.kan_1 = false;
    return $this;
  }
  pan() {
    return this.jan_1;
  }
  ran() {
    return new Rectangle(0.0, 0.0, this.x2p(), this.y2p());
  }
  san() {
    super.san();
    this.tan();
  }
  tan() {
    this.oaq();
  }
  uan(ctx) {
    registerUISupportOnce(this);
    super.uan(ctx);
  }
}
class SceneContainer extends UIView {
  static sa4(views, defaultTransition, name, size) {
    Companion_getInstance_40();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_34())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.r9y_1.e1() : size;
    var $this = this.lan(size);
    $this.ma4_1 = views;
    $this.na4_1 = defaultTransition;
    $this.ha0_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.man();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.bae(this_0);
    tmp.oa4_1 = this_0;
    $this.pa4_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.l6l(tmp_0, SceneContainer$lambda($this));
    $this.qa4_1 = arrayListOf([Companion_getInstance_40().uah_1]);
    $this.ra4_1 = 0;
    return $this;
  }
  nan(clazz, injects, time, transition, $completion) {
    this.oan(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  ta4(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.na4_1 : transition;
    return $super === VOID ? this.nan(clazz, injects, time, transition, $completion) : $super.nan.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  vah(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0.bind(VOID, this, newScene, time, transition), $completion);
  }
  oan(entry) {
    while (this.qa4_1.e1() <= this.ra4_1) {
      this.qa4_1.h(Companion_getInstance_40().uah_1);
    }
    this.qa4_1.p3(this.ra4_1, entry);
  }
  s17() {
    return this.ma4_1.f9x_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static man() {
    var $this = this.cae();
    dummyView($this);
    dummyView($this);
    $this.kak_1 = Companion_getInstance_35().g10_1;
    $this.lak_1 = get_AlphaTransition();
    return $this;
  }
  e1l() {
    return this.d1(0);
  }
  b1l() {
    return this.d1(1);
  }
  nak(next, transition) {
    this.lak_1 = transition;
    this.kak_1 = Companion_getInstance_35().g10_1;
    this.mak_1 = transition.yat();
    this.zat(this.b1l(), next);
    _get_transitionProcess__5hlux5(this).vat(this.e1l(), this.b1l());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.kak_1) + ':transition=' + toString(this.lak_1));
  }
  oak() {
    this.kak_1 = Companion_getInstance_35().j10_1;
    _get_transitionProcess__5hlux5(this).wat(this.e1l(), this.b1l());
    this.zat(dummyView(this), this.b1l());
  }
  zat(prev, next) {
    this.vaq();
    this.waq(prev);
    this.waq(next);
  }
  uan(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.kak_1, Companion_getInstance_35().g10_1) <= 0) {
      this.e1l().qan(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.kak_1, Companion_getInstance_35().j10_1) >= 0) {
      this.b1l().qan(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).xat(ctx, this.e1l(), this.b1l(), this.kak_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.aau_1 = $render;
    this.bau_1 = $name;
  }
  yat() {
    return this;
  }
  xat(ctx, prev, next, ratio) {
    return this.aau_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.bau_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.cau_1 = $process;
    this.dau_1 = $easing;
  }
  vat(prev, next) {
    return this.cau_1.vat(prev, next);
  }
  wat(prev, next) {
    return this.cau_1.wat(prev, next);
  }
  xat(ctx, prev, next, ratio) {
    return this.cau_1.xat(ctx, prev, next, this.dau_1.b10(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.eau_1 = $this_withEasing;
    this.fau_1 = $easing;
  }
  toString() {
    return toString(this.eau_1) + '.withEasing';
  }
  yat() {
    var process = this.eau_1.yat();
    return new withEasing$1$create$1(process, this.fau_1);
  }
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.gau_1 = this.kau(true, VOID, false);
    this.hau_1 = this.kau(true, VOID, true);
    this.iau_1 = this.lau(false, 'r', false);
    this.jau_1 = this.lau(false, 'a', false);
  }
  lau(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_7().m8l_1;
    var tmp2_name = name == null ? Companion_getInstance_7().m8l_1.c72_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.j7b();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.a7d();
    var tmp_0 = this_0.a7d();
    var tmp_1 = this_0.a7d();
    var tmp_2 = this_0.a7d();
    var median$delegate = this_0.p7c(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).r79(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_7().j8l_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.u7c(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.i7d(this_0.c7c());
    var alpha = this_0.j7d(this_0.c7c());
    this_0.o7b(this_0.r7b(), this_0.n7d(this_0.r7b(), this_0.v7b([this_0.u7b(0.5)])));
    if (msdf) {
      this_0.o7b(d, this_0.s7c(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.x7b(this_0.r7b(), 'r'), this_0.x7b(this_0.r7b(), 'g'), this_0.x7b(this_0.r7b(), 'b')));
    } else {
      this_0.o7b(d, this_0.x7b(this_0.r7b(), sdf));
    }
    this_0.o7b(alpha, this_0.r7c(SDFShaders_getInstance().b8r(), d));
    if (inverted) {
      this_0.o7b(alpha, this_0.n7d(this_0.u7b(1.0), alpha));
    }
    this_0.o7b(this_0.r7b(), this_0.s7b(this_0.p7b(), alpha));
    var tmp3_fragment = FragmentShader(this_0.w7b());
    return tmp1_$this.v7y(VOID, tmp3_fragment, tmp2_name);
  }
  kau(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.lau(msdf, sdf, inverted) : $super.lau.call(this, msdf, sdf, inverted);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.l1z() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.l1z() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.mau_1 = view;
    this.nau_1 = vs;
    this.oau_1 = fastTime;
    this.pau_1 = easing;
    this.qau_1 = callback;
    this.rau_1 = c;
    this.sau_1 = fastWaitTime;
    this.tau_1 = autoInvalidate;
    this.uau_1 = Companion_instance_1.k1z();
    var tmp = this;
    var tmp_0;
    if (!equals(this.oau_1, Companion_instance_1.l1z())) {
      tmp_0 = this.oau_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.nau_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.k8s_1);
        destination.h(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.vau_1 = tmp_0;
    this.wau_1 = false;
    this.xau_1 = false;
    this.yau_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.zau_1 = this.mau_1.l6l(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.rau_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.r1a(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.k1z());
  }
  gav() {
    return get_slow(this.sau_1);
  }
  hav() {
    if (this.yau_1)
      return Unit_instance;
    this.yau_1 = true;
    var tmp0_safe_receiver = this.rau_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.ed(tmp$ret$0);
    }
  }
  fav() {
    if (this.xau_1)
      return Unit_instance;
    this.xau_1 = true;
    var tmp0_safe_receiver = this.zau_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t6();
    }
    this.zau_1 = null;
    this.hav();
  }
  aav(elapsed) {
    if (equals(elapsed, Companion_instance_1.k1z())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.nau_1;
      var n = 0;
      while (n < this_0.e1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.d1(_unary__edvuaz).b3e();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.nau_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.d1(_unary__edvuaz_0);
      var durationInTween = equals(v.i8s_1, Companion_instance_1.l1z()) ? FastDuration__minus_impl_evs237(this.vau_1, v.h8s_1) : v.i8s_1;
      var elapsedInTween = get_fastMilliseconds_0(clamp_0(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.h8s_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7(durationInTween, Companion_getInstance().yj_1) <= 0 || FastDuration__compareTo_impl_4fhnj7_0(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.pau_1.a10(ratioInTween);
      v.n8s(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.mau_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.iav_1 = $this_tween;
    this.jav_1 = $tc;
    this.kav_1 = $vs;
    this.lav_1 = $time;
    this.mav_1 = $easing;
    this.nav_1 = $callback;
    this.oav_1 = $waitTime;
    this.pav_1 = $autoInvalidate;
  }
  a1r($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this, $this$withTimeoutNullable), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class UIObservable {
  constructor(initial, observe) {
    this.qav_1 = initial;
    this.rav_1 = observe;
    this.sav_1 = this.qav_1;
  }
  tav(obj, prop) {
    return this.sav_1;
  }
  uav(obj, prop, value) {
    if (!equals(this.sav_1, value)) {
      this.sav_1 = value;
      this.rav_1(value);
    }
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.vav_1 = 90.0;
    this.wav_1 = 32.0;
    this.xav_1 = Size2D.q2l(90.0, 32.0);
  }
}
class InternalViewAutoscaling {
  constructor() {
    this.zb3_1 = 1.0;
    this.ab4_1 = 1.0;
    this.bb4_1 = 1.0;
    this.cb4_1 = 1.0;
    this.db4_1 = 1.0;
    this.eb4_1 = MatrixTransform.b2j();
  }
  fb4(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.eb4_1 = globalMatrix.f2i();
      // Inline function 'kotlin.math.abs' call
      var x = this.eb4_1.t2i_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.eb4_1.u2i_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.bb4_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.cb4_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.bb4_1 = sx;
        this.cb4_1 = sy;
        this.db4_1 = sxy;
        this.zb3_1 = 1.0 / sx;
        this.ab4_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.bb4_1 = 1.0;
      this.cb4_1 = 1.0;
      this.db4_1 = 1.0;
      this.zb3_1 = 1.0;
      this.ab4_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static jbx(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().i2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ebo();
    $this.pb6_1 = smoothing;
    $this.fb7(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.qb6_1 = get_Bitmaps_white();
    $this.rb6_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_16();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.sb6_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.tb6_1 = null;
    $this.ub6_1 = null;
    return $this;
  }
  cb7(v) {
    if (!(this.qb6_1 === v)) {
      this.qb6_1 = v;
      this.ha1_1 = true;
      this.kaq();
    }
  }
  ray(v) {
    if (!this.rb6_1.equals(v)) {
      this.rb6_1 = v;
      this.ha1_1 = true;
      this.kaq();
    }
  }
  vb6() {
    return this.rb6_1;
  }
  nb4() {
    return 0.0;
  }
  ob4() {
    return 0.0;
  }
  gar() {
    return this.vb6().r2c_1 * this.nb4();
  }
  har() {
    return this.vb6().s2c_1 * this.ob4();
  }
  wb6() {
    return -this.gar();
  }
  xb6() {
    return -this.har();
  }
  uan(ctx) {
    if (!this.pas())
      return Unit_instance;
    var tmp = this.qb6_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.ha1_1) {
      this.ha1_1 = false;
      this.eb7();
    }
    this.db7(ctx);
  }
  db7(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a8f_1;
    var this_1 = this_0.j8f_1;
    if (!(this_1.e8f_1 === this_0)) {
      this_1.e8f_1 = this_0;
      this_1.o8g();
    }
    var tmp0_safe_receiver = this.ub6_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.sb6_1;
    var tex = ctx.e8p(this.qb6_1).j3p();
    var smoothing = this.pb6_1;
    var blendMode = this.tas();
    var program = this.tb6_1;
    var vcount = array.k8m_1;
    var icount = array.l8m_1;
    var matrix = Companion_getInstance_31().t2g_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.k8j_1;
      this_0.d8m(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_7().m8l_1 : program;
      if (this_0.s8m(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.u8l();
      if (!contains(this_0.z8f_1, tex_0)) {
        this_0.y8f_1 = 0;
        this_0.z8f_1[0] = tex_0;
      }
      this_0.a8g_1 = smoothing;
      this_0.b8g_1 = blendMode;
      this_0.c8g_1 = pprogram;
    }
    this_0.p8m(array, matrix, vcount, icount);
  }
  eb7() {
    this.sb6_1.m8r(0, this.wb6(), this.xb6(), this.nb4(), this.ob4(), this.laa(), this.qb6_1, this.uas());
  }
  ran() {
    return Companion_getInstance_29().p2l(this.wb6(), this.xb6(), this.nb4(), this.ob4());
  }
  toString() {
    var out = super.toString();
    if (!this.vb6().equals(Companion_getInstance_26().i2c_1))
      out = out + (':anchor=(' + this.cat(this.vb6().r2c_1) + ', ' + this.cat(this.vb6().s2c_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static abx(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().i2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.jbx(anchor, hitShape, smoothing);
    $this.wb3_1 = false;
    $this.xb3_1 = bitmap;
    $this.zb6();
    return $this;
  }
  static hb4(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().i2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.abx(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  mb4(value) {
    if (equals(this.qb6_1, value))
      return Unit_instance;
    this.wb3_1 = true;
    this.cb7(value);
  }
  e5g() {
    return this.qb6_1;
  }
  zb6() {
    if (this.wb3_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  uan(ctx) {
    this.zb6();
    super.uan(ctx);
  }
  nb4() {
    return this.qb6_1.x2p();
  }
  ob4() {
    return this.qb6_1.y2p();
  }
  c3q() {
    return this.qb6_1.c3q();
  }
  d3q() {
    return this.qb6_1.d3q();
  }
  m3p() {
    return this.qb6_1.m3p();
  }
  n3p() {
    return this.qb6_1.n3p();
  }
  ab7() {
    return this.vb6().r2c_1 * this.m3p();
  }
  bb7() {
    return this.vb6().s2c_1 * this.n3p();
  }
  gar() {
    return this.ab7() - this.c3q();
  }
  har() {
    return this.bb7() - this.d3q();
  }
  ran() {
    return Companion_getInstance_29().p2l(-this.ab7(), -this.bb7(), this.m3p(), this.n3p());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.e5g()));
  }
}
class BaseGraphics extends BaseImage {
  static gb4(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.hb4(tmp$ret$0);
    $this.ab1_1 = autoScaling;
    $this.bb1_1 = true;
    $this.cb1_1 = false;
    $this.db1_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.eb1_1 = ArrayList.i1();
    $this.fb1_1 = new InternalViewAutoscaling();
    $this.gb1_1 = 1;
    $this.hb1_1 = true;
    $this.ib1_1 = true;
    $this.jb1_1 = null;
    $this.kb1_1 = 1.0;
    $this.lb1_1 = 1.0;
    $this.mb1_1 = true;
    $this.nb1_1 = true;
    $this.ob1_1 = Companion_getInstance_29().v2g();
    $this.pb1_1 = Companion_getInstance_29().v2g();
    return $this;
  }
  ib4(value) {
    this.bb1_1 = value;
    this.jb4();
  }
  jb4() {
    this.hb1_1 = true;
    this.ib1_1 = true;
    this.was();
  }
  san() {
    super.san();
    if (this.l2b() == null || this.ea7() == null) {
      var tmp = this.e5g().j3p();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.eb1_1.h(this.e5g().j3p());
      }
      clearBitmaps(this, true);
    }
  }
  uan(ctx) {
    this.jb1_1 = ctx;
    clearBitmaps(this, false);
    this.kb4();
    super.uan(ctx);
  }
  kb4() {
    if (this.fb1_1.fb4(this.ab1_1, this.cb1_1, this.laa())) {
      this.hb1_1 = true;
    }
    if (!this.hb1_1)
      return false;
    this.hb1_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.eb1_1.h(this.e5g().j3p());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.t2d_1 * this.fb1_1.bb4_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.u2d_1 * this.fb1_1.cb4_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.gb1_1 | 0, imageHeight + this.gb1_1 | 0, this.bb1_1, true);
    this.kb1_1 = this.fb1_1.bb4_1;
    this.lb1_1 = this.fb1_1.cb4_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.v43_1;
    if (true) {
      image.e44();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.n4b(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.t5e(this.kb1_1, this.lb1_1);
        ctx.x4x(-boundsWithShapes.r2d_1, -boundsWithShapes.s2d_1);
        this.lb4(ctx);
      }finally {
        ctx.d1b();
      }
    }finally {
      result = true ? image.g44(rect) : 0;
    }
    this.mb4(slice(image));
    return true;
  }
  nb4() {
    return _get_bitmapWidth__ndy7bu(this) / this.kb1_1;
  }
  ob4() {
    return _get_bitmapHeight__5t1vx1(this) / this.lb1_1;
  }
  m3p() {
    return this.nb4();
  }
  n3p() {
    return this.ob4();
  }
  gar() {
    return this.vb6().r2c_1 * this.nb4();
  }
  har() {
    return this.vb6().s2c_1 * this.ob4();
  }
  wb6() {
    return _getLocalBoundsInternal(this, this.mb1_1).r2d_1;
  }
  xb6() {
    return _getLocalBoundsInternal(this, this.mb1_1).s2d_1;
  }
  ran() {
    return _getLocalBoundsInternal$default(this);
  }
  yb6(value) {
    this.nb1_1 = value;
    this.was();
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.mb7_1 = $outer;
    this.ib7_1 = ctx;
    this.jb7_1 = this.ib7_1.i8p(16, 16, VOID, VOID, VOID, false);
    this.kb7_1 = TextureBase.n8j(this.jb7_1.f6z(), 16, 16);
    this.lb7_1 = Texture(this.kb7_1);
  }
  nb7(width, height) {
    this.jb7_1.h6z(0, 0, width, height);
    this.kb7_1.o8j(width);
    this.kb7_1.p8j(height);
    this.lb7_1 = Texture(this.kb7_1);
  }
  t6() {
    this.mb7_1.faq_1 = null;
    this.ib7_1.j8p(this.jb7_1);
  }
}
class ShapeView extends Container {
  static ibd(shape, fill, stroke, strokeThickness, autoScaling, renderer) {
    shape = shape === VOID ? null : shape;
    fill = fill === VOID ? new RGBA(Colors_getInstance().y44_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().y44_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 1.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.cae();
    $this.wb9_1 = addTo(Graphics.fbu(VOID, renderer), $this);
    $this.wb9_1.jbu(autoScaling);
    $this.xb9_1 = anchor$factory($this.wb9_1);
    $this.yb9_1 = antialiased$factory($this.wb9_1);
    $this.zb9_1 = autoScaling$factory($this.wb9_1);
    $this.aba_1 = renderer$factory($this.wb9_1);
    $this.bba_1 = smoothing$factory($this.wb9_1);
    $this.cba_1 = boundsIncludeStrokes$factory($this.wb9_1);
    $this.dba_1 = shape;
    $this.eba_1 = fill;
    $this.fba_1 = stroke;
    $this.gba_1 = numberToDouble(strokeThickness);
    $this.gbd();
    $this.hba_1 = new VectorPath();
    return $this;
  }
  ray(_set____db54di) {
    var this_0 = this.xb9_1;
    anchor$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  vb6() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.xb9_1;
    anchor$factory_1();
    return this_0.get();
  }
  gar() {
    return this.wb9_1.gar();
  }
  har() {
    return this.wb9_1.har();
  }
  c29() {
    return this.dba_1;
  }
  gbd() {
    // Inline function 'korlibs.korge.view.Graphics.updateShape' call
    var this_0 = this.wb9_1;
    var result;
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_1 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
    var shapeView = this;
    var shape = shapeView.c29();
    if (!(shape == null) && shape.r2f()) {
      if (!(shapeView.gba_1 === 0.0)) {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = shapeView.eba_1;
        var stroke = shapeView.fba_1;
        var strokeInfo = new StrokeInfo(shapeView.gba_1);
        // Inline function 'korlibs.korge.view.ShapeView._updateShapeGraphics.<anonymous>.<anonymous>' call
        this_1.s5e(shape);
        if (!(fill == null)) {
          this_1.y4v(fill);
        }
        if (!(stroke == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.c3g_1;
              var lineCap = strokeInfo.f3g_1;
              var lineJoin = strokeInfo.h3g_1;
              var miterLimit = strokeInfo.i3g_1;
              var lineDash = strokeInfo.j3g_1;
              var lineDashOffset = strokeInfo.k3g_1;
              if (false) {
                this_1.m4u();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              this_1.f4w();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                this_1.g4w(numberToDouble(lineWidth));
                this_1.h4w(lineCap);
                this_1.i4w(lineJoin);
                this_1.j4w(numberToDouble(miterLimit));
                this_1.k4w(lineDash);
                this_1.l4w(numberToDouble(lineDashOffset));
                this_1.m4w(stroke);
              }finally {
                this_1.n4w();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = this_1.z4v();
            var lineCap_0 = this_1.a4w();
            var lineJoin_0 = this_1.b4w();
            var miterLimit_0 = this_1.c4w();
            var lineDash_0 = this_1.d4w();
            var lineDashOffset_0 = this_1.e4w();
            if (false) {
              this_1.m4u();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            this_1.f4w();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              this_1.g4w(numberToDouble(lineWidth_0));
              this_1.h4w(lineCap_0);
              this_1.i4w(lineJoin_0);
              this_1.j4w(numberToDouble(miterLimit_0));
              this_1.k4w(lineDash_0);
              this_1.l4w(numberToDouble(lineDashOffset_0));
              this_1.m4w(stroke);
            }finally {
              this_1.n4w();
            }
          }
        }
      } else {
        // Inline function 'korlibs.image.vector.Context2d.fill' call
        var paint = shapeView.eba_1;
        if (true) {
          this_1.m4u();
        }
        // Inline function 'korlibs.korge.view.ShapeView._updateShapeGraphics.<anonymous>.<anonymous>' call
        this_1.s5e(shape);
        this_1.l5t(paint, null);
      }
    }
    result = Unit_instance;
    var tmp$ret$4 = this_1.f4t();
    this_0.dbu(tmp$ret$4);
  }
}
class Circle_0 extends ShapeView {
  static hbd(radius, fill, stroke, strokeThickness, autoScaling, renderer) {
    radius = radius === VOID ? 16.0 : radius;
    fill = fill === VOID ? new RGBA(Colors_getInstance().y44_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().y44_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 0.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.ibd(new VectorPath(), fill, stroke, strokeThickness, autoScaling, renderer);
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var value = numberToDouble(radius);
    var observe = Circle$radius$delegate$lambda($this);
    tmp.cbd_1 = new UIObservable(value, observe);
    $this.dbd_1 = colorMul$factory($this);
    updateGraphics($this);
    return $this;
  }
  jbd(_set____db54di) {
    return this.cbd_1.uav(this, radius$factory(), _set____db54di);
  }
  ebd() {
    return this.cbd_1.tav(this, radius$factory_0());
  }
}
class FixedSizeContainer extends Container {
  static hbi(size, clip) {
    size = size === VOID ? Size2D.o2e(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.cae();
    $this.ebi_1 = clip;
    $this.fbi_1 = size;
    $this.gbi_1 = Ref(false);
    return $this;
  }
  w5u() {
    return this.ebi_1;
  }
  pan() {
    return this.fbi_1;
  }
  ran() {
    return new Rectangle(0.0, 0.0, this.x2p(), this.y2p());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.x2p()) + 'x' + get_niceStr(this.y2p()) + ')');
    return out;
  }
  uan(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.w5u();
      var renderingInternalRef = this.gbi_1;
      if (renderingInternalRef.u1()) {
        super.uan(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.laa();
        var hasRotation = !(m.y2g_1 === 0.0) || !(m.z2g_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.u1();
          try {
            renderingInternalRef.z2y(true);
            renderFiltered(this, ctx, Companion_getInstance_50());
          }finally {
            renderingInternalRef.z2y(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.a8f_1;
        if (!(ctx.e8f_1 === batcher)) {
          ctx.e8f_1 = batcher;
          ctx.o8g();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.c8f_1;
        var bounds = this.nat(ctx).q2m(ctx.q8e_1).r2m();
        var rect = c2d.r8p_1.a8m().m75();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.f2m(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_15().h75(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.r8p_1;
            var scissor_0 = c2d.z8p(scissor);
            var temp = this_0.h8g_1;
            this_0.q8m();
            this_0.h8g_1 = scissor_0;
            try {
              super.uan(ctx);
              break $l$block_1;
            }finally {
              this_0.q8m();
              this_0.h8g_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.uan(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.uan(ctx);
      }
    }
  }
}
class ClipContainer extends FixedSizeContainer {
  static vbf(size) {
    size = size === VOID ? Size2D.o2e(100, 100) : size;
    return this.hbi(size, true);
  }
}
class ZIndexComparator {
  ibi(a, b) {
    return compareTo(a.uar(), b.uar());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.ibi(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.pbi_1 = this$0;
    this.obi_1 = 0;
  }
  b1() {
    return this.obi_1 < this.pbi_1.lbi_1.qaq();
  }
  c1() {
    var _unary__edvuaz = this.obi_1;
    this.obi_1 = _unary__edvuaz + 1 | 0;
    return this.pbi_1.lbi_1.saq(_unary__edvuaz);
  }
  x6() {
    this.obi_1 = this.obi_1 - 1 | 0;
    this.pbi_1.lbi_1.taq(this.obi_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.kbi_1 = children;
    this.lbi_1 = container;
  }
  e1() {
    return this.lbi_1.qaq();
  }
  qbi(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.l2b() === this.lbi_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  a3(elements) {
    return this.qbi(elements);
  }
  g1() {
    return this.lbi_1.qaq() === 0;
  }
  rbi(element) {
    this.lbi_1.waq(element);
    return true;
  }
  h(element) {
    return this.rbi(element instanceof View ? element : THROW_CCE());
  }
  sbi(elements) {
    if (elements.g1())
      return false;
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.lbi_1.waq(element);
    }
    return true;
  }
  f1(elements) {
    return this.sbi(elements);
  }
  a1() {
    return new ContainerCollection$iterator$1(this);
  }
  tbi(element) {
    return this.lbi_1.ear(element);
  }
  o3(element) {
    if (!(element instanceof View))
      return false;
    return this.tbi(element instanceof View ? element : THROW_CCE());
  }
  d1(index) {
    return this.kbi_1.d1(index);
  }
  ubi(element) {
    return this.kbi_1.b3(element);
  }
  b3(element) {
    if (!(element instanceof View))
      return -1;
    return this.ubi(element instanceof View ? element : THROW_CCE());
  }
  c3() {
    return this.kbi_1.c3();
  }
  d3(index) {
    return this.kbi_1.d3(index);
  }
  e3(fromIndex, toIndex) {
    return this.kbi_1.e3(fromIndex, toIndex);
  }
}
class CpuGraphics extends BaseGraphics {
  static bbm(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.gb4(autoScaling);
    $this.tbl_1 = 0;
    $this.ubl_1 = null;
    $this.vbl_1 = true;
    $this.wbl_1 = -1;
    $this.xbl_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.ybl_1 = ArrayList.i1();
    $this.zbl_1 = null;
    $this.abm_1 = null;
    $this.ra1_1 = true;
    return $this;
  }
  cbm(value) {
    this.ubl_1 = value;
    this.tbl_1 = this.tbl_1 + 1 | 0;
    this.jb4();
  }
  fb7(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.abm_1 = tmp_0;
  }
  iar() {
    var tmp0_safe_receiver = this.jar();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  jar() {
    if (!(this.abm_1 == null))
      return this.abm_1;
    if (!(this.wbl_1 === this.tbl_1)) {
      this.wbl_1 = this.tbl_1;
      this.ybl_1.m3();
      var tmp = this.ybl_1;
      var tmp0_safe_receiver = this.ubl_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j4z();
      tmp.h(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.ybl_1;
  }
  lb4(ctx) {
    var tmp0_safe_receiver = this.ubl_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.q4y(ctx);
    }
  }
  yb3(includeStrokes) {
    var tmp0_safe_receiver = this.ubl_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o5u(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_29().d2e_1 : tmp1_elvis_lhs;
  }
}
class DummyView extends View {
  static dbo() {
    return this.ebo();
  }
  uan(ctx) {
    return Unit_instance;
  }
}
class Companion_4 {}
class SContainer extends FixedSizeContainer {
  static rag(size, clip) {
    size = size === VOID ? Size2D.o2e(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.hbi(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.gbo_1 = capacity;
    this.hbo_1 = IntDeque.t2u(this.gbo_1);
    this.ibo_1 = 0;
  }
  e1() {
    return this.hbo_1.e1();
  }
  jbo() {
    return this.hbo_1.e1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.ibo_1 / this.hbo_1.e1());
  }
  kbo() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.jbo());
  }
  lbo(index) {
    return get_fastMicroseconds_0(this.hbo_1.d1(index));
  }
  mbo(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.hbo_1.y2u(intValue);
    this.ibo_1 = this.ibo_1 + intValue | 0;
    if (this.hbo_1.e1() > this.gbo_1) {
      this.ibo_1 = this.ibo_1 - this.hbo_1.bl() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  static fbu(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.cae();
    $this.vbq_1 = null;
    $this.wbq_1 = null;
    $this.xbq_1 = true;
    $this.ybq_1 = false;
    $this.zbq_1 = true;
    $this.abr_1 = true;
    $this.bbr_1 = EmptyShape_instance;
    $this.cbr_1 = renderer;
    $this.dbu(shape);
    return $this;
  }
  gbu() {
    var tmp0_elvis_lhs = this.vbq_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.wbq_1 : tmp0_elvis_lhs);
  }
  yb6(value) {
    var tmp0_safe_receiver = this.vbq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.yb6(value);
    }
    var tmp1_safe_receiver = this.wbq_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.yb6(value);
    }
    this.kaq();
    this.was();
  }
  hbu() {
    var tmp0_safe_receiver = this.vbq_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nb1_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.wbq_1;
      tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.gbt_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  }
  ray(value) {
    _get_anchorable__ebfoik(this).ray(value);
    this.kaq();
  }
  vb6() {
    return _get_anchorable__ebfoik(this).vb6();
  }
  gar() {
    return this.gbu().gar();
  }
  har() {
    return this.gbu().har();
  }
  ebu(value) {
    if (this.xbq_1 === value)
      return Unit_instance;
    this.xbq_1 = value;
    var tmp0_safe_receiver = this.vbq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vbl_1 = value;
    }
    var tmp1_safe_receiver = this.wbq_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ebu(value);
    }
    this.kaq();
  }
  ibu(value) {
    if (this.zbq_1 === value)
      return Unit_instance;
    this.zbq_1 = value;
    var tmp0_safe_receiver = this.vbq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pb6_1 = value;
    }
    var tmp1_safe_receiver = this.wbq_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.fbt_1 = value;
    }
    this.kaq();
  }
  jbu(value) {
    if (this.abr_1 === value)
      return Unit_instance;
    this.abr_1 = value;
    var tmp0_safe_receiver = this.vbq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ab1_1 = value;
    }
    var tmp1_safe_receiver = this.wbq_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.dbt_1 = value;
    }
    this.kaq();
  }
  dbu(value) {
    if (this.bbr_1 === value)
      return Unit_instance;
    this.bbr_1 = value;
    ensure(this);
    var tmp0_safe_receiver = this.vbq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cbm(value);
    }
    var tmp1_safe_receiver = this.wbq_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.dbu(value);
    }
    this.kaq();
  }
  kbu(value) {
    if (this.cbr_1 === value)
      return Unit_instance;
    this.cbr_1 = value;
    this.lbu();
  }
  lbu() {
    ensure(this);
    var tmp0_safe_receiver = this.vbq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jb4();
    }
    var tmp1_safe_receiver = this.vbq_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.kb4();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.c9y_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.ebx(views, currentVfs, sourceFile, $completion) : $super.ebx.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static zbw(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().i2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.abx(bitmap, anchor, hitShape, smoothing);
    $this.ubw_1 = new Mixin_0();
    $this.vbw_1 = sourceFile$factory($this);
    return $this;
  }
  static bbx(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().i2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.zbw(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  static cbx(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().i2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.bbx(slice(bitmap), anchor, hitShape, smoothing);
  }
  uan(ctx) {
    this.dbx(ctx, this);
    super.uan(ctx);
  }
  ebx(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos.bind(VOID, this, views, currentVfs, sourceFile), $completion);
  }
  gbx(_set____db54di) {
    this.ubw_1.xbw_1 = _set____db54di;
  }
  hbx(_set____db54di) {
    this.ubw_1.hbx(_set____db54di);
  }
  ibx() {
    return this.ubw_1.ybw_1;
  }
  wbw(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b.bind(VOID, _this__u8e3s4, this, views, currentVfs, sourceFile), $completion);
  }
  dbx(ctx, view) {
    this.ubw_1.dbx(ctx, view);
  }
}
class RoundRect extends ShapeView {
  static hc0(size, radius, fill, stroke, strokeThickness, autoScaling) {
    fill = fill === VOID ? new RGBA(Colors_getInstance().y44_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().y44_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 0.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.ibd(new VectorPath(), fill, stroke, strokeThickness, autoScaling);
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe = RoundRect$unscaledSize$delegate$lambda($this);
    tmp.ec0_1 = new UIObservable(size, observe);
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe_0 = RoundRect$radius$delegate$lambda($this);
    tmp_0.fc0_1 = new UIObservable(radius, observe_0);
    $this.gc0_1 = colorMul$factory_0($this);
    updateGraphics_0($this);
    return $this;
  }
  ic0(_set____db54di) {
    return this.ec0_1.uav(this, unscaledSize$factory(), _set____db54di);
  }
  pan() {
    return this.ec0_1.tav(this, unscaledSize$factory_0());
  }
  jc0(_set____db54di) {
    return this.fc0_1.uav(this, radius$factory_1(), _set____db54di);
  }
  ebd() {
    return this.fc0_1.tav(this, radius$factory_2());
  }
}
class Companion_5 {}
class Companion_6 {}
class SolidRect extends RectBase {
  static rc2(size, color) {
    color = color === VOID ? Colors_getInstance().y44_1 : color;
    var $this = this.jbx();
    $this.qc2_1 = size;
    $this.m4k(color);
    return $this;
  }
  pan() {
    return this.qc2_1;
  }
  nb4() {
    return this.x2p();
  }
  ob4() {
    return this.y2p();
  }
}
class Stage extends FixedSizeContainer {
  static q9w(views) {
    var $this = this.hbi();
    $this.m9w_1 = views.p9x_1;
    $this.n9w_1 = views;
    $this.o9w_1 = clipBorders$factory($this.fa7());
    $this.p9w_1 = virtualSizeDouble$factory($this.fa7());
    $this.lar($this);
    $this.nar($this);
    return $this;
  }
  fa7() {
    return this.n9w_1;
  }
  sc2(_set____db54di) {
    var this_0 = this.o9w_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  w5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o9w_1;
    clip$factory_0();
    return this_0.get();
  }
  ic0(_set____db54di) {
    var this_0 = this.p9w_1;
    unscaledSize$factory_1();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  pan() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p9w_1;
    unscaledSize$factory_2();
    return this_0.get();
  }
  ea7() {
    return this;
  }
  laq() {
    return this;
  }
  h8i() {
    return this.nbi(this.fa7());
  }
  maq(view) {
    this.fa7().maq(view);
  }
  toString() {
    return 'Stage';
  }
  s17() {
    return this.n9w_1.f9x_1;
  }
  w8n(pos) {
    return this.m9w_1.w8n(pos);
  }
  l8n(value) {
    this.m9w_1.l8n(value);
  }
  m8n() {
    return this.m9w_1.m8n();
  }
  n8n(value) {
    this.m9w_1.n8n(value);
  }
  o8n() {
    return this.m9w_1.o8n();
  }
  p8n(value) {
    this.m9w_1.p8n(value);
  }
  q8n() {
    return this.m9w_1.q8n();
  }
  r8n(value) {
    this.m9w_1.r8n(value);
  }
  s8n() {
    return this.m9w_1.s8n();
  }
  t8n(value) {
    this.m9w_1.t8n(value);
  }
  u8n() {
    return this.m9w_1.u8n();
  }
  v8n() {
    return this.m9w_1.v8n();
  }
}
class Companion_7 {
  constructor() {
    this.uc6_1 = 16.0;
    this.vc6_1 = true;
  }
}
class Text$_renderInternal$slambda {
  constructor(this$0, $ctx, $fontSource) {
    this.vc2_1 = this$0;
    this.wc2_1 = $ctx;
    this.xc2_1 = $fontSource;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this), $completion);
  }
}
class Text extends Container {
  static zc6(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_22.uc6_1 : textSize;
    color = color === VOID ? Colors_getInstance().y44_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_3().s4t_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_22.vc6_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.cae();
    $this.gc5_1 = true;
    $this.hc5_1 = -1;
    $this.ic5_1 = -1;
    $this.jc5_1 = 0;
    $this.kc5_1 = 0;
    $this.lc5_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.mc5_1 = fill == null ? new RGBA(color) : fill;
    $this.nc5_1 = stroke;
    $this.oc5_1 = font;
    $this.pc5_1 = numberToDouble(textSize);
    $this.qc5_1 = textSize$factory($this);
    $this.rc5_1 = 0;
    $this.sc5_1 = 2147483647;
    $this.tc5_1 = renderer;
    $this.uc5_1 = alignment;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.vc5_1 = addTo(this_0, $this);
    $this.wc5_1 = new Text2TextRendererActions();
    $this.xc5_1 = false;
    $this.yc5_1 = autoScaling;
    $this.zc5_1 = false;
    $this.ac6_1 = null;
    $this.bc6_1 = Companion_getInstance_29().o2l(0, 0, 2048, 2048);
    $this.cc6_1 = true;
    $this.dc6_1 = -1;
    $this.ec6_1 = new MMatrix();
    $this.fc6_1 = -1;
    $this.gc6_1 = null;
    $this.hc6_1 = new Entry();
    $this.ic6_1 = new FontMetrics();
    $this.jc6_1 = new TextMetrics();
    $this.kc6_1 = null;
    $this.lc6_1 = null;
    $this.mc6_1 = null;
    $this.nc6_1 = null;
    $this.oc6_1 = new MMatrix();
    $this.pc6_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.qc6_1 = true;
    $this.rc6_1 = null;
    $this.sc6_1 = fontSource$factory($this);
    return $this;
  }
  ac7(value) {
    if (!(this.lc5_1 === value)) {
      this.lc5_1 = value;
      updateLineCount(this);
      this.oaq();
      this.kaq();
    }
  }
  wc6() {
    return this.lc5_1;
  }
  bc7(value) {
    if (!equals(this.mc5_1, value)) {
      this.mc5_1 = value;
      this.oaq();
    }
  }
  cc7(value) {
    this.bc7(new RGBA(value));
  }
  o5b() {
    var tmp = this.mc5_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.u4k_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().y44_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  yc6(value) {
    if (!equals(this.oc5_1, value)) {
      this.oc5_1 = value;
      this.oaq();
    }
  }
  dc7(value) {
    if (!(this.pc5_1 === value)) {
      this.pc5_1 = value;
      this.oaq();
    }
  }
  ec7(_set____db54di) {
    var this_0 = this.qc5_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  p4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.qc5_1;
    fontSize$factory_0();
    return this_0.get();
  }
  oaq() {
    this.jc5_1 = this.jc5_1 + 1 | 0;
    super.oaq();
  }
  fc7(value) {
    if (!this.uc5_1.equals(value)) {
      this.uc5_1 = value;
      this.oaq();
    }
  }
  f5t() {
    return this.uc5_1.k4v_1;
  }
  z5p() {
    return this.uc5_1.l4v_1;
  }
  xc6(value) {
    this.ac6_1 = value;
    this.xc5_1 = false;
    this.oaq();
  }
  tc6(currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadFontSource__wlrz09.bind(VOID, this, currentVfs, sourceFile), $completion);
  }
  ran() {
    this.gc7(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.ran();
    } else {
      return this.bc6_1;
    }
  }
  uan(ctx) {
    this.gc7(ctx);
    var tva = this.nc6_1;
    if (!(tva == null)) {
      this.ec6_1.e3x(this.laa());
      this.ec6_1.i3x(this.vc5_1.o6p(), this.vc5_1.p6p());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.a8f_1;
      var this_1 = this_0.j8f_1;
      if (!(this_1.e8f_1 === this_0)) {
        this_1.e8f_1 = this_0;
        this_1.o8g();
      }
      var tmp = this.oc5_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.t4n();
      this_0.u8m(tex, this.gc5_1, this.tas(), get_agProgram(bmpfont), tva.l8m_1, tva.k8m_1);
      this_0.p8m(tva, this.ec6_1.c3x());
    } else {
      super.uan(ctx);
    }
  }
  gc7(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.ac6_1;
      if (!this.xc5_1 && !(fontSource == null)) {
        this.xc5_1 = true;
        launchImmediately_0(ctx.g8e_1, Text$_renderInternal$slambda_0(this, ctx, fontSource));
      }
    }
    var font = this.oc5_1.v11();
    var tmp;
    var tmp_0;
    if (this.cc6_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.dc6_1 === this.jc5_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.dc6_1 = this.jc5_1;
      var metrics = getTextBounds(font, this.pc5_1, this.wc6(), this.jc6_1, this.tc5_1, this.uc5_1);
      this.bc6_1 = new Rectangle(metrics.y2d(), VerticalAlign__getOffsetY_impl_iso0y6(this.uc5_1.l4v_1, metrics.y2p(), -metrics.s4v()), metrics.x2p(), font.x4n(this.pc5_1, this.ic6_1).t4m() * this.kc5_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.tc5_1.s5o();
        if (!(this.lc6_1 === this.gc5_1) || !(this.hc5_1 === this.jc5_1) || !(this.ic5_1 === rversion)) {
          this.lc6_1 = this.gc5_1;
          this.ic5_1 = rversion;
          this.hc5_1 = this.jc5_1;
          if (!(this.rc6_1 == null)) {
            this.rc6_1 = null;
            this.vc5_1.vaq();
          }
          this.wc5_1.d5q();
          this.wc5_1.q5p_1 = Companion_getInstance_3().w4t_1;
          invoke(this.tc5_1, this.wc5_1, this.wc6(), this.pc5_1, font);
          while (this.vc5_1.qaq() < this.wc5_1.e1()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.vc5_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_26().i2c_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image.bbx(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.vc5_1.qaq() > this.wc5_1.e1()) {
            this.vc5_1.d1(this.vc5_1.qaq() - 1 | 0).hat();
          }
          var bounds = this.wc5_1.k3i();
          var firstBounds = this.wc5_1.b5q(0);
          var lineInfos = this.wc5_1.a5q();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var tmp0_iterator = lineInfos.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.z5o_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.t2d_1;
          var textHeight = bounds.u2d_1;
          var dx = this.cc6_1 ? this.bc6_1.r2d_1 : this.bc6_1.r2d_1 + 1 + (this.bc6_1.t2d_1 - textWidth) * _HorizontalAlign___get_ratio__impl__x9wlea(this.f5t());
          var tmp_2;
          if (this.cc6_1) {
            tmp_2 = this.bc6_1.s2d_1 + firstLineInfos.x5o_1;
          } else {
            var tmp2_subject = this.z5p();
            tmp_2 = equals(tmp2_subject, Companion_getInstance_4().g5o_1) ? this.bc6_1.s2d_1 : this.bc6_1.s2d_1 + firstLineInfos.x5o_1 + (this.bc6_1.u2d_1 - totalHeight) * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.z5p());
          }
          var dy = tmp_2;
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.wc5_1.e1();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.wc5_1.c5q(n, this.hc6_1);
              var tmp_3 = this.vc5_1.d1(n);
              var it = tmp_3 instanceof Image ? tmp_3 : THROW_CCE();
              it.tb6_1 = program;
              it.m4k(this.o5b());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.v2c(numberToDouble(0), numberToDouble(0)));
              it.pb6_1 = this.gc5_1;
              it.mb4(entry.a5p_1);
              it.d4y(Vector2D.q2f(entry.b5p_1 + dx, entry.c5p_1 + dy));
              it.bas(Scale.b2l(entry.d5p_1, entry.e5p_1));
              it.fas(entry.f5p_1);
              var containsLower = this.rc5_1;
              it.z8w(n < this.sc5_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.lc6_1 === this.gc5_1) || !(this.mc6_1 === this.qc6_1)) {
          this.jc5_1 = this.jc5_1 + 1 | 0;
          this.mc6_1 = this.qc6_1;
          this.kc6_1 = this.yc5_1;
          this.lc6_1 = this.gc5_1;
        }
        if (!(this.hc5_1 === this.jc5_1)) {
          this.hc5_1 = this.jc5_1;
          var realTextSize = this.pc5_1;
          if (this.rc6_1 == null) {
            this.vc5_1.vaq();
            var tmp_4 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.vc5_1;
            var renderer = this.pc6_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(Graphics.fbu(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).f4t();
            this_3.dbu(tmp$ret$10);
            this_3.lbu();
            tmp_4.rc6_1 = this_3;
            var tmp3_safe_receiver = this.rc6_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.jbu(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.rc6_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.wc6();
          var tmp1_pos = Companion_getInstance_28().j2d_1;
          var tmp2_paint = this.o5b();
          var tmp3_renderer = this.tc5_1;
          var tmp4_align = this.uc5_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.mc5_1;
          var tmp7_stroke = this.nc5_1;
          var tmp8_textRangeStart = this.rc5_1;
          var tmp9_textRangeEnd = this.sc5_1;
          result_0 = this_5.p5t(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$16 = this_5.f4t();
          this_4.dbu(tmp$ret$16);
          var metrics_0 = result_0;
          this.fc6_1 = this.jc5_1;
          this.gc6_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_28().j2d_1, font.x4n(this.p4n(), this.ic6_1).n4m_1);
        }
        var tmp4_safe_receiver = this.rc6_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.ibu(this.gc5_1);
        }
      }
    }
  }
}
class ColorReference {}
class Companion_8 {
  hc7(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l2b();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l2b();
      }
    }
    return null;
  }
}
class ViewRenderPhase {}
function render_0(view, ctx) {
  return view.aat(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.qc7_1 = $view;
    this.rc7_1 = $ctx;
    this.sc7_1 = this$0;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.xbw_1 = true;
    this.ybw_1 = null;
  }
  gbx(_set____db54di) {
    this.xbw_1 = _set____db54di;
  }
  hbx(value) {
    this.xbw_1 = false;
    this.ybw_1 = value;
  }
  wbw(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.hbx(sourceFile);
    _this__u8e3s4.gbx(true);
  }
  ebx(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.ee('An operation is not implemented: ' + reason);
  }
  dbx(ctx, view) {
    if (this.xbw_1)
      return Unit_instance;
    this.tc7(ctx, view);
  }
  tc7(ctx, view) {
    if (!this.xbw_1 && !(this.ybw_1 == null)) {
      this.xbw_1 = true;
      launchImmediately_0(ctx.g8e_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.uc7_1 = this$0;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_21.bind(VOID, this), $completion);
  }
}
class Views extends BaseEventListener {
  static ea5(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_7().f8l_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.j6l();
    $this.e9x_1 = new Mixin();
    $this.f9x_1 = coroutineContext;
    $this.g9x_1 = ag;
    $this.h9x_1 = injector;
    $this.i9x_1 = input;
    $this.j9x_1 = timeProvider;
    $this.k9x_1 = stats;
    $this.l9x_1 = gameWindow;
    $this.m9x_1 = gameId;
    $this.n9x_1 = settingsFolder;
    $this.o9x_1 = batchMaxQuads;
    $this.p9x_1 = bp;
    $this.q9x_1 = stageBuilder;
    $this.r9x_1 = quality$factory($this.l9x_1);
    $this.s9x_1 = $this;
    $this.t9x_1 = false;
    $this.u9x_1 = continuousRenderMode$factory($this.l9x_1);
    $this.v9x_1 = new ReshapeEvent(0, 0);
    $this.w9x_1 = new UpdateEvent();
    $this.x9x_1 = new ViewsUpdateEvent($this);
    $this.y9x_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.z9x_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.b9y_1 = null;
    $this.c9y_1 = get_resourcesVfs();
    $this.d9y_1 = get_RegisteredImageFormats();
    $this.e9y_1 = new RenderContext($this.g9x_1, $this, $this.l9x_1, $this.k9x_1, $this.f9x_1, $this.o9x_1, $this.l9x_1);
    $this.f9y_1 = true;
    $this.g9y_1 = Colors_getInstance().z44_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.h9y_1 = HashMap.y8();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.i9y_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.j9y_1 = new Resources($this.f9x_1, $this.c9y_1);
    $this.k9y_1 = false;
    $this.l9y_1 = 1280;
    $this.m9y_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.n9y_1 = ArrayList.i1();
    $this.o9y_1 = Companion_getInstance_25().q2n_1;
    $this.p9y_1 = Companion_getInstance_26().m2c_1;
    $this.q9y_1 = true;
    $this.r9y_1 = $this.q9x_1($this);
    $this.s9y_1 = $this.r9y_1;
    $this.t9y_1 = true;
    $this.u9y_1 = false;
    $this.v9y_1 = debugExtraFontScale$factory($this.e9y_1);
    $this.w9y_1 = debugExtraFontColor$factory($this.e9y_1);
    $this.x9y_1 = FastArrayList.j11();
    $this.y9y_1 = $this.j9x_1.i1y();
    var tmp_4 = $this;
    tmp_4.z9y_1 = Pool.r2x(VOID, Views$tempViewsPool$lambda);
    $this.a9z_1 = SizeInt.e2o();
    $this.b9z_1 = SizeInt.e2o();
    $this.c9z_1 = SizeInt.e2o();
    $this.d9z_1 = new Signal();
    $this.e9z_1 = new Signal();
    $this.f9z_1 = -1.0;
    $this.h9x_1.a6i(getKClass(CoroutineContext), $this.f9x_1);
    $this.h9x_1.a6i(getKClass(AG), $this.g9x_1);
    $this.h9x_1.a6i(getKClass(Views), $this);
    $this.e9z_1.q22(Views$lambda($this));
    $this.d9z_1.q22(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.g9z_1 = Companion_instance_11.oi('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.h9z_1 = new EventResult();
    $this.i9z_1 = new Signal();
    $this.j9z_1 = Companion_getInstance_0().iz('debugHightlightView');
    $this.k9z_1 = new Signal();
    $this.l9z_1 = new Signal();
    $this.m9z_1 = ArrayList.i1();
    $this.n9z_1 = updatedSinceFrame$factory($this.l9x_1);
    return $this;
  }
  s17() {
    return this.f9x_1;
  }
  fa7() {
    return this.s9x_1;
  }
  pa5(_set____db54di) {
    var this_0 = this.u9x_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  ja5() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u9x_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  wc7() {
    return replace(replace(replace(this.m9x_1, '\\', ''), '/', ''), '..', '');
  }
  maa() {
    var tmp = this.a9y_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  n2a($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this), $completion);
  }
  oa5() {
    return this.j9y_1;
  }
  qa5() {
    return this.g9x_1.k6u().d6u_1;
  }
  ra5() {
    return this.g9x_1.k6u().e6u_1;
  }
  xc7(value) {
    this.l9y_1 = numberToInt(value);
  }
  yc7() {
    return this.l9y_1;
  }
  zc7(value) {
    this.m9y_1 = numberToInt(value);
  }
  ac8() {
    return this.m9y_1;
  }
  uc2(value) {
    this.xc7(value.m2e_1);
    this.zc7(value.n2e_1);
  }
  tc2() {
    return Size2D.u2l(this.yc7(), this.ac8());
  }
  t6() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  vc7($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw.bind(VOID, this), $completion);
  }
  ga7() {
    return this.r9y_1.h8i();
  }
  fa5(_set____db54di) {
    var this_0 = this.v9y_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  bc8() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v9y_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  ga5(_set____db54di) {
    var this_0 = this.w9y_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  cc8() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w9y_1;
    debugFontColor$factory_0();
    return this_0.get().u4k_1;
  }
  fbo(block) {
    this.x9y_1.h(block);
  }
  n6l(type, event, result, up, down) {
    event.g6m(false);
    var result_0 = super.n6l(type, event, result, up, down);
    var e = event;
    e.f6m(this.s9x_1);
    if (e instanceof KeyEvent) {
      this.i9x_1.o8i(e);
      this.i9x_1.v8h_1.f8h(e);
      if (e.d6n_1.equals(Type_UP_getInstance_0()) && this.t9y_1 && (e.f6n_1.equals(Key_F12_getInstance()) || e.f6n_1.equals(Key_F7_getInstance()))) {
        this.u9y_1 = !this.u9y_1;
        this.l9x_1.d8x(this.u9y_1);
        this.maq(this.r9y_1);
      }
    }
    try {
      return this.r9y_1.w6l(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  dc8(frameBuffer) {
    this.e9y_1.f8f_1 = frameBuffer;
    if (this.f9y_1) {
      var tmp0_$this = this.e9y_1;
      var tmp1_color = this.g9y_1;
      tmp0_$this.d8p(tmp1_color, 1.0, 0, true, true, true);
    }
    this.d9z_1.r22(this.e9y_1);
    this.e9y_1.o8g();
    this.r9y_1.qan(this.e9y_1);
    this.e9y_1.o8g();
    this.r9y_1.yaq(this.e9y_1);
    if (this.u9y_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.x9y_1.h11_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.e9y_1);
      }
    }
    this.e9z_1.r22(this.e9y_1);
    this.e9y_1.o8g();
  }
  ec8(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.g9x_1.k6u() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.dc8(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.dc8.call(this, frameBuffer);
    }
    return tmp;
  }
  fc8() {
    this.g9x_1.o6u();
    this.ec8();
  }
  ka5(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.j9x_1.i1y();
    this.s9x_1.k9x_1.o6u();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_37().y9t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.y9y_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.s9x_1.i9y_1) > 0 ? this.s9x_1.i9y_1 : delta;
    this.y9y_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.l1z())) {
        this.hc8(fixedSizeStep);
      } else {
        this.gc8(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.ic8() > 0);
    if (doRender2) {
      if (this.g9z_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_6().k1y().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.ic8() + ']');
      }
      this.fc8();
      this.o6u();
    }
  }
  gc8(elapsed) {
    return this.hc8(get_fast(elapsed));
  }
  hc8(elapsed) {
    this.i9x_1.m8i(elapsed);
    this.h9z_1.j2y();
    updateSingleViewWithViewsAll(this.r9y_1, this, elapsed);
    this.i9x_1.n8i(elapsed);
  }
  ia5() {
  }
  na5(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.b9z_1 = SizeInt.d2o(actualWidth, actualHeight);
    this.jc8();
  }
  jc8() {
    setBoundsInfo(this.p9x_1, Size2D.o2e(this.l9y_1, this.m9y_1), toFloat(this.b9z_1), this.o9y_1, this.p9y_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.e9y_1.m8e_1 = this.p9x_1.q8n();
    this.e9y_1.n8e_1 = this.p9x_1.m8n();
    // Inline function 'kotlin.also' call
    var this_0 = this.v9x_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.x6m_1 = this.b9z_1.b2o_1;
    this_0.y6m_1 = this.b9z_1.c2o_1;
    this.w6l(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.y9x_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.nc8_1 = this.a9z_1;
    this.w6l(this_1);
    this.r9y_1.oaq();
  }
  oc8(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.l9x_1.e8x())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.j9z_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.i9z_1.r22(viewToHightlight);
  }
  kaa(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.oc8(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.oc8.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  pc8(_set____db54di) {
    var this_0 = this.n9z_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  ic8() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n9z_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  o6u() {
    this.l9x_1.o6u();
  }
  maq(view) {
    this.l9x_1.s8x();
  }
  r10(value) {
    this.e9x_1.r10(value);
  }
  s10() {
    return this.e9x_1.s10();
  }
  w8n(pos) {
    return this.p9x_1.w8n(pos);
  }
  l8n(value) {
    this.p9x_1.l8n(value);
  }
  m8n() {
    return this.p9x_1.m8n();
  }
  n8n(value) {
    this.p9x_1.n8n(value);
  }
  o8n() {
    return this.p9x_1.o8n();
  }
  p8n(value) {
    this.p9x_1.p8n(value);
  }
  q8n() {
    return this.p9x_1.q8n();
  }
  r8n(value) {
    this.p9x_1.r8n(value);
  }
  s8n() {
    return this.p9x_1.s8n();
  }
  t8n(value) {
    this.p9x_1.t8n(value);
  }
  u8n() {
    return this.p9x_1.u8n();
  }
  v8n() {
    return this.p9x_1.v8n();
  }
  n8p() {
    return this.l9x_1.n8p();
  }
  o8p() {
    return this.l9x_1.o8p();
  }
  p8p() {
    return this.l9x_1.p8p();
  }
  y8o() {
    return this.l9x_1.y8o();
  }
}
class Companion_9 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.k1z() : fastDelta;
    super();
    this.nc7_1 = views;
    this.oc7_1 = fastDelta;
  }
  pc7() {
    return toDuration_0(this.oc7_1);
  }
  i2h() {
    return Companion_instance_24;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.oc7_1) + ')';
  }
}
class Companion_10 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.d2o(0, 0) : size;
    super();
    this.mc8_1 = views;
    this.nc8_1 = size;
  }
  i2h() {
    return Companion_instance_25;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.nc8_1.toString() + ')';
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.qc8_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  rc8(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.qc8_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_33().i2g_1;
}
class RenderToTextureResult {
  constructor() {
    this.vc8_1 = null;
    this.wc8_1 = 0;
    this.xc8_1 = 0;
    this.yc8_1 = 0;
    this.zc8_1 = 0;
    this.ac9_1 = 1.0;
    this.bc9_1 = Companion_getInstance_31().s2g_1;
    this.cc9_1 = null;
    this.dc9_1 = null;
    this.ec9_1 = null;
    this.fc9_1 = null;
  }
  d1b() {
    if (this.dc9_1 == null || this.fc9_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.dc9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.fc9_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.j8p(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.vc8_1 = null;
    this.cc9_1 = null;
    this.dc9_1 = null;
    this.fc9_1 = null;
    this.ec9_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_50();
    this.gc9_1 = smoothing;
  }
  uc8(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a8f_1;
    var this_1 = this_0.j8f_1;
    if (!(this_1.e8f_1 === this_0)) {
      this_1.e8f_1 = this_0;
      this_1.o8g();
    }
    this_0.q8g(texture, VOID, VOID, VOID, VOID, matrix, this.gc9_1, renderColorMul, blendMode, Companion_getInstance_7().m8l_1);
  }
}
class Companion_12 extends IdentityFilter {
  constructor() {
    Companion_instance_27 = null;
    super(true);
    Companion_instance_27 = this;
  }
}
class ViewRenderPhaseBackdropFilter {}
class ViewRenderPhaseFilter {}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.tca_1 = bounds;
    this.uca_1 = vertexCount;
    this.vca_1 = vertexStart;
    this.wca_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  static cbu(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.ebo();
    $this.dbt_1 = autoScaling;
    $this.ebt_1 = true;
    $this.fbt_1 = true;
    $this.gbt_1 = true;
    $this.hbt_1 = new GpuShapeViewCommands();
    $this.ibt_1 = 1000;
    $this.jbt_1 = 1000;
    $this.kbt_1 = Companion_getInstance_26().i2c_1;
    $this.lbt_1 = true;
    $this.mbt_1 = false;
    $this.nbt_1 = antialiased;
    $this.obt_1 = shape;
    $this.pbt_1 = false;
    $this.qbt_1 = false;
    $this.rbt_1 = false;
    $this.sbt_1 = 0;
    $this.tbt_1 = Companion_getInstance_29().v2g();
    $this.ubt_1 = Companion_getInstance_29().v2g();
    $this.vbt_1 = false;
    $this.wbt_1 = 1.0;
    $this.xbt_1 = NaN;
    $this.ybt_1 = Companion_getInstance_31().v2g();
    $this.zbt_1 = 100000;
    $this.abu_1 = false;
    $this.bbu_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  yb6(value) {
    this.gbt_1 = value;
    this.was();
  }
  ray(value) {
    this.kbt_1 = value;
    this.oaq();
  }
  vb6() {
    return this.kbt_1;
  }
  ebu(value) {
    this.nbt_1 = value;
    invalidateShape(this);
  }
  dbu(value) {
    this.obt_1 = value;
    invalidateShape(this);
  }
  gar() {
    return _get_shapeBounds__actvvf(this).t2d_1 * this.vb6().r2c_1;
  }
  har() {
    return _get_shapeBounds__actvvf(this).u2d_1 * this.vb6().s2c_1;
  }
  oaq() {
    super.oaq();
    invalidateShape(this);
  }
  ran() {
    return new Rectangle(_get_shapeBounds__actvvf(this).r2d_1 - this.gar(), _get_shapeBounds__actvvf(this).s2d_1 - this.har(), _get_shapeBounds__actvvf(this).t2d_1, _get_shapeBounds__actvvf(this).u2d_1);
  }
  yca(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.b5v_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.g1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.yca(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.yca(_this__u8e3s4.u5v());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.z5u();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  uan(ctx) {
    this.wbt_1 = this.laa().f2i().d2j() * ctx.d8e_1.v8n();
    if (!(this.xbt_1 === this.wbt_1)) {
      invalidateShape(this);
    }
    ctx.o8g();
    var doRequireTexture = this.yca(this.obt_1);
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.rj();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.c8e_1.k6u();
      this.ibt_1 = currentFrameBuffer.d6u_1;
      this.jbt_1 = currentFrameBuffer.e6u_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.ibt_1;
      var height = this.jbt_1;
      ctx.o8g();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.i8p(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.k8p(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.a8f_1;
          var this_1 = this_0.j8f_1;
          if (!(this_1.e8f_1 === this_0)) {
            this_1.e8f_1 = this_0;
            this_1.o8g();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor.e75(0, 0, rb.d6u_1, rb.e6u_1);
            var temp = this_0.h8g_1;
            this_0.q8m();
            this_0.h8g_1 = scissor;
            try {
              if (true) {
                ctx.d8p(Colors_getInstance().d45_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.q8m();
              this_0.h8g_1 = temp;
            }
          }
        }finally {
          ctx.l8p();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture_0(rb).r3p(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.a8f_1;
        var this_3 = this_2.j8f_1;
        if (!(this_3.e8f_1 === this_2)) {
          this_3.e8f_1 = this_2;
          this_3.o8g();
        }
        this_2.q8g(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.d8e_1.m8n()));
        ctx.o8g();
      }finally {
        ctx.j8p(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.zca_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.zca_1.toString() + ')';
  }
  hashCode() {
    return this.zca_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.zca_1.equals(tmp0_other_with_cast.zca_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.acb_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.acb_1 + ')';
  }
  hashCode() {
    return this.acb_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.acb_1 === tmp0_other_with_cast.acb_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_17().y73_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_23().o6v_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().l6v_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_19().j6v_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_22().z6v_1 : cullFace;
    this.bcb_1 = drawType;
    this.ccb_1 = vertexIndex;
    this.dcb_1 = vertexEnd;
    this.ecb_1 = paintShader;
    this.fcb_1 = program;
    this.gcb_1 = colorMask;
    this.hcb_1 = stencilOpFunc;
    this.icb_1 = stencilRef;
    this.jcb_1 = blendMode;
    this.kcb_1 = cullFace;
  }
  y8l() {
    return this.dcb_1 - this.ccb_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.bcb_1) + ', vertexIndex=' + this.ccb_1 + ', vertexEnd=' + this.dcb_1 + ', paintShader=' + toString_0(this.ecb_1) + ', program=' + toString_0(this.fcb_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.gcb_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.hcb_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.icb_1) + ', blendMode=' + toString_0(this.jcb_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.kcb_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.bcb_1);
    result = imul(result, 31) + this.ccb_1 | 0;
    result = imul(result, 31) + this.dcb_1 | 0;
    result = imul(result, 31) + (this.ecb_1 == null ? 0 : this.ecb_1.hashCode()) | 0;
    result = imul(result, 31) + (this.fcb_1 == null ? 0 : this.fcb_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.gcb_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.hcb_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.icb_1) | 0;
    result = imul(result, 31) + (this.jcb_1 == null ? 0 : this.jcb_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.kcb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.bcb_1 === tmp0_other_with_cast.bcb_1))
      return false;
    if (!(this.ccb_1 === tmp0_other_with_cast.ccb_1))
      return false;
    if (!(this.dcb_1 === tmp0_other_with_cast.dcb_1))
      return false;
    if (!equals(this.ecb_1, tmp0_other_with_cast.ecb_1))
      return false;
    if (!equals(this.fcb_1, tmp0_other_with_cast.fcb_1))
      return false;
    if (!(this.gcb_1 === tmp0_other_with_cast.gcb_1))
      return false;
    if (!(this.hcb_1 === tmp0_other_with_cast.hcb_1))
      return false;
    if (!equals(this.icb_1, tmp0_other_with_cast.icb_1))
      return false;
    if (!equals(this.jcb_1, tmp0_other_with_cast.jcb_1))
      return false;
    if (!(this.kcb_1 === tmp0_other_with_cast.kcb_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.jc9_1 = 0;
    this.kc9_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.lc9_1 = ArrayList.i1();
    this.mc9_1 = null;
    this.nc9_1 = FastArrayList.j11();
    this.oc9_1 = 0;
    this.pc9_1 = 0;
    this.qc9_1 = MatrixTransform.b2j();
    this.rc9_1 = FastArrayList.j11();
    this.sc9_1 = AGTextureUnits.z6x();
  }
  m3() {
    this.jc9_1 = 0;
    this.kc9_1.m3();
    this.lc9_1.m3();
  }
  xc9(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.oc9_1;
      this.oc9_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.kc9_1.y2r(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.jc9_1;
    this.jc9_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  wc9() {
    this.pc9_1 = this.jc9_1;
    return this.pc9_1;
  }
  yc9() {
    return this.jc9_1;
  }
  xca(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.lc9_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.h(element);
  }
  sca(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_23().o6v_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().l6v_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_19().j6v_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_14().h8d_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_22().z6v_1 : cullFace;
    startIndex = startIndex === VOID ? this.pc9_1 : startIndex;
    endIndex = endIndex === VOID ? this.jc9_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.xca(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.xca.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  k7k(i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.lc9_1;
    var element = new ClearCommand(i);
    this_0.h(element);
  }
  tc9(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.k7k(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.k7k.call(this, i);
    }
    return tmp;
  }
  uc9(scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.lc9_1;
    var element = new ScissorCommand(scissor);
    this_0.h(element);
  }
  m6u() {
    var tmp0_safe_receiver = this.mc9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.nc9_1.h(tmp0_safe_receiver);
    }
    this.mc9_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.kc9_1.d2s())));
  }
  vc9(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.mc9_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.w8e_1.c8l(this.nc9_1);
    this.nc9_1.m3();
    ctx.o8g();
    var ag = ctx.c8e_1;
    var vao = AGVertexArrayObject.j73(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().ica_1, ctx.z8k(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a8f_1;
    var this_1 = this_0.j8f_1;
    if (!(this_1.e8f_1 === this_0)) {
      this_1.e8f_1 = this_0;
      this_1.o8g();
    }
    this_0.z8m();
    var tempMat = (doRequireTexture ? Companion_getInstance_31().s2g_1 : this_0.w8l()).d2i(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.j8f_1;
    this_2.o8g();
    var temp4 = this_2.p8e_1;
    var temp2d = this_2.q8e_1;
    this_2.q8e_1 = tempMat;
    this_2.p8e_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.q71(ProjViewUB_getInstance());
      var _unary__edvuaz = this_3.f73();
      this_3.x7p(_unary__edvuaz + 1 | 0);
      this_3.y7p(this_3.f73() + 1 | 0);
      var blockSize = this_3.j71_1;
      var index0 = imul(this_3.f73() - 1 | 0, blockSize);
      var index1 = imul(this_3.f73(), blockSize);
      var texBlockSize = this_3.g71_1.f79().e1();
      var texIndex0 = imul(this_3.f73() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.f73(), texBlockSize);
      if (this_3.f73() > 0) {
        arraycopy(this_3.l71_1, index0, this_3.l71_1, index1, blockSize);
      } else {
        arrayfill(this_3.l71_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.g71_1;
      this_3.m71_1.h7q($this$push.e79(), this_2.p8e_1);
      if (true && this_3.f73() >= 1) {
        var equals = arrayequal(this_3.l71_1, index0, this_3.l71_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_3.f73();
          this_3.x7p(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.qc9_1 = globalMatrix.f2i();
      var program = GpuShapeViewPrograms_getInstance().pca_1;
      var scissor = Companion_getInstance_15().x6v_1;
      var this_4 = this.lc9_1;
      var n = 0;
      while (n < this_4.e1()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_4.d1(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.zca_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.acb_1;
            ctx.d8p(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.ecb_1;
              this_0.f8n(cmd.y8l());
              var pixelScale = this.qc9_1.d2j() / ctx.d8e_1.v8n();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.j8f_1.q71(ShapeViewUB_getInstance());
                  var _unary__edvuaz_2 = this_5.f73();
                  this_5.x7p(_unary__edvuaz_2 + 1 | 0);
                  this_5.y7p(this_5.f73() + 1 | 0);
                  var blockSize_0 = this_5.j71_1;
                  var index0_0 = imul(this_5.f73() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.f73(), blockSize_0);
                  var texBlockSize_0 = this_5.g71_1.f79().e1();
                  var texIndex0_0 = imul(this_5.f73() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.f73(), texBlockSize_0);
                  if (this_5.f73() > 0) {
                    arraycopy(this_5.l71_1, index0_0, this_5.l71_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(this_5.l71_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.g71_1;
                  var it = this_5.m71_1;
                  it.b7q(paintShader.lcb_1);
                  it.c7q($this$push_0.acc(), pixelScale);
                  it.e7q($this$push_0.bcc(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && this_5.f73() >= 1) {
                    var equals_0 = arrayequal(this_5.l71_1, index0_0, this_5.l71_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = this_5.f73();
                      this_5.x7p(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.mcb_1 == null)) {
                  var tex = ctx.s8e_1.t2x();
                  tex.x6z(paintShader.mcb_1);
                  this.sc9_1.q6y(DefaultShaders_getInstance().y7b(), tex);
                  this.rc9_1.h(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.fcb_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.f8f_1.w6t_1;
              var tmp5_frameBufferInfo = ctx.f8f_1.d6w();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.u8o(_program);
              var tmp8_textureUnits = this.sc9_1.o10();
              var tmp9_stencilOpFunc = cmd.hcb_1;
              var tmp10_stencilRef = cmd.icb_1;
              var tmp11_colorMask = cmd.gcb_1;
              var tmp3_elvis_lhs = cmd.jcb_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_14().h8d_1 : tmp3_elvis_lhs).r8g_1;
              var tmp13_cullFace = cmd.kcb_1;
              var tmp14_drawType = cmd.bcb_1;
              var tmp15_drawOffset = cmd.ccb_1;
              var tmp16_vertexCount = cmd.y8l();
              draw(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.o8g();
      this_2.p8e_1 = temp4;
      this_2.q8e_1 = temp2d;
      this_2.q71(ProjViewUB_getInstance()).z7p();
    }
    var _iterator__ex2g4s = this.rc9_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var tex_0 = _iterator__ex2g4s.c1();
      ctx.s8e_1.u2x(tex_0);
    }
    this.rc9_1.m3();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    this.scb_1 = this.k79().c79(this, u_ProgramType$factory());
    this.tcb_1 = this.m79().c79(this, u_Color$factory());
    this.ucb_1 = this.m79().c79(this, u_ColorMul$factory());
    this.vcb_1 = this.k79().c79(this, u_GlobalAlpha$factory());
    this.wcb_1 = this.k79().c79(this, u_GlobalPixelScale$factory());
    this.xcb_1 = this.s78().c79(this, u_Transform$factory());
    this.ycb_1 = this.m79().c79(this, u_Gradientp0$factory());
    this.zcb_1 = this.m79().c79(this, u_Gradientp1$factory());
  }
  ccc() {
    return this.scb_1.wo(this, u_ProgramType$factory_0());
  }
  dcc() {
    return this.tcb_1.wo(this, u_Color$factory_0());
  }
  bcc() {
    return this.ucb_1.wo(this, u_ColorMul$factory_0());
  }
  ecc() {
    return this.vcb_1.wo(this, u_GlobalAlpha$factory_0());
  }
  acc() {
    return this.wcb_1.wo(this, u_GlobalPixelScale$factory_0());
  }
  fcc() {
    return this.xcb_1.wo(this, u_Transform$factory_0());
  }
  gcc() {
    return this.ycb_1.wo(this, u_Gradientp0$factory_0());
  }
  hcc() {
    return this.zcb_1.wo(this, u_Gradientp1$factory_0());
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().pca_1 : program;
    this.lcb_1 = uniforms;
    this.mcb_1 = texture;
    this.ncb_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.lcb_1.toString() + ', texture=' + toString_0(this.mcb_1) + ', program=' + this.ncb_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.lcb_1);
    result = imul(result, 31) + (this.mcb_1 == null ? 0 : hashCode(this.mcb_1)) | 0;
    result = imul(result, 31) + this.ncb_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.lcb_1, tmp0_other_with_cast.lcb_1))
      return false;
    if (!equals(this.mcb_1, tmp0_other_with_cast.mcb_1))
      return false;
    if (!this.ncb_1.equals(tmp0_other_with_cast.ncb_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.zc9_1 = Attribute.i7a('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.aca_1 = Attribute.i7a('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.bca_1 = Varying.u7a('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.cca_1 = Varying.u7a('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.dca_1 = ProgramLayout.t73([DefaultShaders_getInstance().d77_1]);
    this.eca_1 = ProgramLayout.t73([DefaultShaders_getInstance().e77_1]);
    this.fca_1 = ProgramLayout.t73([this.aca_1]);
    this.gca_1 = ProgramLayout.t73([DefaultShaders_getInstance().d77_1, DefaultShaders_getInstance().e77_1]);
    this.hca_1 = ProgramLayout.t73([DefaultShaders_getInstance().d77_1, this.aca_1]);
    this.ica_1 = ProgramLayout.t73([DefaultShaders_getInstance().d77_1, this.aca_1, this.zc9_1]);
    this.jca_1 = 0;
    this.kca_1 = 1;
    this.lca_1 = 2;
    this.mca_1 = 3;
    this.nca_1 = 4;
    this.oca_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.j7b();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.o7b(this_0.r7b(), this_0.s7b(this_0.s7b(this_0.d79(), this_0.e79()), this_0.v7b([this_0.t7b(), this_0.u7b(0.0), this_0.u7b(1.0)])));
    this_0.o7b(this_0.k7b(), DefaultShaders_getInstance().d77_1);
    this_0.o7b(GpuShapeViewPrograms_getInstance().cca_1, GpuShapeViewPrograms_getInstance().aca_1);
    this_0.o7b(GpuShapeViewPrograms_getInstance().bca_1, GpuShapeViewPrograms_getInstance().zc9_1);
    var tmp0_vertex = VertexShader(this_0.w7b());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.j7b();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.p7d(GpuShapeViewPrograms_getInstance().ccc(), this_1.u7b(5));
    var body = this_1.f7c();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.o7b(body.r7b(), body.v7b([body.u7b(1.0), body.u7b(0.0), body.u7b(0.0), body.u7b(1.0)]));
    body.y7c();
    var stmIf = new If(cond, body.h7c());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.n7b_1.h(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.s7d(this_1.e7d(GpuShapeViewPrograms_getInstance().cca_1), GpuShapeViewPrograms_getInstance().bca_1);
    var body_0 = this_1.f7c();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.w7c();
    var stmIf_0 = new If(cond_0, body_0.h7c());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.n7b_1.h(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().ccc();
    this_1.v7c(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.n7d(this_1.u7b(1.0), this_1.g7d(this_1.n7d(this_1.s7b(GpuShapeViewPrograms_getInstance().bca_1, GpuShapeViewPrograms_getInstance().acc()), this_1.u7b(1.5)), this_1.s7b(GpuShapeViewPrograms_getInstance().bca_1, GpuShapeViewPrograms_getInstance().acc()), this_1.e7d(this_1.s7b(GpuShapeViewPrograms_getInstance().cca_1, GpuShapeViewPrograms_getInstance().acc()))));
    this_1.o7b(this_1.r7b(), this_1.s7b(this_1.s7b(this_1.s7b(this_1.r7b(), GpuShapeViewPrograms_getInstance().bcc()), GpuShapeViewPrograms_getInstance().ecc()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.w7b());
    tmp.pca_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.j2y();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.f73();
      this_2.x7p(_unary__edvuaz + 1 | 0);
      this_2.y7p(this_2.f73() + 1 | 0);
      var blockSize = this_2.j71_1;
      var index0 = imul(this_2.f73() - 1 | 0, blockSize);
      var index1 = imul(this_2.f73(), blockSize);
      var texBlockSize = this_2.g71_1.f79().e1();
      var texIndex0 = imul(this_2.f73() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.f73(), texBlockSize);
      if (this_2.f73() > 0) {
        arraycopy(this_2.l71_1, index0, this_2.l71_1, index1, blockSize);
      } else {
        arrayfill(this_2.l71_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.g71_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.m71_1.d7q(ShapeViewUB_getInstance().ccc(), 5);
      if (true && this_2.f73() >= 1) {
        var equals = arrayequal(this_2.l71_1, index0, this_2.l71_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.f73();
          this_2.x7p(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.qca_1 = new PaintShader(this_2, null);
  }
  ccc() {
    return ShapeViewUB_getInstance().ccc().z72_1;
  }
  dcc() {
    return ShapeViewUB_getInstance().dcc().z72_1;
  }
  bcc() {
    return ShapeViewUB_getInstance().bcc().z72_1;
  }
  ecc() {
    return ShapeViewUB_getInstance().ecc().z72_1;
  }
  acc() {
    return ShapeViewUB_getInstance().acc().z72_1;
  }
  fcc() {
    return ShapeViewUB_getInstance().fcc().z72_1;
  }
  gcc() {
    return ShapeViewUB_getInstance().gcc().z72_1;
  }
  hcc() {
    return ShapeViewUB_getInstance().hcc().z72_1;
  }
  icc(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$ExpressionBuilder = Companion_getInstance_24().k7w_1;
    return $this$ExpressionBuilder.c7d(_this__u8e3s4, $this$ExpressionBuilder.u7b(2.0));
  }
  rca(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.j2y();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.f73();
          this_0.x7p(_unary__edvuaz + 1 | 0);
          this_0.y7p(this_0.f73() + 1 | 0);
          var blockSize = this_0.j71_1;
          var index0 = imul(this_0.f73() - 1 | 0, blockSize);
          var index1 = imul(this_0.f73(), blockSize);
          var texBlockSize = this_0.g71_1.f79().e1();
          var texIndex0 = imul(this_0.f73() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.f73(), texBlockSize);
          if (this_0.f73() > 0) {
            arraycopy(this_0.l71_1, index0, this_0.l71_1, index1, blockSize);
          } else {
            arrayfill(this_0.l71_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.g71_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.m71_1;
          it.d7q($this$push.ccc(), 0);
          it.e7q($this$push.dcc(), _RGBA___get_premultiplied__impl__3bulqc(paint.u4k_1));
          it.d7q($this$push.ecc(), globalAlpha);
          if (true && this_0.f73() >= 1) {
            var equals = arrayequal(this_0.l71_1, index0, this_0.l71_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.f73();
              this_0.x7p(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_31().s2g_1.k2i(paint.k5n_1).k2i(stateTransform).e2i().s2h(1.0 / paint.j5n_1.r43_1, 1.0 / paint.j5n_1.s43_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.j2y();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.f73();
            this_1.x7p(_unary__edvuaz_1 + 1 | 0);
            this_1.y7p(this_1.f73() + 1 | 0);
            var blockSize_0 = this_1.j71_1;
            var index0_0 = imul(this_1.f73() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.f73(), blockSize_0);
            var texBlockSize_0 = this_1.g71_1.f79().e1();
            var texIndex0_0 = imul(this_1.f73() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.f73(), texBlockSize_0);
            if (this_1.f73() > 0) {
              arraycopy(this_1.l71_1, index0_0, this_1.l71_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.l71_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.g71_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.m71_1;
            it_0.d7q($this$push_0.ccc(), 1);
            it_0.h7q($this$push_0.fcc(), toMatrix4(mat));
            it_0.d7q($this$push_0.ecc(), globalAlpha);
            if (true && this_1.f73() >= 1) {
              var equals_0 = arrayequal(this_1.l71_1, index0_0, this_1.l71_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.f73();
                this_1.x7p(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.j5n_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.k43(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.v43_1;
            if (true) {
              gradientBitmap.e44();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.v5m(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.h43_1));
            }finally {
              result = true ? gradientBitmap.g44(rect) : 0;
            }
            var npaint = paint.w5m(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_31().s2g_1.k2i(paint.c5a_1).k2i(stateTransform));
            var mat_0 = paint.s59_1.t3_1 === 0 ? npaint.i5a_1 : npaint.c5a_1.e2i();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.j2y();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.f73();
              this_2.x7p(_unary__edvuaz_3 + 1 | 0);
              this_2.y7p(this_2.f73() + 1 | 0);
              var blockSize_1 = this_2.j71_1;
              var index0_1 = imul(this_2.f73() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.f73(), blockSize_1);
              var texBlockSize_1 = this_2.g71_1.f79().e1();
              var texIndex0_1 = imul(this_2.f73() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.f73(), texBlockSize_1);
              if (this_2.f73() > 0) {
                arraycopy(this_2.l71_1, index0_1, this_2.l71_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.l71_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.g71_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.m71_1;
              var tmp_0 = $this$push_1.ccc();
              var tmp0 = paint.s59_1.t3_1;
              it_1.d7q(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.h7q($this$push_1.fcc(), toMatrix4(mat_0));
              it_1.g7q($this$push_1.gcc(), new Vector4F(paint.t59_1, paint.u59_1, paint.v59_1, 1.0));
              it_1.g7q($this$push_1.hcc(), new Vector4F(paint.w59_1, paint.x59_1, paint.y59_1, 1.0));
              it_1.d7q($this$push_1.ecc(), globalAlpha);
              if (true && this_2.f73() >= 1) {
                var equals_1 = arrayequal(this_2.l71_1, index0_1, this_2.l71_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.f73();
                  this_2.x7p(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.ee('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.x9t($this.m9s_1.w9t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.n9s_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_14;
function Companion_getInstance_37() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().d22($this.t9t_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.a9u(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.q9w(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_15;
function Companion_getInstance_38() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.o9z_1.r9s_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.p9z_1.r9y_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_34()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_27().x2n_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.ul();
    var height = size.vl();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp1_elvis_lhs = base == null ? null : base.x2p();
      rwidth = tmp1_elvis_lhs == null ? views_0.r9y_1.x2p() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.y2p();
      rheight = tmp3_elvis_lhs == null ? views_0.r9y_1.y2p() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.sa4(views_0, defaultTransition, name, Size2D.u2l(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).ta4($this.o9z_1.r9s_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.q9z_1($this.p9z_1.r9y_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.o9z_1.z9s_1) {
    var tmp_3 = $this.r9z_1.j8x($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.ua4_1, $this.va4_1, $this.wa4_1, $this.xa4_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.a1r($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_36().zw()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().j6j();
    try {
      var tmp0_elvis_lhs = $this.aa5_1.h9t_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().z44_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.ya4_1, $this.za4_1, $this.aa5_1.g9t_1, null, $this.aa5_1.y9s_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().j6j();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.v8w(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().j6j();
    try {
      try {
        if (!($this.ba5_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().oi($this.ba5_1), $this.ca5_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.x8w(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_37().y9t_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.q31(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.r31(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().j6j();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.v8w('setIcon', tmp$ret$5);
    }
  }
  $this$loop.c8x($this$loop.v8o());
  if (Companion_getInstance_36().zw()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.cd();
  var this_3 = Views.ea5(tmp$ret$6.mn(gameWindow.q8w()).mn(new InjectorContext($this.aa5_1.t9s_1)).mn(SupervisorJob()).mn(CoroutineName.o1e('Views')), $this.aa5_1.o9t_1 ? AGPrint.d7o() : $this$loop.p8w(), $this.aa5_1.t9s_1, input, $this.aa5_1.s9s_1, stats, gameWindow, $this.aa5_1.a9t_1, $this.aa5_1.b9t_1, $this.aa5_1.c9t_1, VOID, $this.aa5_1.r9t_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.n2a($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_36().ex()) {
    Dyn__set_impl_2ozvx8(Companion_instance_13.g35(), 'views', this_3);
  }
  var views = this_3;
  $this.aa5_1.t9s_1.a6i(getKClass(GameWindow), gameWindow);
  $this.aa5_1.t9s_1.a6i(getKClass(Korge), $this.aa5_1);
  views.u9y_1 = $this$loop.e8x();
  views.fa5($this.aa5_1.p9t_1);
  views.ga5($this.aa5_1.q9t_1);
  views.l9y_1 = numberToInt($this.aa5_1.e9t_1.m2e_1);
  views.m9y_1 = numberToInt($this.aa5_1.e9t_1.n2e_1);
  views.p9y_1 = $this.aa5_1.f9t_1.y9w_1;
  views.o9y_1 = $this.aa5_1.f9t_1.x9w_1;
  views.q9y_1 = $this.aa5_1.f9t_1.z9w_1;
  views.f9z_1 = $this.aa5_1.s9t_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().j6j();
    try {
      KorgeReload_getInstance().f8d(gameWindow);
      var tmp_4 = KorgeRunner_instance.ha5(views, gameWindow, true, $this$loop.b8x(), Companion_instance_1.l1z(), $this.aa5_1.l9t_1, $this.aa5_1.u9s_1).k1a($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().j6j();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.v8w(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().j6j();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().j6j();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.v8w(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.aa5_1, views, $this.da5_1, gameWindow));
  if ($this.aa5_1.z9s_1) {
    var tmp_5 = gameWindow.j8x($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.h8x();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
  beforeStartingKorge(config);
  if (null == null) {
    $l$block: {
      // Inline function 'korlibs.io.worker.Companion.init' call
      get_workerImpl().b3e();
      if (get_workerImpl().c3e()) {
        if (get_DEBUG_WORKER()) {
          println('INSIDE WORKER');
        }
        break $l$block;
      } else {
        if (get_DEBUG_WORKER()) {
          println('**NOT** INSIDE WORKER');
        }
      }
      // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
      get_nativeSoundProvider();
      get_RegisteredImageFormats().k5j([config.p9s_1]);
      var iconPath = config.j9t_1;
      var imageFormats = config.p9s_1;
      var entry = config.n9t_1;
      var windowSize = config.d9t_1;
      if (!Companion_getInstance_36().ex()) {
        var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().oi('klogger.properties'), $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0_elvis_lhs = config.q9s_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        tmp_0 = $completion.cd().pd(CoroutineKey_getInstance());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_0;
      var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.m9t_1.m8y(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.g9t_1)) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = config.h9t_1;
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
        tmp_1 = Colors_getInstance().z44_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      realGameWindow.a8x(tmp_1);
      var tmp_3 = realGameWindow.k8x(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.w8n(Vector2D.q2f(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.j8i(button, true);
  input.i8i(p, false);
  input.i8i(p, true);
  $views.ia5();
  downPos._v = input.h8i();
  downTime._v = new DateTime(Companion_getInstance_6().i1y());
  input.t8h_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.j8i(button, false);
  input.i8i(p, false);
  $views.ia5();
  upPos._v = $views.i9x_1.h8i();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.i9x_1.i8i(p, false);
  $views.i9x_1.t8h_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.ia5();
  moveTime._v = new DateTime(Companion_getInstance_6().i1y());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.i9x_1.i8i(p, false);
  $views.ia5();
  moveTime._v = new DateTime(Companion_getInstance_6().i1y());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.w6p_1 = 0;
  mouseTouchEvent.z6p_1 = true;
  mouseTouchEvent.x6p_1 = Companion_getInstance_6().i1y();
  mouseTouchEvent.y6p_1 = false;
  mouseTouchEvent.h6q(type);
  mouseTouchEvent.m6q(button.n6t_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.i6q();
  $views.w6l(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.h6r_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.d8i_1[gamepad.i6r_1].q6r(gamepad);
  }
  input.k8i();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.ka5($fixedSizeStep, $views.ja5(), event.m6m_1, event.n6m_1);
    $views.i9x_1.s8h_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.i9x_1.s8h_1 = true;
      $views.i9x_1.t8h_1 = false;
      $views.ia5();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_37().y9t_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.q31(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.r31(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.t9x_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.la5($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_37().y9t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.w6n_1, e.x6n_1, e.h6o_1);
    var tmp_0;
    switch (e.u6n_1.t3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.y6n_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.y6n_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.y6n_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.y6n_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.y6n_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.w6l(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_37().y9t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.w6l(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_37().y9t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.w6l(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.w6l(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.w6l(e);
    get_nativeSoundProvider().g2z(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.w6l(e);
    get_nativeSoundProvider().g2z(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.w6l(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.w6l(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_37().y9t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.g8i(e);
    var ee = $input.l8h_1;
    var _iterator__ex2g4s = ee.e6q().a1();
    while (_iterator__ex2g4s.b1()) {
      var t = _iterator__ex2g4s.c1();
      t.j6p_1 = prepareViewsBase$getRealXY($views, t.o6p(), t.p6p(), e.y6p_1);
    }
    $views.w6l(ee);
    var tmp_0;
    if (ee.f6q() === 1) {
      var start = ee.p6q();
      var end = ee.q6q();
      var t_0 = first(ee.e6q());
      var p = t_0.j6p_1;
      var x = t_0.o6p();
      var y = t_0.p6p();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.v6n_1 = 0;
      this_1.y6n_1 = button;
      this_1.z6n_1 = end ? 0 : 1 << button.n6t_1;
      this_1.w6n_1 = numberToInt(x);
      this_1.x6n_1 = numberToInt(y);
      this_1.h6o_1 = false;
      this_1.i6o_1 = true;
      this_1.u6n_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.w6l(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_37().y9t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.w6l(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.w6l(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.na5($ag.k6u().d6u_1, $ag.k6u().e6u_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.w6l(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.n6m_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.e9y_1;
      var frameBuffer = this_0.k6u();
      this_0.j8e_1.j2y();
      this_0.c8e_1.o6u();
      var tmp_0;
      try {
        this_0.k8p(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.b1e(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.l8p();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.c8e_1.i6q();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_37().z9t_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_7().f8l_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().r8i_1.m2e_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().r8i_1.n2e_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.o2e(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.m2e_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.n2e_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.o2e(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_25().q2n_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_26().u2c() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().z44_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().y44_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).v9w(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.a9u(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.q9w(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.a9u(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.v10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.w10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.v10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, it, $completion) {
  var tmp = $this.sa5_1(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.za5_1.xa5_1.d23($this.aa6_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.ba6_1.va5_1.d23($this.ca6_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = $this.da6_1.wa5_1.d23($this.ea6_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$down$slambda_0($callback) {
  var i = new KeysEvents$down$slambda($callback);
  var l = function (it, $completion) {
    return i.fa6(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.d6m_1;
    tmp.ua5_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.ga6().f9x_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.d6m_1;
    tmp.ua5_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.ga6().f9x_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.d6m_1;
    tmp.ua5_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.ga6().f9x_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function onMouseDrag(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  return onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback).sl_1;
}
function onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  var dragging = {_v: false};
  var sx = {_v: 0.0};
  var sy = {_v: 0.0};
  var cx = {_v: 0.0};
  var cy = {_v: 0.0};
  var view = _this__u8e3s4;
  var mousePos = {_v: Vector2D.b2g()};
  var onDownCloseable = null;
  var onUpAnywhereCloseable = null;
  var onMoveAnywhereCloseable = null;
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  var $this$mouse = get_mouse(_this__u8e3s4);
  // Inline function 'korlibs.korge.input.MouseEvents.onDownCloseable' call
  var handler = onMouseDragInternal$slambda_2(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp = down$factory().get($this$mouse);
  onDownCloseable = tmp.p22(onMouseDragInternal$lambda($this$mouse, handler));
  // Inline function 'korlibs.korge.input.MouseEvents.onUpAnywhereCloseable' call
  var handler_0 = onMouseDragInternal$slambda_3(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_0 = upAnywhere$factory().get($this$mouse);
  onUpAnywhereCloseable = tmp_0.p22(onMouseDragInternal$lambda_0($this$mouse, handler_0));
  // Inline function 'korlibs.korge.input.MouseEvents.onMoveAnywhereCloseable' call
  var handler_1 = onMouseDragInternal$slambda_4(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_1 = moveAnywhere$factory().get($this$mouse);
  onMoveAnywhereCloseable = tmp_1.p22(onMouseDragInternal$lambda_1($this$mouse, handler_1));
  var tmp_2;
  if (onDownCloseable == null) {
    throwUninitializedPropertyAccessException('onDownCloseable');
  } else {
    tmp_2 = onDownCloseable;
  }
  var tmp_3 = tmp_2;
  var tmp_4;
  if (onUpAnywhereCloseable == null) {
    throwUninitializedPropertyAccessException('onUpAnywhereCloseable');
  } else {
    tmp_4 = onUpAnywhereCloseable;
  }
  var tmp_5 = tmp_4;
  var tmp_6;
  if (onMoveAnywhereCloseable == null) {
    throwUninitializedPropertyAccessException('onMoveAnywhereCloseable');
  } else {
    tmp_6 = onMoveAnywhereCloseable;
  }
  return to(_this__u8e3s4, new OnMouseDragCloseable(tmp_3, tmp_5, tmp_6));
}
var MouseDragState_START_instance;
var MouseDragState_DRAG_instance;
var MouseDragState_END_instance;
var MouseDragState_entriesInitialized;
function MouseDragState_initEntries() {
  if (MouseDragState_entriesInitialized)
    return Unit_instance;
  MouseDragState_entriesInitialized = true;
  MouseDragState_START_instance = new MouseDragState('START', 0);
  MouseDragState_DRAG_instance = new MouseDragState('DRAG', 1);
  MouseDragState_END_instance = new MouseDragState('END', 2);
}
function onMouseDragInternal$views(view) {
  return ensureNotNull(view.ea7()).fa7();
}
function onMouseDragInternal$updateMouse(mousePos, view) {
  var views = onMouseDragInternal$views(view);
  mousePos._v = views.ga7();
}
function onMouseDragInternal$handle(dragging, $info, mousePos, sx, sy, cx, cy, $callback, $timeProvider, view, it, state) {
  if (!state.equals(MouseDragState_START_getInstance()) && !dragging._v)
    return Unit_instance;
  onMouseDragInternal$updateMouse(mousePos, view);
  $info.ta6_1 = it;
  var px = mousePos._v.h2d_1;
  var py = mousePos._v.i2d_1;
  switch (state.t3_1) {
    case 0:
      dragging._v = true;
      sx._v = px;
      sy._v = py;
      $info.j2y();
      break;
    case 2:
      dragging._v = false;
      break;
    default:
      break;
  }
  cx._v = mousePos._v.h2d_1;
  cy._v = mousePos._v.i2d_1;
  var dx = cx._v - sx._v;
  var dy = cy._v - sy._v;
  $callback(onMouseDragInternal$views(view), $info.ya6(dx, dy, state.p6q(), state.q6q(), $timeProvider.i1y(), sx._v, sy._v, cx._v, cy._v));
}
function onMouseDragInternal$slambda_2($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.ra7(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = $this.sa7_1($this.ta7_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_2($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda($this, $handler) {
  return function (it) {
    var tmp = $this.ja9();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_2($handler, it));
    return Unit_instance;
  };
}
function onMouseDragInternal$slambda_3($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda_0($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.ra7(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = $this.ua9_1($this.va9_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_3($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda_0($this, $handler) {
  return function (it) {
    var tmp = $this.ja9();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_3($handler, it));
    return Unit_instance;
  };
}
function onMouseDragInternal$slambda_4($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda_1($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.ra7(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.gaa_1($this.haa_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_4($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda_1($handler, $it);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda_1($this, $handler) {
  return function (it) {
    var tmp = $this.ja9();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_4($handler, it));
    return Unit_instance;
  };
}
function MouseDragState_START_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_START_instance;
}
function MouseDragState_DRAG_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_DRAG_instance;
}
function MouseDragState_END_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_END_instance;
}
function down$factory() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.ba8_1;
  }, null);
}
function upAnywhere$factory() {
  return getPropertyCallableRef('upAnywhere', 1, KProperty1, function (receiver) {
    return receiver.ia8_1;
  }, null);
}
function moveAnywhere$factory() {
  return getPropertyCallableRef('moveAnywhere', 1, KProperty1, function (receiver) {
    return receiver.ka8_1;
  }, null);
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitSearch$delegate;
  var property = mouseHitSearch$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitSearch$delegate;
    var property = mouseHitSearch$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResult$delegate;
  var property = mouseHitResult$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResult$delegate;
    var property = mouseHitResult$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResultUsed$delegate;
  var property = mouseHitResultUsed$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResultUsed$delegate;
    var property = mouseHitResultUsed$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugHandlerOnce$delegate;
  var property = mouseDebugHandlerOnce$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugHandlerOnce$delegate;
    var property = mouseDebugHandlerOnce$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugLastFrameClicked$delegate;
  var property = mouseDebugLastFrameClicked$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugLastFrameClicked$delegate;
    var property = mouseDebugLastFrameClicked$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = mouse$delegate;
    var property = mouse$factory();
    var tmp0_elvis_lhs = this_0.v10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.w10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.v10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = cursor$delegate;
  var property = cursor$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = cursor$delegate;
    var property = cursor$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.i9x_1)) {
    set_mouseHitSearch(views.i9x_1, true);
    set_mouseHitResult(views.i9x_1, views.r9y_1.iaa(views.ga7()));
    var view = get_mouseHitResult(views.i9x_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.l2b();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.l9x_1.o8w(), newCursor)) {
      views.l9x_1.n8w(newCursor);
    }
  }
  return get_mouseHitResult(views.i9x_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return function (_this__u8e3s4, ctx) {
    var scale = ctx.x8o();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.m8n();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_16, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.jaa();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.kaa(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.e9y_1.a8f_1;
      var this_1 = this_0.j8f_1;
      if (!(this_1.e8f_1 === this_0)) {
        this_1.e8f_1 = this_0;
        this_1.o8g();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$1 = get_Bitmaps_white();
      var tmp0_tex = ctx.p8g(tmp$ret$1);
      var tmp1_x = bounds.r2d_1;
      var tmp2_y = bounds.s2d_1;
      var tmp3_width = bounds.t2d_1;
      var tmp4_height = bounds.u2d_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().a45_1, 0.3);
      var tmp6_m = mouseHit.laa();
      this_0.q8g(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.e9y_1;
      var tmp8_font = _this__u8e3s4.maa();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.ga7().h2d_1 + ',' + $views.ga7().i2d_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.z8e_1;
      var tmp12_blendMode = Companion_getInstance_14().r8d_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.i9x_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.jaa();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.e9y_1.a8f_1;
      var this_3 = this_2.j8f_1;
      if (!(this_3.e8f_1 === this_2)) {
        this_3.e8f_1 = this_2;
        this_3.o8g();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$4 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.p8g(tmp$ret$4);
      var tmp1_x_0 = bounds_0.r2d_1;
      var tmp2_y_0 = bounds_0.s2d_1;
      var tmp3_width_0 = bounds_0.t2d_1;
      var tmp4_height_0 = bounds_0.u2d_1;
      var tmp5_colorMul_0 = Companion_getInstance_2().k4j(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.laa();
      this_2.q8g(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.e9y_1;
        var tmp8_font_0 = _this__u8e3s4.maa();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.z8e_1;
        var tmp12_blendMode_0 = Companion_getInstance_14().r8d_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.l2b();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return function ($this$addUpdaterWithViews, views, dt) {
    this$0.naa(views, dt.xj_1);
    return Unit_instance;
  };
}
var Companion_instance_16;
function Companion_getInstance_39() {
  return Companion_instance_16;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.ea9_1;
  var tmp = $this;
  tmp.ea9_1 = lastEventNew == null ? $this.ea9_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.ea9_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return function (event) {
    var tmp;
    if (!this$0.va7_1.saa()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.d6m_1;
    tmp_0.wa7_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.da9_1 = event;
    this$0.ea9_1.m6o(event);
    this$0.fa9_1 = event.i6o_1;
    this$0.ca9_1 = true;
    var tmp_2;
    switch (event.u6n_1.t3_1) {
      case 2:
        this$0.ga9_1.m6o(event);
        this$0.xa8_1 = this$0.fa7().i9x_1.h8i();
        this$0.ua8_1 = PerformanceCounter_getInstance().k6j();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.ua8_1, this$0.va8_1);
        var tmp_3;
        if (this$0.xa8_1.r2o(this$0.wa8_1) < this$0.fa7().i9x_1.o8h_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.fa7().i9x_1.n8h_1) < 0) {
          var _unary__edvuaz = this$0.ba9_1;
          this$0.ba9_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.taa()) {
            this$0.ya7_1.r22(this$0);
            var tmp_5;
            if (this$0.ya7_1.v22() > 0) {
              event.o6o(this$0.va7_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.f6o_1) {
          set_mouseDebugLastFrameClicked(this$0.fa7(), true);
        }

        this$0.va8_1 = PerformanceCounter_getInstance().k6j();
        this$0.wa8_1 = this$0.fa7().i9x_1.h8i();
        var tmp_6;
        if (this$0.xa7_1.w22()) {
          var tmp_7;
          if (this$0.taa()) {
            this$0.xa7_1.r22(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.taa()) {
          this$0.na8_1.r22(this$0);
        } else {
          this$0.pa8_1.r22(this$0);
        }

        this$0.oa8_1.r22(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return function () {
    var tmp;
    if ($over) {
      this$0.ea8_1.r22(this$0);
      tmp = Unit_instance;
    } else {
      this$0.fa8_1.r22(this$0);
      this$0.ha8_1.r22(this$0);
      tmp = Unit_instance;
    }
    this$0.ia8_1.r22(this$0);
    return Unit_instance;
  };
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitSearch$factory() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitSearch$factory_0() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitResult$factory() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResult$factory_0() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResultUsed$factory() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseHitResultUsed$factory_0() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory_0() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory_0() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouse$factory() {
  return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
    return get_mouse(receiver);
  }, null);
}
function cursor$factory() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
function cursor$factory_0() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.d8e_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.pab($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.s17(), SceneCancellationException.eab($this));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.fa7().f9x_1.mn(new InjectorContext(this$0.qab())).mn(SupervisorJob(this$0.fa7().f9x_1.pd(Key_instance))).mn(CoroutineName.o1e('Scene:' + toString(this$0)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.sab(this$0.rab().e1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.kab_1.bae(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.qab().j6i(getKClass(Resources));
  };
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.s17();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.fae();
  }, null);
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var scene = $this.jah_1.pa4_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.jah_1.pa4_1) + ' . doFullReload=' + $this.kah_1.rah());
    var tmp;
    if ($this.kah_1.rah()) {
      tmp = $this.kah_1.sah(getKClassFromExpression(scene), scene.qab());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.jah_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.na4_1;
    var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.a6i(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.j6i(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.kah_1.z8c(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_40().tah_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.q31(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.r31(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.l6i(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.ma4_1.h9x_1.e6i(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.kah_1, scene));
    }
    var tmp_5 = this_0.vah(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.fa7().kaa(scene_0.fae());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.j6i($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.z8c($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.wah_1.fae();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.wah_1.sag(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.xah_1.fae();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.xah_1.tag(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  var tmp = $this.yah_1.vag($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.zah_1.wag($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.zah_1.xag();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.aai_1.yag($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = $this.bai_1.uag($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), $this).a6i(getKClass(Resources), new Resources($this.s17(), $this.ma4_1.oa5().z3b_1, $this.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.j6i(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_40().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.r31(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.ma4_1.h9x_1.e6i(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq.bind(VOID, $this, clazz, injects, time, transition), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.pa4_1;
  $this.pa4_1 = newScene;
  $this.oa4_1.nak(newScene.kab_1, transition);
  try {
    var tmp = newScene.s17();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.s17();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.oa4_1);
    var initial = Companion_getInstance_35().g10_1;
    var end = Companion_getInstance_35().j10_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween($this.oa4_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.oa4_1.kak_1 = Companion_getInstance_35().j10_1;
  }
  $this.oa4_1.oak();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.s17();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.s17();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_17;
function Companion_getInstance_40() {
  if (Companion_instance_17 === VOID)
    new Companion_2();
  return Companion_instance_17;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).g1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.pa4_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.j6i($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.f10_1, p1.f10_1, p2.f10_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.kak_1);
  }, function (value) {
    $b0.kak_1 = value.f10_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.mak_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.mas();
  var nextAlpha = next.mas();
  try {
    prev.las(1.0 - Ratio__toFloat_impl_1ftup5(ratio.f10_1));
    next.las(Ratio__toFloat_impl_1ftup5(ratio.f10_1));
    prev.qan(ctx);
    next.qan(ctx);
  }finally {
    prev.las(prevAlpha);
    next.las(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.wo(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.x7c($this$FUNC.l7x($this$FUNC.k7x(a, b), $this$FUNC.k7x($this$FUNC.l7x(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.o7b($this$IF_ELSE_BINARY_LOOKUP.r7b(), $this$IF_ELSE_BINARY_LOOKUP.z7b(Companion_getInstance_7().d8l_1[n], $this$IF_ELSE_BINARY_LOOKUP.x7b($$this$buildShader.k7b(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_0(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.l1z() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds(300));
      } else {
        tmp_0 = Companion_instance_1.l1z();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.aav(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.l1z() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21.bind(VOID, _this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback), $completion);
}
function _update($this, dt) {
  if ($this.tau_1) {
    $this.mau_1.kaq();
  }
  if ($this.wau_1) {
    return $this.fav();
  }
  $this.uau_1 = FastDuration__plus_impl_q1enab($this.uau_1, dt);
  var ratio = clamp(FastDuration__div_impl_rlslck($this.uau_1, $this.vau_1), 0.0, 1.0);
  $this.aav($this.uau_1);
  $this.qau_1($this.pau_1.zz(ratio));
  var tmp;
  var tmp_0 = $this.gav();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7($this.uau_1, $this.gav()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.hav();
  }
  if (ratio >= 1.0) {
    return $this.fav();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.d8z_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.wau_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.l1z()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.cd();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0.bind(VOID, time, block), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_18($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.j1c();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.iav_1;
  $this.jav_1._v = new TweenComponent(view, toList($this.kav_1), $this.lav_1, $this.mav_1, $this.nav_1, cancellable, $this.oav_1, $this.pav_1);
  var tmp$ret$0 = cancellable.v19();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.a1r($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_34());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function registerUISupportOnce($this) {
  if ($this.kan_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.ea7();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.kan_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_18;
function Companion_getInstance_41() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.ray(anchor);
  return _this__u8e3s4;
}
function clearBitmaps($this, onParentChanged) {
  if ($this.eb1_1.g1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.eb1_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.d1(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$0))) {
      var tmp0_safe_receiver = $this.jb1_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v8e_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.r8k(it, 'BaseGraphics');
      }
    }
  }
  $this.eb1_1.m3();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.e5g().x2p();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.e5g().y2p();
}
function _getLocalBoundsInternal($this, strokes) {
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.r2d_1 - $this.gar(), bounds.s2d_1 - $this.har(), bounds.t2d_1, bounds.u2d_1);
}
function _getLocalBoundsInternal$default($this, strokes, $super) {
  strokes = strokes === VOID ? $this.nb1_1 : strokes;
  return _getLocalBoundsInternal($this, strokes);
}
function boundsUnsafe($this, strokes) {
  if ($this.ib1_1) {
    $this.ib1_1 = false;
    $this.pb1_1 = $this.yb3(false);
    $this.ob1_1 = $this.yb3(true);
  }
  return strokes ? $this.ob1_1 : $this.pb1_1;
}
function updateGraphics($this) {
  var halfStroke = $this.gba_1 / 2;
  var radius = $this.ebd();
  $this.fbd(toShape2D(new Circle(Vector2D.q2f(radius, radius), radius)));
  // Inline function 'korlibs.korge.view.ShapeView.updatePath' call
  // Inline function 'korlibs.korge.view.Circle.updateGraphics.<anonymous>' call
  var $this$updatePath = $this.hba_1;
  $this$updatePath.m3();
  $this$updatePath.b3g(Vector2D.q2f(radius, radius), radius);
  $this$updatePath.e3m_1 = true;
  $this.dba_1 = $this.hba_1;
  $this.gbd();
}
function Circle$radius$delegate$lambda(this$0) {
  return function (it) {
    updateGraphics(this$0);
    return Unit_instance;
  };
}
function colorMul$factory($b0) {
  return getPropertyCallableRef('colorMul', 0, KMutableProperty0, function () {
    return new RGBA($b0.o4k());
  }, function (value) {
    return $b0.m4k(value.u4k_1);
  });
}
function radius$factory() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.ebd();
  }, function (receiver, value) {
    return receiver.jbd(value);
  });
}
function radius$factory_0() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.ebd();
  }, function (receiver, value) {
    return receiver.jbd(value);
  });
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.w5u();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.bae(_this__u8e3s4);
  return _this__u8e3s4;
}
function CpuGraphics_0(shape, antialiased) {
  antialiased = antialiased === VOID ? true : antialiased;
  // Inline function 'kotlin.apply' call
  var this_0 = CpuGraphics.bbm();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.CpuGraphics.<anonymous>' call
  this_0.vbl_1 = antialiased;
  this_0.cbm(shape);
  return this_0;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.dbo();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.waq(this_0);
  return this_0;
}
var Companion_instance_19;
function Companion_getInstance_42() {
  return Companion_instance_19;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().l6j())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.fa7().d9z_1;
  tmp.q22(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.fa7().e9y_1).c8o_1;
  tmp_0.q22(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.fa7().e9y_1.a8f_1.i8g_1;
  tmp_1.q22(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.fa7().e9y_1.a8f_1.j8g_1;
  tmp_2.q22(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.fa7();
  tmp_3.fbo(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.k8o_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.y8l() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.maa();
  var tmp1_colMul = $ctx.z8e_1;
  var tmp2_blendMode = Companion_getInstance_14().r8d_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.x8o();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().l6j();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.n1z_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7_0(elapsedTime, get_fastMilliseconds(4)) > 0) {
        $longWindow.mbo(elapsedTime);
        $shortWindow.mbo(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.s9x_1.m8n();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.kbo(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_36().xw() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.e9y_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.b8o_1;
    if (!(this_2.e8f_1 === this_1)) {
      this_2.e8f_1 = this_1;
      this_2.o8g();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.n8o_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_14().r8d_1;
          var doUpdate = !(this_1.m8o_1 === blending);
          var old = this_1.m8o_1;
          try {
            if (doUpdate) {
              this_1.b8o_1.o8g();
              this_1.m8o_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().o4a_1;
            var oldColor = this_1.e8o_1;
            this_1.e8o_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.s8o(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.s8o(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.e8o_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().y44_1 : Colors_getInstance().z44_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.e8o_1;
                this_1.e8o_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.e1() / $longWindow.gbo_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.e1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var p1 = convertRange(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.e1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.lbo(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.lbo(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange_0(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.s8o(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.e8o_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.b8o_1.o8g();
            }
            this_1.m8o_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.n8o_1;
  }, function (value) {
    $b0.n8o_1 = value;
    return Unit_instance;
  });
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.vbq_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.wbq_1 : tmp0_elvis_lhs);
}
function ensure($this) {
  if ($this.cbr_1.t3_1 === 2) {
    if (!($this.vbq_1 == null)) {
      var tmp1_safe_receiver = $this.vbq_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.hat();
      }
      $this.vbq_1 = null;
    }
    if ($this.wbq_1 == null) {
      var tmp = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.cbu(EmptyShape_instance, true);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
      var tmp$ret$2 = (new ShapeBuilder(null, null)).f4t();
      this_0.dbu(tmp$ret$2);
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_1.ebu($this.xbq_1);
      this_1.dbt_1 = $this.abr_1;
      this_1.fbt_1 = $this.zbq_1;
      this_1.dbu($this.bbr_1);
      tmp.wbq_1 = this_1;
    }
  } else {
    if (!($this.wbq_1 == null)) {
      var tmp2_safe_receiver = $this.wbq_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.hat();
      }
      $this.wbq_1 = null;
    }
    if ($this.vbq_1 == null) {
      var tmp_0 = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.bbm(false), $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      var tmp$ret$9 = (new ShapeBuilder(null, null)).f4t();
      this_2.cbm(tmp$ret$9);
      if (false) {
        this_2.kb4();
      }
      this_2.ib1_1 = true;
      this_2.was();
      this_2.kb4();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_2.vbl_1 = $this.xbq_1;
      this_2.ab1_1 = $this.abr_1;
      this_2.pb6_1 = $this.zbq_1;
      this_2.cbm($this.bbr_1);
      tmp_0.vbq_1 = this_2;
    }
    var tmp3_safe_receiver = $this.vbq_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.ib4($this.cbr_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.wbw($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.oi('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.mb4(tmp_0);
    $this.var(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.mb4(tmp$ret$0);
      $this.var(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.ubw_1.wbw(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.xb3_1.v11();
  if (!(source == null)) {
    $this.wb3_1 = true;
    $this.cb7(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.ibx();
  }, function (value) {
    return $b0.hbx(value);
  });
}
function updateGraphics_0($this) {
  // Inline function 'korlibs.korge.view.ShapeView.updatePath' call
  // Inline function 'korlibs.korge.view.RoundRect.updateGraphics.<anonymous>' call
  var $this$updatePath = $this.hba_1;
  $this$updatePath.m3();
  $this$updatePath.t3v(new RoundRectangle(new Rectangle(0.0, 0.0, $this.x2p(), $this.y2p()), $this.ebd()));
  $this$updatePath.e3m_1 = true;
  $this.dba_1 = $this.hba_1;
  $this.gbd();
}
function RoundRect$unscaledSize$delegate$lambda(this$0) {
  return function (it) {
    updateGraphics_0(this$0);
    return Unit_instance;
  };
}
function RoundRect$radius$delegate$lambda(this$0) {
  return function (it) {
    updateGraphics_0(this$0);
    return Unit_instance;
  };
}
function colorMul$factory_0($b0) {
  return getPropertyCallableRef('colorMul', 0, KMutableProperty0, function () {
    return new RGBA($b0.o4k());
  }, function (value) {
    return $b0.m4k(value.u4k_1);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.pan();
  }, function (receiver, value) {
    return receiver.ic0(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.pan();
  }, function (receiver, value) {
    return receiver.ic0(value);
  });
}
function radius$factory_1() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.ebd();
  }, function (receiver, value) {
    return receiver.jc0(value);
  });
}
function radius$factory_2() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.ebd();
  }, function (receiver, value) {
    return receiver.jc0(value);
  });
}
var Companion_instance_20;
function Companion_getInstance_43() {
  return Companion_instance_20;
}
function anchor$factory($b0) {
  return getPropertyCallableRef('anchor', 0, KMutableProperty0, function () {
    return $b0.vb6();
  }, function (value) {
    return $b0.ray(value);
  });
}
function antialiased$factory($b0) {
  return getPropertyCallableRef('antialiased', 0, KMutableProperty0, function () {
    return $b0.xbq_1;
  }, function (value) {
    return $b0.ebu(value);
  });
}
function autoScaling$factory($b0) {
  return getPropertyCallableRef('autoScaling', 0, KMutableProperty0, function () {
    return $b0.abr_1;
  }, function (value) {
    return $b0.jbu(value);
  });
}
function renderer$factory($b0) {
  return getPropertyCallableRef('renderer', 0, KMutableProperty0, function () {
    return $b0.cbr_1;
  }, function (value) {
    return $b0.kbu(value);
  });
}
function smoothing$factory($b0) {
  return getPropertyCallableRef('smoothing', 0, KMutableProperty0, function () {
    return $b0.zbq_1;
  }, function (value) {
    return $b0.ibu(value);
  });
}
function boundsIncludeStrokes$factory($b0) {
  return getPropertyCallableRef('boundsIncludeStrokes', 0, KMutableProperty0, function () {
    return $b0.hbu();
  }, function (value) {
    return $b0.yb6(value);
  });
}
function anchor$factory_0() {
  return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
    return receiver.vb6();
  }, function (receiver, value) {
    return receiver.ray(value);
  });
}
function anchor$factory_1() {
  return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
    return receiver.vb6();
  }, function (receiver, value) {
    return receiver.ray(value);
  });
}
var Companion_instance_21;
function Companion_getInstance_44() {
  return Companion_instance_21;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.q9y_1;
  }, function (value) {
    $b0.q9y_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.tc2();
  }, function (value) {
    return $b0.uc2(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.w5u();
  }, function (receiver, value) {
    return receiver.sc2(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.w5u();
  }, function (receiver, value) {
    return receiver.sc2(value);
  });
}
function unscaledSize$factory_1() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.pan();
  }, function (receiver, value) {
    return receiver.ic0(value);
  });
}
function unscaledSize$factory_2() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.pan();
  }, function (receiver, value) {
    return receiver.ic0(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.q4n()) {
    case 'msdf':
      return MsdfRender_getInstance().gau_1;
    case 'psdf':
      return MsdfRender_getInstance().jau_1;
    case 'sdf':
      return MsdfRender_getInstance().jau_1;
    default:
      return null;
  }
}
function *_generator_invoke__zhh2q8_19($this, $completion) {
  var tmp = $this.vc2_1.tc6(ensureNotNull(get_views($this.wc2_1)).c9y_1, $this.xc2_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_22;
function Companion_getInstance_45() {
  return Companion_instance_22;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.wc6();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.kc5_1 = count + 1 | 0;
}
function *_generator_forceLoadFontSource__wlrz09($this, currentVfs, sourceFile, $completion) {
  $this.xc6(sourceFile);
  $this.xc5_1 = true;
  if (!(sourceFile == null)) {
    var tmp = readFont(currentVfs.oi('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.yc6(tmp);
  }
  return Unit_instance;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.ul();
  var y = pos.vl();
  if ($this.cc6_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.uc5_1.k4v_1, $this.bc6_1.t2d_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.uc5_1.l4v_1, $this.bc6_1.u2d_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.vc5_1, x, y);
}
function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource) {
  var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.pc5_1;
  }, function (value) {
    return $b0.dc7(value);
  });
}
function fontSource$factory($b0) {
  return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
    return $b0.ac6_1;
  }, function (value) {
    return $b0.xc6(value);
  });
}
function fontSize$factory() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.p4n();
  }, function (receiver, value) {
    return receiver.ec7(value);
  });
}
function fontSize$factory_0() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.p4n();
  }, function (receiver, value) {
    return receiver.ec7(value);
  });
}
var Companion_instance_23;
function Companion_getInstance_46() {
  return Companion_instance_23;
}
function updateRenderColorTransform($this) {
  $this.ea1_1 = $this.ja1_1;
  $this.la1_1 = true;
  var parent = $this.l2b();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.da1_1.p4k($this.ca1_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.da1_1.q4k($this.ca1_1, parent.sas());
    } else {
      $this.da1_1.p4k($this.ca1_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.ea1_1 === $this.ja1_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.ga1_1 = $this.ia1_1;
  $this.ka1_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.ia0_1.equals(Companion_getInstance_14().i8d_1)) {
    var tmp1_safe_receiver = $this.l2b();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.tas();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_14().h8d_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.ia0_1;
  }
  tmp.fa1_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.ga1_1 === $this.ia1_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_24;
  return _this__u8e3s4.l6l(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.l2b();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.bas(Scale.b2l(sx, sy));
  return _this__u8e3s4;
}
function position(_this__u8e3s4, x, y) {
  return xy(_this__u8e3s4, Vector2D.q2f(x, y));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.i1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.h(_this__u8e3s4);
    }
    if (_this__u8e3s4.w9z_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.naq();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.d1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.l2b();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.l2b();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.l2b();
  }
  return count;
}
function addUpdater(_this__u8e3s4, updatable) {
  return addUpdater_0(_this__u8e3s4, true, VOID, updatable);
}
function xy(_this__u8e3s4, p) {
  _this__u8e3s4.d4y(p);
  return _this__u8e3s4;
}
function addUpdater_0(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_getInstance().yj_1 : firstTime;
  if (first)
    updatable(_this__u8e3s4, new Duration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.l6l(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return function (it) {
    $updatable($this_addUpdaterWithViews, it.nc7_1, new Duration(Duration__times_impl_sfuzvp(it.pc7(), $this_addUpdaterWithViews.qar())));
    return Unit_instance;
  };
}
function addUpdater$lambda($updatable, $this_addUpdater) {
  return function (it) {
    $updatable($this_addUpdater, new Duration(Duration__times_impl_sfuzvp(it.e8z(), $this_addUpdater.qar())));
    return Unit_instance;
  };
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.war();
  }, function (value) {
    return $b0.var(value);
  });
}
function bviewAll$factory() {
  return getPropertyCallableRef('bviewAll', 1, KProperty1, function (receiver) {
    return receiver.far();
  }, null);
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.n8o_1;
  }, function (value) {
    $b0.n8o_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_20($this, $completion) {
  var tmp = $this.qc7_1.fbx(ensureNotNull(get_views($this.rc7_1)), VOID, $this.sc7_1.ybw_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function get_logger() {
  _init_properties_ViewRenderToBitmap_kt__12ybtn();
  return logger;
}
var logger;
function renderToBitmap(_this__u8e3s4, views, region, scale, outPoint, includeBackground, $completion) {
  var tmp;
  if (views === VOID) {
    var tmp0_safe_receiver = _this__u8e3s4.ea7();
    tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fa7();
  } else {
    tmp = views;
  }
  views = tmp;
  region = region === VOID ? null : region;
  scale = scale === VOID ? 1.0 : scale;
  outPoint = outPoint === VOID ? null : outPoint;
  includeBackground = includeBackground === VOID ? false : includeBackground;
  if (views == null) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = get_logger();
    var level = Level_WARN_getInstance();
    var tmp_0;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.view.renderToBitmap.<anonymous>' call
      var tmp$ret$0 = 'View.renderToBitmap Views not specified';
      this_0.r31(level, tmp$ret$0);
      tmp_0 = Unit_instance;
    }
    return Companion_getInstance_5().z4b(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().d45_1));
  }
  var done = CompletableDeferred();
  views.r9y_1.kaq();
  views.d9z_1.j22(renderToBitmap$lambda(done, _this__u8e3s4, region, scale, outPoint, includeBackground, views));
  return done.k1a($completion);
}
function unsafeRenderToBitmapSync(_this__u8e3s4, ctx, region, scale, outPoint, useTexture, bgcolor) {
  region = region === VOID ? null : region;
  scale = scale === VOID ? 1.0 : scale;
  outPoint = outPoint === VOID ? null : outPoint;
  useTexture = useTexture === VOID ? true : useTexture;
  bgcolor = bgcolor === VOID ? Colors_getInstance().d45_1 : bgcolor;
  _init_properties_ViewRenderToBitmap_kt__12ybtn();
  var view = _this__u8e3s4;
  var bounds = _this__u8e3s4.jaa(VOID, true);
  // Inline function 'kotlin.also' call
  var tmp1_elvis_lhs = region == null ? null : region.t2d_1;
  var tmp = numberToInt(tmp1_elvis_lhs == null ? bounds.t2d_1 : tmp1_elvis_lhs);
  var tmp3_elvis_lhs = region == null ? null : region.u2d_1;
  var this_0 = Bitmap32.k43(tmp, numberToInt(tmp3_elvis_lhs == null ? bounds.u2d_1 : tmp3_elvis_lhs), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.unsafeRenderToBitmapSync.<anonymous>' call
  // Inline function 'korlibs.korge.render.RenderContext.renderToBitmap' call
  if (useTexture) {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTextureInternal' call
    var width = this_0.r43_1;
    var height = this_0.s43_1;
    ctx.o8g();
    // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
    var rb = ctx.i8p(width, height, false, true, 1);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToTextureInternal.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.k8p(rb);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTextureInternal.<anonymous>.<anonymous>' call
        ctx.d8p(Colors_getInstance().d45_1);
        // Inline function 'korlibs.korge.render.RenderContext.renderToBitmap.<anonymous>' call
        // Inline function 'korlibs.korge.view.unsafeRenderToBitmapSync.<anonymous>.<anonymous>' call
        if (!(bgcolor === Colors_getInstance().d45_1)) {
          ctx.d8p(bgcolor);
        }
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_1 = ctx.a8f_1;
        var this_2 = this_1.j8f_1;
        if (!(this_2.e8f_1 === this_1)) {
          this_2.e8f_1 = this_1;
          this_2.o8g();
        }
        var matrix = get_mutable(view.ras().o10());
        if (!(region == null)) {
          matrix.g3x(scale);
          matrix.i3x(-region.r2d_1, -region.s2d_1);
        }
        matrix.h3x(-bounds.r2d_1, -bounds.s2d_1);
        if (outPoint == null)
          null;
        else {
          outPoint.z2y(Vector2D.q2f(bounds.r2d_1, bounds.s2d_1));
        }
        // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
        var matrix_0 = matrix.c3x();
        var this_3 = this_1.j8f_1;
        this_3.o8g();
        var temp4 = this_3.p8e_1;
        var temp2d = this_3.q8e_1;
        this_3.q8e_1 = matrix_0;
        this_3.p8e_1 = toMatrix4(matrix_0);
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var this_4 = this_3.q71(ProjViewUB_getInstance());
          var _unary__edvuaz = this_4.f73();
          this_4.x7p(_unary__edvuaz + 1 | 0);
          this_4.y7p(this_4.f73() + 1 | 0);
          var blockSize = this_4.j71_1;
          var index0 = imul(this_4.f73() - 1 | 0, blockSize);
          var index1 = imul(this_4.f73(), blockSize);
          var texBlockSize = this_4.g71_1.f79().e1();
          var texIndex0 = imul(this_4.f73() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_4.f73(), texBlockSize);
          if (this_4.f73() > 0) {
            arraycopy(this_4.l71_1, index0, this_4.l71_1, index1, blockSize);
          } else {
            arrayfill(this_4.l71_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
          var $this$push = this_4.g71_1;
          this_4.m71_1.h7q($this$push.e79(), this_3.p8e_1);
          if (true && this_4.f73() >= 1) {
            var equals = arrayequal(this_4.l71_1, index0, this_4.l71_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_4.f73();
              this_4.x7p(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        var tmp_0;
        try {
          view.qan(ctx);
          tmp_0 = Unit_instance;
        }finally {
          this_3.o8g();
          this_3.p8e_1 = temp4;
          this_3.q8e_1 = temp2d;
          this_3.q71(ProjViewUB_getInstance()).z7p();
        }
        readColor(ctx.c8e_1, ctx.f8f_1, this_0);
      }finally {
        ctx.l8p();
      }
      // Inline function 'korlibs.korge.render.RenderContext.renderToBitmap.<anonymous>' call
      rb.f6z();
      rb.d6u_1;
      rb.e6u_1;
    }finally {
      ctx.j8p(rb);
    }
  } else {
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    var rb_0 = ctx.k6u();
    ctx.k8p(rb_0);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToBitmap.<anonymous>' call
      ctx.z8m();
      ctx.d8p(Colors_getInstance().d45_1);
      ctx.o8g();
      // Inline function 'korlibs.korge.view.unsafeRenderToBitmapSync.<anonymous>.<anonymous>' call
      if (!(bgcolor === Colors_getInstance().d45_1)) {
        ctx.d8p(bgcolor);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_5 = ctx.a8f_1;
      var this_6 = this_5.j8f_1;
      if (!(this_6.e8f_1 === this_5)) {
        this_6.e8f_1 = this_5;
        this_6.o8g();
      }
      var matrix_1 = get_mutable(view.ras().o10());
      if (!(region == null)) {
        matrix_1.g3x(scale);
        matrix_1.i3x(-region.r2d_1, -region.s2d_1);
      }
      matrix_1.h3x(-bounds.r2d_1, -bounds.s2d_1);
      if (outPoint == null)
        null;
      else {
        outPoint.z2y(Vector2D.q2f(bounds.r2d_1, bounds.s2d_1));
      }
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
      var matrix_2 = matrix_1.c3x();
      var this_7 = this_5.j8f_1;
      this_7.o8g();
      var temp4_0 = this_7.p8e_1;
      var temp2d_0 = this_7.q8e_1;
      this_7.q8e_1 = matrix_2;
      this_7.p8e_1 = toMatrix4(matrix_2);
      $l$block_0: {
        // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
        var this_8 = this_7.q71(ProjViewUB_getInstance());
        var _unary__edvuaz_1 = this_8.f73();
        this_8.x7p(_unary__edvuaz_1 + 1 | 0);
        this_8.y7p(this_8.f73() + 1 | 0);
        var blockSize_0 = this_8.j71_1;
        var index0_0 = imul(this_8.f73() - 1 | 0, blockSize_0);
        var index1_0 = imul(this_8.f73(), blockSize_0);
        var texBlockSize_0 = this_8.g71_1.f79().e1();
        var texIndex0_0 = imul(this_8.f73() - 1 | 0, texBlockSize_0);
        var texIndex1_0 = imul(this_8.f73(), texBlockSize_0);
        if (this_8.f73() > 0) {
          arraycopy(this_8.l71_1, index0_0, this_8.l71_1, index1_0, blockSize_0);
        } else {
          arrayfill(this_8.l71_1, 0, 0, blockSize_0);
        }
        // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
        var $this$push_0 = this_8.g71_1;
        this_8.m71_1.h7q($this$push_0.e79(), this_7.p8e_1);
        if (true && this_8.f73() >= 1) {
          var equals_0 = arrayequal(this_8.l71_1, index0_0, this_8.l71_1, index1_0, blockSize_0);
          if (equals_0) {
            var _unary__edvuaz_2 = this_8.f73();
            this_8.x7p(_unary__edvuaz_2 - 1 | 0);
            break $l$block_0;
          }
        }
      }
      var tmp_1;
      try {
        view.qan(ctx);
        tmp_1 = Unit_instance;
      }finally {
        this_7.o8g();
        this_7.p8e_1 = temp4_0;
        this_7.q8e_1 = temp2d_0;
        this_7.q71(ProjViewUB_getInstance()).z7p();
      }
      ctx.o8g();
      readColor(ctx.c8e_1, ctx.k6u(), this_0);
    }finally {
      ctx.l8p();
    }
  }
  return this_0;
}
function renderToBitmap$lambda($done, $this_renderToBitmap, $region, $scale, $outPoint, $includeBackground, $views) {
  return function (ctx) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      // Inline function 'korlibs.korge.view.renderToBitmap.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_0 = unsafeRenderToBitmapSync($this_renderToBitmap, ctx, $region, $scale, $outPoint, VOID, $includeBackground ? $views.g9y_1 : Colors_getInstance().d45_1);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.renderToBitmap.<anonymous>.<anonymous>.<anonymous>' call
      tmp = _Result___init__impl__xyqfz8(this_0);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp$ret$5 = tmp;
    completeWith($done, tmp$ret$5);
    return Unit_instance;
  };
}
var properties_initialized_ViewRenderToBitmap_kt_yjoejd;
function _init_properties_ViewRenderToBitmap_kt__12ybtn() {
  if (!properties_initialized_ViewRenderToBitmap_kt_yjoejd) {
    properties_initialized_ViewRenderToBitmap_kt_yjoejd = true;
    logger = Companion_getInstance_0().iz('RenderToBitmap');
  }
}
function *_generator_invoke__zhh2q8_21($this, $completion) {
  var tmp = $this.uc7_1.vc7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.a9y_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().g8d();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.n9y_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.d1(_unary__edvuaz).m1s($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.n9y_1.m3();
  cancel($this.f9x_1);
  $this.l9x_1.i8x();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.q9w(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.n9x_1 == null) ? ensureNotNull(this$0.n9x_1) : StandardPaths_instance.n36(this$0.wc7());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.j11();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.e9y_1.q8k();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.e9y_1.g8p();
    return Unit_instance;
  };
}
var Companion_instance_24;
function Companion_getInstance_47() {
  return Companion_instance_24;
}
var Companion_instance_25;
function Companion_getInstance_48() {
  return Companion_instance_25;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.w9x_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.d8z_1 = delta;
  _this__u8e3s4.w6l(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.x9x_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.oc7_1 = delta;
  _this__u8e3s4.w6l(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_25().t2n() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_26().u2c() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.z2y(reqVirtualSize_0);
  targetSize.z2y(scaleMode.w2n(virtualSize.u1(), actualSize_0));
  var ratioX = targetSize.u1().b2o_1 / reqVirtualSize_0.b2o_1;
  var ratioY = targetSize.u1().c2o_1 / reqVirtualSize_0.c2o_1;
  var actualVirtualWidth = toIntRound(actualSize_0.b2o_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.c2o_1 / ratioY);
  _this__u8e3s4.p8n(Companion_getInstance_31().s2g_1.u2h(ratioX, ratioY).c2i(toIntRound((actualVirtualWidth - reqVirtualSize_0.b2o_1 | 0) * anchor.r2c_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.c2o_1 | 0) * anchor.s2c_1)));
  _this__u8e3s4.l8n(_this__u8e3s4.q8n().e2i());
  _this__u8e3s4.r8n(_this__u8e3s4.q8n().f2i());
  _this__u8e3s4.n8n(_this__u8e3s4.m8n().f2i());
  var tl = _this__u8e3s4.w8n(Vector2D.d2g(0, 0));
  var br = _this__u8e3s4.w8n(Vector2D.q2f(actualSize_0.b2o_1, actualSize_0.c2o_1));
  _this__u8e3s4.t8n(Companion_getInstance_29().r2l(tl.h2d_1, tl.i2d_1, br.h2d_1, br.i2d_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.j6i(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006.bind(VOID), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.v8o();
  }, function (value) {
    return $b0.c8x(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.m8x();
  }, function (value) {
    return $b0.l8x(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.y8e_1;
  }, function (value) {
    $b0.y8e_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.z8e_1);
  }, function (value) {
    $b0.z8e_1 = value.u4k_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.a8v_1;
  }, function (value) {
    $b0.a8v_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.ja5();
  }, function (receiver, value) {
    return receiver.pa5(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.ja5();
  }, function (receiver, value) {
    return receiver.pa5(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.bc8();
  }, function (receiver, value) {
    return receiver.fa5(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.bc8();
  }, function (receiver, value) {
    return receiver.fa5(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.cc8());
  }, function (receiver, value) {
    return receiver.ga5(value.u4k_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.cc8());
  }, function (receiver, value) {
    return receiver.ga5(value.u4k_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.a9z_1;
  }, function (value) {
    $b0.a9z_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.c9z_1;
  }, function (value) {
    $b0.c9z_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.ic8();
  }, function (receiver, value) {
    return receiver.pc8(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.ic8();
  }, function (receiver, value) {
    return receiver.pc8(value);
  });
}
var renderToTextureResultPool$delegate;
var Companion_instance_26;
function Companion_getInstance_49() {
  if (Companion_instance_26 === VOID)
    new Companion_11();
  return Companion_instance_26;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.o2m(getBorder(_this__u8e3s4, toIntCeil(inp.t2d_1), toIntCeil(inp.u2d_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.tc8(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.q2x(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.d1b();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_27;
function Companion_getInstance_50() {
  if (Companion_instance_27 === VOID)
    new Companion_12();
  return Companion_instance_27;
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.oa1_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.hc9_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.x10_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.v10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.v10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.w10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.v10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.jaa(VOID, false);
  if (bounds.t2d_1 <= 0.0 || bounds.u2d_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_49();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.sc8();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.rc8(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.t2d_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.u2d_1 * tryFilterScale), 1);
  var realFilterScale = clamp_0(texWidthNoBorder / bounds.t2d_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.r2d_1 + edgeSize;
  var addy = -bounds.s2d_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.o8g();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.i8p(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.k8p(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.a8f_1;
      var this_1 = this_0.j8f_1;
      if (!(this_1.e8f_1 === this_0)) {
        this_1.e8f_1 = this_0;
        this_1.o8g();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.e75(0, 0, rb.d6u_1, rb.e6u_1);
        var temp = this_0.h8g_1;
        this_0.q8m();
        this_0.h8g_1 = scissor;
        try {
          if (true) {
            ctx.d8p(Colors_getInstance().d45_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.ras().y2h(addx, addy).t2h(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.a8f_1.j8f_1;
          this_2.o8g();
          var temp4 = this_2.p8e_1;
          var temp2d = this_2.q8e_1;
          this_2.q8e_1 = mat;
          this_2.p8e_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.q71(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.f73();
            this_3.x7p(_unary__edvuaz + 1 | 0);
            this_3.y7p(this_3.f73() + 1 | 0);
            var blockSize = this_3.j71_1;
            var index0 = imul(this_3.f73() - 1 | 0, blockSize);
            var index1 = imul(this_3.f73(), blockSize);
            var texBlockSize = this_3.g71_1.f79().e1();
            var texIndex0 = imul(this_3.f73() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.f73(), texBlockSize);
            if (this_3.f73() > 0) {
              arraycopy(this_3.l71_1, index0, this_3.l71_1, index1, blockSize);
            } else {
              arrayfill(this_3.l71_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.g71_1;
            this_3.m71_1.h7q($this$push.e79(), this_2.p8e_1);
            if (true && this_3.f73() >= 1) {
              var equals = arrayequal(this_3.l71_1, index0, this_3.l71_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.f73();
                this_3.x7p(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.zas(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.aat(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.o8g();
            this_2.p8e_1 = temp4;
            this_2.q8e_1 = temp2d;
            this_2.q71(ProjViewUB_getInstance()).z7p();
          }
          break $l$block_0;
        }finally {
          this_0.q8m();
          this_0.h8g_1 = temp;
        }
      }
    }finally {
      ctx.l8p();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).r3p(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.laa().c2i(-addx, -addy).v2h(1.0 / realFilterScale);
    filter.uc8(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.uas(), _this__u8e3s4.ia0_1, realFilterScale);
    ctx.o8g();
  }finally {
    ctx.j8p(rb);
  }
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.oa1_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ic9_1;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_49().rc8(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.x10_1 = transform;
    filterScale$delegate = this_0;
  }
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.gbt_1 ? $this.rbt_1 : $this.qbt_1;
  if (!valid) {
    if ($this.gbt_1)
      $this.rbt_1 = true;
    else
      $this.qbt_1 = true;
    var result = $this.obt_1.o5u($this.gbt_1);
    if ($this.gbt_1)
      $this.ubt_1 = result;
    else
      $this.tbt_1 = result;
    return result;
  }
  return $this.gbt_1 ? $this.ubt_1 : $this.tbt_1;
}
function invalidateShape($this) {
  $this.sbt_1 = 0;
  $this.pbt_1 = false;
  $this.qbt_1 = false;
  $this.rbt_1 = false;
  $this.kaq();
}
function requireShape($this) {
  if ($this.pbt_1)
    return Unit_instance;
  $this.pbt_1 = true;
  $this.hbt_1.m3();
  $this.hbt_1.tc9();
  $this.hbt_1.uc9(Companion_getInstance_15().x6v_1);
  $this.vbt_1 = true;
  renderShape($this, $this.obt_1);
  $this.hbt_1.m6u();
  $this.xbt_1 = $this.wbt_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.laa().g2h(get_immutable(ctx.d8e_1.q8n())) : $this.laa();
  $this.ybt_1 = mat.a2i(-$this.gar(), -$this.har());
  requireShape($this);
  $this.hbt_1.vc9(ctx, $this.ybt_1, $this.qas(), $this.lbt_1, $this.uas(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.b5v_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var v = _iterator__ex2g4s.c1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.u5v());
      } else {
        if (shape instanceof FillShape) {
          $this.sbt_1 = $this.sbt_1 + 1 | 0;
          if ($this.sbt_1 > $this.zbt_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.sbt_1 = $this.sbt_1 + 1 | 0;
            if ($this.sbt_1 > $this.zbt_1)
              return Unit_instance;
            renderStroke$default($this, shape.g5v_1, shape.d5v_1, shape.f5v_1, shape.i5v_1, shape.h5v_1);
          } else {
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.ee('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  var gpuShapeViewCommands = $this.hbt_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.uc9(Companion_getInstance_15().x6v_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.d1(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.wc9();
    var vector = points.t3g();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.e1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
        var x = vector.s2f(n_0, 0);
        var y = vector.s2f(n_0, 1);
        var dx = vector.s2f(n_0, 2);
        var dy = vector.s2f(n_0, 3);
        var len = vector.s2f(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.s2f(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.xc9(px, py, $this.nbt_1 ? len : 0.0, $this.nbt_1 ? maxLen : $this.bbu_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.yc9();
    var info = GpuShapeViewPrograms_getInstance().rca(stateTransform, paint, globalAlpha, strokeInfo.c3g_1);
    var tmp0_drawType = Companion_getInstance_17().c74_1;
    var tmp1_blendMode = Companion_getInstance_14().h8d_1;
    gpuShapeViewCommands.sca(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
  }
}
function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().l6v_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_19().j6v_1 : stencilRef;
  return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
}
function getPointsForPath($this, points, type) {
  if (points.e1() < 3)
    return null;
  var vertexStart = $this.hbt_1.wc9();
  var bb = BoundsBuilder__plus_impl_cz7f7x_0(Companion_getInstance_30().h2e(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.q2f(xMid, yMid);
  var isStrip = type === Companion_getInstance_17().c74_1;
  var antialiased = $this.nbt_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.hbt_1.xc9(xMid, yMid, 0.0, $this.bbu_1);
  }
  var inductionVariable = 0;
  var last = points.e1() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.d1(n % points.e1() | 0);
      var x = p.ul();
      var y = p.vl();
      var len = isStripAndAntialiased ? Companion_getInstance_28().m2o(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.bbu_1;
      if (isStrip) {
        $this.hbt_1.xc9(xMid, yMid, 0.0, maxLen);
      }
      $this.hbt_1.xc9(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.hbt_1.yc9();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.e1() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = getPoints2List(path);
  var destination = ArrayList.i1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().rca(shape.s5u_1, shape.r5u_1, shape.t5u_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.abu_1;
  var drawAntialiasingBorder = $this.abu_1 ? true : $this.nbt_1;
  var shapeIsConvex = shape.z5u();
  var isSimpleDraw = shapeIsConvex && shape.q5u_1 == null && !$this.abu_1;
  var pathDataList = getPointsForPathList($this, shape.p5u_1, isSimpleDraw ? Companion_getInstance_17().c74_1 : Companion_getInstance_17().d74_1);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
  var bb = Companion_getInstance_30().h2e();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.d1(_unary__edvuaz);
    bb = plus(bb, it.tca_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.o2m(MarginInt.o2g(2)));
  var clipDataStart = $this.hbt_1.wc9();
  var tmp1_safe_receiver = shape.q5u_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_17().d74_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.hbt_1.yc9();
  var tmp3_elvis_lhs = clipData == null ? null : clipData.tca_1;
  var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_15().x6v_1 : tmp3_elvis_lhs;
  if (!isSimpleDraw || $this.vbt_1) {
    $this.vbt_1 = true;
    $this.hbt_1.uc9(isSimpleDraw ? Companion_getInstance_15().x6v_1 : !clipBounds.equals(Companion_getInstance_15().x6v_1) ? Companion_getInstance_15().j75(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.vbt_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.e1()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.d1(_unary__edvuaz_0);
      var tmp0_$this = $this.hbt_1;
      var tmp1_drawType = Companion_getInstance_17().c74_1;
      var tmp2_startIndex = pathData.vca_1;
      var tmp3_endIndex = pathData.wca_1;
      var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp5_blendMode = $this.tas();
      tmp0_$this.sca(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.p5u_1.c3m_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_20().d76_1;
  if (drawFill) {
    switch (winding.t3_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_20().d76_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().l6v_1, true), Companion_getInstance_20().c76_1), Companion_getInstance_21().o76_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().j6v_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.d1(_unary__edvuaz_1);
          writeStencil($this, pathData_0.vca_1, pathData_0.wca_1, stencilOpFunc, stencilRef, Companion_getInstance_22().z6v_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_20().j76_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().l6v_1, true), Companion_getInstance_20().c76_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().j6v_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.d1(_unary__edvuaz_2);
          writeStencil($this, pathData_1.vca_1, pathData_1.wca_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_21().n76_1, Companion_getInstance_21().l76_1), stencilRef_0, Companion_getInstance_22().z6v_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().l6v_1, true), Companion_getInstance_20().j76_1), Companion_getInstance_21().o76_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_19().j6v_1, 0), 255), Companion_getInstance_22().a6w_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().l6v_1, true), Companion_getInstance_20().c76_1), Companion_getInstance_21().o76_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().j6v_1, 2), Companion_getInstance_22().c6w_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.q5u_1 == null) {
    renderStroke($this, shape.s5u_1, shape.p5u_1, shape.r5u_1, shape.t5u_1, new StrokeInfo(1.6 / $this.wbt_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_18().l6v_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().l6v_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_19().j6v_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.hbt_1.k7k(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp0_$this = $this.hbt_1;
  var tmp1_drawType = Companion_getInstance_17().d74_1;
  var tmp2_paintShader = GpuShapeViewPrograms_getInstance().qca_1;
  var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp4_blendMode = Companion_getInstance_14().j8d_1;
  tmp0_$this.xca(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.hbt_1.wc9();
  var x0 = pathBounds.y2d();
  var y0 = pathBounds.a2e();
  var x1 = pathBounds.z2d();
  var y1 = pathBounds.b2e();
  $this.hbt_1.xc9(x0, y0, 0.0, $this.bbu_1);
  $this.hbt_1.xc9(x1, y0, 0.0, $this.bbu_1);
  $this.hbt_1.xc9(x1, y1, 0.0, $this.bbu_1);
  $this.hbt_1.xc9(x0, y1, 0.0, $this.bbu_1);
  var vend = $this.hbt_1.yc9();
  var tmp0_$this = $this.hbt_1;
  var tmp1_drawType = Companion_getInstance_17().d74_1;
  var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().l6v_1, true), stencilCompare);
  var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_19().j6v_1, stencilReferenceValue), 0);
  var tmp5_blendMode = $this.tas();
  tmp0_$this.sca(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return function ($this$IF_ELSE_LIST, it) {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.o7b($this$IF_ELSE_LIST.r7b(), GpuShapeViewPrograms_getInstance().dcc());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.o7b($this$IF_ELSE_LIST.r7b(), $this$IF_ELSE_LIST.z7b($$this$FragmentShaderDefault.y7b(), $this$IF_ELSE_LIST.f7d($this$IF_ELSE_LIST.h7d([$this$IF_ELSE_LIST.x7b($this$IF_ELSE_LIST.s7b(GpuShapeViewPrograms_getInstance().fcc(), $this$IF_ELSE_LIST.v7b([$$this$FragmentShaderDefault.k7b(), $this$IF_ELSE_LIST.u7b(0.0), $this$IF_ELSE_LIST.u7b(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.o7b($this$IF_ELSE_LIST.r7b(), $this$IF_ELSE_LIST.z7b($$this$FragmentShaderDefault.y7b(), $this$IF_ELSE_LIST.x7b($this$IF_ELSE_LIST.s7b(GpuShapeViewPrograms_getInstance().fcc(), $this$IF_ELSE_LIST.v7b([$this$IF_ELSE_LIST.i7d($$this$FragmentShaderDefault.k7b()), $this$IF_ELSE_LIST.j7d($$this$FragmentShaderDefault.k7b()), $this$IF_ELSE_LIST.u7b(0.0), $this$IF_ELSE_LIST.u7b(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.z7c(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.o7b($this$IF_ELSE_LIST.x7b(rpoint, 'xy'), $this$IF_ELSE_LIST.x7b($this$IF_ELSE_LIST.s7b(GpuShapeViewPrograms_getInstance().fcc(), $this$IF_ELSE_LIST.v7b([$this$IF_ELSE_LIST.i7d($$this$FragmentShaderDefault.k7b()), $this$IF_ELSE_LIST.j7d($$this$FragmentShaderDefault.k7b()), $this$IF_ELSE_LIST.u7b(0.0), $this$IF_ELSE_LIST.u7b(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.i7d(rpoint);
        var y = $this$IF_ELSE_LIST.j7d(rpoint);
        var x0 = $this$IF_ELSE_LIST.i7d(GpuShapeViewPrograms_getInstance().gcc());
        var y0 = $this$IF_ELSE_LIST.j7d(GpuShapeViewPrograms_getInstance().gcc());
        var r0 = $this$IF_ELSE_LIST.k7d(GpuShapeViewPrograms_getInstance().gcc());
        var x1 = $this$IF_ELSE_LIST.i7d(GpuShapeViewPrograms_getInstance().hcc());
        var y1 = $this$IF_ELSE_LIST.j7d(GpuShapeViewPrograms_getInstance().hcc());
        var r1 = $this$IF_ELSE_LIST.k7d(GpuShapeViewPrograms_getInstance().hcc());
        var ratio = $this$IF_ELSE_LIST.i7d($$this$FragmentShaderDefault.c7c());
        var r0r1_2 = $this$IF_ELSE_LIST.j7d($$this$FragmentShaderDefault.c7c());
        var r0pow2 = $this$IF_ELSE_LIST.k7d($$this$FragmentShaderDefault.c7c());
        var r1pow2 = $this$IF_ELSE_LIST.l7d($$this$FragmentShaderDefault.c7c());
        var y0_y1 = $this$IF_ELSE_LIST.i7d($$this$FragmentShaderDefault.t7d());
        var x0_x1 = $this$IF_ELSE_LIST.j7d($$this$FragmentShaderDefault.t7d());
        var r0_r1 = $this$IF_ELSE_LIST.k7d($$this$FragmentShaderDefault.t7d());
        var radial_scale = $this$IF_ELSE_LIST.l7d($$this$FragmentShaderDefault.t7d());
        $this$IF_ELSE_LIST.o7b(r0r1_2, $this$IF_ELSE_LIST.s7b($this$IF_ELSE_LIST.s7b($this$IF_ELSE_LIST.u7b(2.0), r0), r1));
        $this$IF_ELSE_LIST.o7b(r0pow2, GpuShapeViewPrograms_getInstance().icc(r0));
        $this$IF_ELSE_LIST.o7b(r1pow2, GpuShapeViewPrograms_getInstance().icc(r1));
        $this$IF_ELSE_LIST.o7b(x0_x1, $this$IF_ELSE_LIST.n7d(x0, x1));
        $this$IF_ELSE_LIST.o7b(y0_y1, $this$IF_ELSE_LIST.n7d(y0, y1));
        $this$IF_ELSE_LIST.o7b(r0_r1, $this$IF_ELSE_LIST.n7d(r0, r1));
        $this$IF_ELSE_LIST.o7b(radial_scale, $this$IF_ELSE_LIST.d7c($this$IF_ELSE_LIST.u7b(1.0), $this$IF_ELSE_LIST.n7d($this$IF_ELSE_LIST.n7d(GpuShapeViewPrograms_getInstance().icc($this$IF_ELSE_LIST.n7d(r0, r1)), GpuShapeViewPrograms_getInstance().icc($this$IF_ELSE_LIST.n7d(x0, x1))), GpuShapeViewPrograms_getInstance().icc($this$IF_ELSE_LIST.n7d(y0, y1)))));
        $this$IF_ELSE_LIST.o7b(ratio, $this$IF_ELSE_LIST.n7d($this$IF_ELSE_LIST.u7b(1.0), $this$IF_ELSE_LIST.s7b($this$IF_ELSE_LIST.n7d($this$IF_ELSE_LIST.o7d($this$IF_ELSE_LIST.o7d($this$IF_ELSE_LIST.s7b($this$IF_ELSE_LIST.m7d(r1), r0_r1), $this$IF_ELSE_LIST.s7b(x0_x1, $this$IF_ELSE_LIST.n7d(x1, x))), $this$IF_ELSE_LIST.s7b(y0_y1, $this$IF_ELSE_LIST.n7d(y1, y))), $this$IF_ELSE_LIST.d7d($this$IF_ELSE_LIST.n7d($this$IF_ELSE_LIST.o7d($this$IF_ELSE_LIST.n7d($this$IF_ELSE_LIST.s7b(r1pow2, $this$IF_ELSE_LIST.o7d(GpuShapeViewPrograms_getInstance().icc($this$IF_ELSE_LIST.n7d(x0, x)), GpuShapeViewPrograms_getInstance().icc($this$IF_ELSE_LIST.n7d(y0, y)))), $this$IF_ELSE_LIST.s7b(r0r1_2, $this$IF_ELSE_LIST.o7d($this$IF_ELSE_LIST.s7b($this$IF_ELSE_LIST.n7d(x0, x), $this$IF_ELSE_LIST.n7d(x1, x)), $this$IF_ELSE_LIST.s7b($this$IF_ELSE_LIST.n7d(y0, y), $this$IF_ELSE_LIST.n7d(y1, y))))), $this$IF_ELSE_LIST.s7b(r0pow2, $this$IF_ELSE_LIST.o7d(GpuShapeViewPrograms_getInstance().icc($this$IF_ELSE_LIST.n7d(x1, x)), GpuShapeViewPrograms_getInstance().icc($this$IF_ELSE_LIST.n7d(y1, y))))), GpuShapeViewPrograms_getInstance().icc($this$IF_ELSE_LIST.n7d($this$IF_ELSE_LIST.o7d($this$IF_ELSE_LIST.o7d($this$IF_ELSE_LIST.n7d($this$IF_ELSE_LIST.n7d($this$IF_ELSE_LIST.s7b(x1, y0), $this$IF_ELSE_LIST.s7b(x, y0)), $this$IF_ELSE_LIST.s7b(x0, y1)), $this$IF_ELSE_LIST.s7b(x, y1)), $this$IF_ELSE_LIST.s7b(x0, y)), $this$IF_ELSE_LIST.s7b(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.o7b($this$IF_ELSE_LIST.r7b(), $this$IF_ELSE_LIST.z7b($$this$FragmentShaderDefault.y7b(), $this$IF_ELSE_LIST.h7d([ratio, $this$IF_ELSE_LIST.u7b(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.z7c(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.o7b($this$IF_ELSE_LIST.x7b(rpoint_0, 'xy'), $this$IF_ELSE_LIST.x7b($this$IF_ELSE_LIST.s7b(GpuShapeViewPrograms_getInstance().fcc(), $this$IF_ELSE_LIST.v7b([$this$IF_ELSE_LIST.i7d($$this$FragmentShaderDefault.k7b()), $this$IF_ELSE_LIST.j7d($$this$FragmentShaderDefault.k7b()), $this$IF_ELSE_LIST.u7b(0.0), $this$IF_ELSE_LIST.u7b(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.i7d(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.j7d(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.i7d($$this$FragmentShaderDefault.c7c());
        var angle = $this$IF_ELSE_LIST.j7d($$this$FragmentShaderDefault.c7c());
        var x0_0 = $this$IF_ELSE_LIST.i7d(GpuShapeViewPrograms_getInstance().gcc());
        var y0_0 = $this$IF_ELSE_LIST.j7d(GpuShapeViewPrograms_getInstance().gcc());
        var PI2 = $this$IF_ELSE_LIST.u7b(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.o7b(angle, $this$IF_ELSE_LIST.b7d($this$IF_ELSE_LIST.n7d(y_0, y0_0), $this$IF_ELSE_LIST.n7d(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.q7d(angle, $this$IF_ELSE_LIST.u7b(0.0));
        var body = $this$IF_ELSE_LIST.f7c();
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

        body.o7b(angle, body.o7d(angle, PI2));
        var stmIf = new If(cond, body.h7c());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.n7b_1.h(stmIf);
        $this$IF_ELSE_LIST.o7b(ratio_0, $this$IF_ELSE_LIST.d7c(angle, PI2));
        $this$IF_ELSE_LIST.o7b($this$IF_ELSE_LIST.r7b(), $this$IF_ELSE_LIST.z7b($$this$FragmentShaderDefault.y7b(), $this$IF_ELSE_LIST.f7d($this$IF_ELSE_LIST.h7d([ratio_0, $this$IF_ELSE_LIST.u7b(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function u_ProgramType$factory() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.ccc();
  }, null);
}
function u_Color$factory() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.dcc();
  }, null);
}
function u_ColorMul$factory() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.bcc();
  }, null);
}
function u_GlobalAlpha$factory() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.ecc();
  }, null);
}
function u_GlobalPixelScale$factory() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.acc();
  }, null);
}
function u_Transform$factory() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.fcc();
  }, null);
}
function u_Gradientp0$factory() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.gcc();
  }, null);
}
function u_Gradientp1$factory() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.hcc();
  }, null);
}
function u_ProgramType$factory_0() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.ccc();
  }, null);
}
function u_Color$factory_0() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.dcc();
  }, null);
}
function u_ColorMul$factory_0() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.bcc();
  }, null);
}
function u_GlobalAlpha$factory_0() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.ecc();
  }, null);
}
function u_GlobalPixelScale$factory_0() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.acc();
  }, null);
}
function u_Transform$factory_0() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.fcc();
  }, null);
}
function u_Gradientp0$factory_0() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.gcc();
  }, null);
}
function u_Gradientp1$factory_0() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.hcc();
  }, null);
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$down$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(MouseDragInfo, 'MouseDragInfo');
initMetadataForClass(OnMouseDragCloseable, 'OnMouseDragCloseable', VOID, VOID, [AutoCloseable]);
initMetadataForClass(MouseDragState, 'MouseDragState');
initMetadataForLambda(onMouseDragInternal$slambda, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(onMouseDragInternal$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(onMouseDragInternal$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_2);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.gb7);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.cae);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.hb7);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.qay);
initMetadataForClass(UIView, 'UIView', UIView.lan);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.man);
protoOf(Transition$1).vat = start;
protoOf(Transition$1).wat = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForClass(UIObservable, 'UIObservable');
initMetadataForCompanion(Companion_3);
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.jbx);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForClass(ShapeView, 'ShapeView', ShapeView.ibd);
initMetadataForClass(Circle_0, 'Circle', Circle_0.hbd);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.hbi);
initMetadataForClass(ClipContainer, 'ClipContainer', ClipContainer.vbf);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [MutableIterable, Collection, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.bbm);
initMetadataForClass(DummyView, 'DummyView', DummyView.dbo);
initMetadataForCompanion(Companion_4);
initMetadataForClass(SContainer, 'SContainer', SContainer.rag);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.fbu);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).fbx = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForClass(RoundRect, 'RoundRect');
initMetadataForCompanion(Companion_5);
initMetadataForCompanion(Companion_6);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForCompanion(Companion_7);
initMetadataForLambda(Text$_renderInternal$slambda, VOID, VOID, [0]);
initMetadataForClass(Text, 'Text', VOID, VOID, VOID, [2]);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_8);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).fbx = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_10);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForCompanion(Companion_11);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).sc8 = get_recommendedFilterScale;
protoOf(IdentityFilter).tc8 = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.cbu);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_16 = new Companion_1();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_19 = new Companion_4();
Companion_instance_20 = new Companion_5();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_25 = new Companion_10();
//endregion
//region block: exports
export {
  GraphicsRenderer_GPU_getInstance as GraphicsRenderer_GPU_getInstance3l98mt1a5bjlb,
  renderToBitmap as renderToBitmap3nglzwiwh97g5,
  views as views116j359zi8nvf,
  Korge_0 as Korge3fi4cwjkh8up9,
  Companion_getInstance_40 as Companion_getInstance2b4rje0hs8ulh,
  Companion_instance_22 as Companion_instance1qzytx5vkv693,
  get_keys as get_keysmipauarvwdlb,
  get_mouse as get_mouse1jstwhfaumelj,
  onMouseDrag as onMouseDrag20om3ch85u2pf,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  Transition as Transition2j190usvy2fcc,
  withEasing as withEasingtnol1eyyo9sf,
  Circle_0 as Circlepba9jsmewo4k,
  ClipContainer as ClipContainernpx31s3mxtjx,
  Container as Container7486fjmip554,
  CpuGraphics_0 as CpuGraphics2sfhutqezpf4d,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  Image as Image1b2d7ghyim7p5,
  RoundRect as RoundRect16qm0yoxjizxs,
  SolidRect as SolidRect131p7hyzlx7j8,
  Stage as Stage1ggtrzujnnkl0,
  Text as Text3kimhvgfxflj3,
  addTo as addTo25e29vq105prw,
  addUpdater as addUpdater1la23qj9g2d42,
  anchor as anchor3c5itxst996yy,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  position as positionu6441b7hkb4l,
  scale as scalea9fc0mbrr7ub,
};
//endregion
